{
  "currencyHint": {
    "disclaimer": "Ενδεικτική μετατροπή με τρέχουσα ισοτιμία — μόνο για κατανόηση του ποσού, δεν αφορά πραγματική συναλλαγή μέσω της Χειραψίας."
  },
  "common": {
    "tapToReportBug": "Πατήστε εδώ για bug report",
    "and": "και",
    "back": "‹ Πίσω",
    "save": "Αποθήκευση",
    "cancel": "Ακύρωση",
    "send": "Αποστολή",
    "confirm": "Επιβεβαίωση",
    "close": "Κλείσιμο",
    "done": "Τέλος",
    "loading": "Φόρτωση...",
    "error": "Σφάλμα",
    "success": "Επιτυχία",
    "yes": "Ναι",
    "no": "Όχι",
    "retry": "Δοκίμασε ξανά",
    "or": "ή",
    "delete": "Διαγραφή",
    "edit": "Επεξεργασία",
    "share": "Κοινοποίηση",
    "copy": "Αντιγραφή",
    "copied": "Αντιγράφηκε!",
    "search": "Αναζήτηση",
    "filter": "Φίλτρο",
    "all": "Όλα",
    "none": "Κανένα",
    "optional": "προαιρετικό",
    "unknown": "Άγνωστος",
    "user": "Χρήστης",
    "someone": "Κάποιος",
    "userNumberFallback": "Χρήστης #{{number}}",
    "ok": "Εντάξει",
    "info": "Πληροφορία",
    "active": "Ενεργό",
    "inactive": "Ανενεργό",
    "today": "Σήμερα",
    "expired": "Έληξε",
    "days": "μέρες",
    "day": "μέρα",
    "next": "Επόμενο →",
    "preview": "Επισκόπηση →",
    "continue": "Συνέχεια",
    "start": "Ξεκινάμε ✓",
    "skip": "Παράλειψη",
    "understood": "Κατάλαβα",
    "changedMind": "Ακύρωση ενέργειας",
    "selectReason": "Επέλεξε λόγο (τουλάχιστον έναν):",
    "uploading": "Μεταφόρτωση…",
    "saving": "Αποθήκευση…",
    "retake": "Ξανά",
    "new": "Νέα",
    "view": "Προβολή →",
    "change": "Αλλαγή",
    "help": "Βοήθεια",
    "reject": "Απόρριψη",
    "accept": "Αποδοχή",
    "decline": "Απόρριψη",
    "remove": "Αφαίρεση",
    "create": "Δημιουργία",
    "public": "Δημόσιο",
    "hidden": "Κρυφό",
    "uploaded": "✓ Ανεβασμένο",
    "complete": "Ολοκλήρωση",
    "agreement": "Συμφωνία",
    "noResults": "Κανένα αποτέλεσμα",
    "searchPlaceholder": "Αναζήτηση…",
    "tapToChange": "Πάτησε για αλλαγή",
    "you": "(εσύ)",
    "selectedUser": "Επιλεγμένος χρήστης",
    "unknownUser": "Άγνωστος χρήστης",
    "pdf": "PDF",
    "saving_changes": "Αποθήκευση…",
    "uploading_logo": "Μεταφόρτωση…",
    "stepOf": "Βήμα {{step}} από {{total}}",
    "select": "Επιλογή",
    "loadFailed": "Αποτυχία φόρτωσης",
    "appName": "Χειραψία",
    "datePickerDone": "Επιλογή",
    "progress": "Πρόοδος",
    "level": "Επίπεδο",
    "verified": "Επαληθευμένος",
    "tagline": "Δίνοντας τα χέρια, ψηφιακά.",
    "valid": "ΕΓΚΥΡΟ",
    "settlement": "ΕΞΟΦΛΗΣΗ",
    "communication": "Επικοινωνία",
    "maybeLater": "Ίσως αργότερα",
    "backTo": "Επιστροφή στη",
    "selectCountry": "Επιλογή χώρας",
    "enjoyApp": "Χαίρεσαι την Χειραψία?",
    "clear": "Καθαρισμός",
    "datePickerPlaceholder": "Επέλεξε ημερομηνία"
  },
  "language": {
    "select_title": "Επίλεξε γλώσσα",
    "select_subtitle": "Μπορείς να την αλλάξεις αργότερα από τις Ρυθμίσεις.",
    "greek": "Ελληνικά",
    "english": "English",
    "toggle_label": "Γλώσσα εφαρμογής"
  },
  "auth": {
    "error_invalidCredentials": "Λάθος email ή κωδικός.",
    "error_alreadyRegistered": "Υπάρχει ήδη λογαριασμός με αυτό το email.",
    "error_passwordTooShort": "Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες.",
    "error_invalidEmail": "Μη έγκυρη διεύθυνση email.",
    "error_emailNotConfirmed": "Επιβεβαίωσε πρώτα το email σου από το μήνυμα που έλαβες. (Έλεγξε και τα ανεπιθύμητα/spam αν δεν το βλέπεις)",
    "error_codeExpired": "Ο κωδικός έληξε. Ζήτησε νέο κωδικό επαναφοράς.",
    "error_invalidResetCode": "Λάθος κωδικός επαναφοράς.",
    "error_invalidOrExpiredCode": "Λάθος ή ληγμένος κωδικός.",
    "error_samePassword": "Ο νέος κωδικός πρέπει να διαφέρει από τον παλιό.",
    "error_rateLimit": "Πολλές προσπάθειες. Δοκίμασε ξανά σε λίγο.",
    "login": {
      "subtitle": "Καλώς ήρθες πίσω στη Χειραψία. Συνδέσου με το λογαριασμό σου.",
      "email": "Email",
      "password": "Κωδικός",
      "forgot_password": "Ξέχασες τον κωδικό;",
      "submit": "Σύνδεση",
      "no_account": "Δεν έχεις λογαριασμό;",
      "register_link": "Εγγραφή",
      "notRegistered_title": "Μάλλον δεν είστε ακόμα εγγεγραμμένος!",
      "notRegistered_body": "Πάμε για εγγραφή;",
      "notRegistered_no": "Όχι",
      "notRegistered_yes": "Ναι"
    },
    "register": {
      "title": "Εγγραφή",
      "subtitle": "Δημιούργησε λογαριασμό Χειραψία.",
      "full_name": "Ονοματεπώνυμο",
      "email": "Email",
      "password": "Κωδικός (τουλάχιστον 8 χαρακτήρες)",
      "confirm_password": "Επαλήθευση κωδικού",
      "submit": "Δημιουργία λογαριασμού",
      "have_account": "Έχεις ήδη λογαριασμό;",
      "login_link": "Σύνδεση",
      "terms_agree": "Διάβασα και αποδέχομαι τους",
      "terms_link": "Όρους Χρήσης",
      "success_title": "Επιτυχής εγγραφή!",
      "success_body": "Έλεγξε το email σου για επιβεβαίωση.",
      "consent": {
        "accept": "Αποδέχομαι τους",
        "and": "και την",
        "terms": "Όρους Χρήσης",
        "privacy": "Πολιτική Απορρήτου"
      },
      "duplicate_email": {
        "title": "Έχεις ήδη λογαριασμό;",
        "body": "Υπάρχει ήδη λογαριασμός με αυτό το email.",
        "login": "Σύνδεση"
      }
    },
    "forgot_password": {
      "title": "Επαναφορά κωδικού",
      "subtitle": "Εισάγαγε το email σου και θα σου στείλουμε οδηγίες.",
      "email": "Email",
      "submit": "Αποστολή",
      "success": "Έλεγξε το email σου για τον σύνδεσμο επαναφοράς.",
      "back": "Πίσω στη σύνδεση",
      "remembered": "Το θυμήθηκες;",
      "have_code": "Έχω ήδη κωδικό"
    },
    "reset_password": {
      "title": "Νέος κωδικός",
      "new_password": "Νέος κωδικός",
      "submit": "Ενημέρωση κωδικού",
      "success": "Ο κωδικός ενημερώθηκε. Συνδέσου ξανά.",
      "code_label": "Κωδικός επαναφοράς",
      "confirm_label": "Επιβεβαίωση νέου κωδικού",
      "subtitle_link": "Όρισε τον νέο σου κωδικό πρόσβασης.",
      "subtitle_code": "Βάλε τον 6-ψήφιο κωδικό που έλαβες στο email σου και όρισε νέο κωδικό. (Έλεγξε και τα ανεπιθύμητα/spam αν δεν το βλέπεις)",
      "code_error": "Συμπλήρωσε τον κωδικό από το email.",
      "resent_title": "Στάλθηκε",
      "resent_body": "Σου στείλαμε νέο email επαναφοράς. (Έλεγξε και τα ανεπιθύμητα/spam αν δεν το βλέπεις)",
      "change_btn": "Αλλαγή κωδικού",
      "resend_btn": "Στείλε ξανά email",
      "sending": "Αποστολή…"
    },
    "action": {
      "login": "Σύνδεση",
      "register": "Εγγραφή"
    },
    "field": {
      "password": "Κωδικός",
      "confirmPassword": "Επαλήθευση κωδικού"
    }
  },
  "home": {
    "statsExplainTitle": "Τι σημαίνουν αυτά;",
    "statsExplainRating": "⭐ Βαθμολογία: ο μέσος όρος αξιολογήσεων που έχεις λάβει από άλλους χρήστες.",
    "statsExplainReliability": "✅ Αξιοπιστία: το ποσοστό των συμφωνιών σου που ολοκληρώθηκαν κανονικά, χωρίς διαφωνία.",
    "statsExplainLevel": "🏅 Επίπεδο: ανεβαίνει όσο ολοκληρώνεις περισσότερες συμφωνίες με καλή συμπεριφορά.",
    "greeting": "Γεια, {{name}}!",
    "greetingPrefix": "Γεια σου,",
    "tab_label": "Αρχική",
    "active_agreements": "Ενεργές συμφωνίες",
    "no_active": "Δεν έχεις ενεργές συμφωνίες.",
    "ink_remaining": "Μελάνι: {{count}} υπογραφές",
    "search_placeholder": "Αναζήτηση χρήστη...",
    "notifications_empty": "Δεν υπάρχουν ειδοποιήσεις.",
    "notifications_mark_all": "Σήμανση όλων ως αναγνωσμένων",
    "announcements": "Ανακοινώσεις κύκλου",
    "no_announcements": "Δεν υπάρχουν ανακοινώσεις.",
    "level": "Επίπεδο {{level}}",
    "completed_agreements": "{{count}} ολοκληρωμένες συμφωνίες",
    "betaBanner": "Δοκιμαστική έκδοση — τα προφίλ και οι συμφωνίες θα διαγραφούν όταν βγει η επίσημη κυκλοφορία.",
    "myAgreements": "Συμφωνίες",
    "incomingOffers": "Εισερχόμενες Προσφορές",
    "myOffers": "Προσφορές προς πελάτες",
    "markAllRead": "Σήμανση όλων ως αναγνωσμένα",
    "noNotifications": "Δεν υπάρχουν ειδοποιήσεις",
    "noNotificationsBody": "Εδώ θα εμφανίζονται οι ειδοποιήσεις δραστηριότητας.",
    "walletInfo": "Κάθε συμφωνία καταναλώνει 1 μελάνι από το στυλό σου.",
    "emptyWalletTitle": "Το στυλό σου είναι άδειο",
    "emptyWalletLink": "Γέμισε μελάνι",
    "freeAgreements": "Δωρεάν συμφωνίες που απομένουν",
    "platformStat": "Συμφωνίες που ολοκληρώθηκαν στη Χειραψία",
    "freeModalTitle": "Δωρεάν συμφωνίες",
    "freeModalBody": "Κάθε νέος χρήστης λαμβάνει δωρεάν υπογραφές συμφωνιών.",
    "freeModalDismiss": "Κατάλαβα!",
    "circleLabel": "στο κύκλο μου",
    "circlePeople": "άτομα",
    "myCircle": "Ο Κύκλος μου",
    "myProfile": "Το προφίλ μου",
    "notifications": "Ειδοποιήσεις",
    "unreadChat": "Έχεις μη αναγνωσμένο μήνυμα",
    "chat": "Μηνύματα",
    "noChats": "Δεν έχεις μηνύματα ακόμα.",
    "searchingUserId": "Αναζήτηση UserID…",
    "action": {
      "newAgreement": "Νέα Συμφωνία"
    },
    "level_max": "🏆 Θρύλος — Μέγιστο επίπεδο!",
    "level_progress": "{{count}} συμφωνίες ακόμα μέχρι να ανέβεις επίπεδο!",
    "defaultUserName": "Χρήστης",
    "shareProfileTitle": "{{name}} στη Χειραψία",
    "shareProfileMessage": "Δες το προφίλ μου στη Χειραψία{{rating}}",
    "news": "Εφημερίδα",
    "findProfessionals": "Βρες επαγγελματίες",
    "findClients": "Αιτήματα Πελατών",
    "promoteProfile": "Προώθηση επαγγελματικού προφίλ",
    "promoteProfileActive": "Ενεργή προώθηση · {{rate}} μελάνια/ημέρα",
    "promotePrivateBody": "Η δυνατότητα προώθησης προφίλ είναι διαθέσιμη μόνο για δημόσια προφίλ.",
    "promoteMakePublic": "Κάνε το δημόσιο & προώθησε",
    "nearbyRequestsHint_one": "{{count}} αίτημα κοντά σου!",
    "nearbyRequestsHint_other": "{{count}} αιτήματα κοντά σου!",
    "nearbyProfessionalsHint": "{{count}} στη περιοχή σου!",
    "section_discover": "Ανακάλυψε",
    "section_agreements": "Συμφωνίες",
    "section_proTools": "Εργαλεία Επαγγελματία",
    "activeAgreementsCaption_one": "{{count}} ενεργή",
    "activeAgreementsCaption_other": "{{count}} ενεργές",
    "requests": "Αναζητήσεις",
    "reportBug": "Για ενημέρωση σφαλμάτων ή προτάσεις νέων λειτουργιών πατήστε εδώ!",
    "walletHasInkPrefix": "Έχεις μελάνι για",
    "walletHasInkBold": "{{count}} υπογραφές",
    "walletHasInkSuffix": "ακόμα",
    "walletEmpty": "Το μελάνι σου τελείωσε από τις πολλές υπογραφές! Μπορείς να αποδέχεσαι προσφορές δωρεάν. ",
    "freeCount_one": "Έχεις {{count}} δωρεάν συμφωνία!",
    "freeCount_other": "Έχεις {{count}} δωρεάν συμφωνίες!",
    "newAgreementHint_ink": "Έχεις μελάνι για {{count}} υπογραφές.",
    "noInkHint": "✒️ Τελείωσε το μελάνι υπογραφών! - Γέμισε το",
    "juryDutySelected": "🧑‍⚖️ Επιλέχθηκες σαν Κληρωτός Κριτής μιας διαφωνίας!",
    "juryDutyCountdownHours": "Έχεις {{hours}}ω {{minutes}}λ να αποφασίσεις πριν πάει σε άλλον κριτή.",
    "juryDutyCountdownMinutes": "Έχεις {{minutes}} λεπτά να αποφασίσεις πριν πάει σε άλλον κριτή.",
    "juryDutyExpiringNow": "Λήγει από στιγμή σε στιγμή — πάτα για να ψηφίσεις.",
    "newAgreementHint_free_one": "{{count}} δωρεάν υπογραφή!",
    "newAgreementHint_free_other": "{{count}} δωρεάν υπογραφές!",
    "platformStatFull": "{{count}} συμφωνίες έχουν υπογραφεί στη Χειραψία",
    "platformStatOffers": "{{count}} προσφορές έχουν αποσταλεί μέσω Χειραψία",
    "platformStatUsers": "{{count}} άτομα εμπιστεύονται τη Χειραψία",
    "platformStatDisputes": "{{count}} διαφωνίες επιλύθηκαν δίκαια",
    "platformStatProfessionals": "{{count}} επαγγελματίες είναι ήδη εδώ",
    "platformStatEur": "{{count}}€ σε συμφωνίες μέσω Χειραψία",
    "freeModalIntroPrefix": "Κάθε συμφωνία στη Χειραψία κοστίζει",
    "freeModalIntroBold": "1 μελάνι",
    "freeModalIntroSuffix": ". Μπορείς να κερδίσεις δωρεάν συμφωνίες με τους παρακάτω τρόπους:",
    "freeModalWelcomeTitle": "Καλωσόρισμα",
    "freeModalWelcomeDesc": "Λαμβάνεις 45 δωρεάν συμφωνίες μόλις εγγραφείς στη Χειραψία — αρκούν όσο είσαι στο επίπεδο \"Νέος\".",
    "freeModalLevelUpTitle": "Ανέβασμα επιπέδου",
    "freeModalLevelUpDesc": "Κάθε φορά που ανεβαίνεις επίπεδο κερδίζεις +5 δωρεάν συμφωνίες. Ανέβαινε ολοκληρώνοντας συμφωνίες!",
    "offersWaiting_one": "{{count}} προσφορά περιμένει απόκρισή σου",
    "offersWaiting_other": "{{count}} προσφορές περιμένουν απόκρισή σου",
    "firstOfferAlertTitle": "Έτοιμος επαγγελματικά!",
    "firstOfferAlertBody": "Θέλεις να δημιουργήσεις την πρώτη σου προσφορά τώρα;",
    "later": "Αργότερα",
    "createOffer": "Δημιουργία προσφοράς",
    "loadOlder": "Φόρτωση παλιότερων",
    "coach_profile_title": "Το προφίλ σου",
    "coach_profile_text": "Δες τη βαθμολογία σου και επαλήθευσε την ταυτότητά σου εδώ.",
    "coach_circle_title": "Ο Κύκλος μου",
    "coach_circle_text": "Εδώ βρίσκεται ο Κύκλος σου — οι επαφές που εμπιστεύεσαι. Σύνδεσε ανθρώπους που γνωρίζεις για να χτίσεις το δίκτυό σου.",
    "coach_search_title": "Βρες χρήστες",
    "coach_search_text": "Αναζήτησε άτομα και δες τα δημόσια προφίλ τους.",
    "coach_agreements_title": "Οι συμφωνίες σου",
    "coach_agreements_text": "Όλες οι συμφωνίες σου εδώ — με ειδοποίηση όταν χρειάζεται η έγκρισή σου.",
    "coach_new_title": "Νέα συμφωνία",
    "coach_new_text": "Ξεκίνα μια νέα συμφωνία — δωρεάν!"
  },
  "agreements": {
    "tab_label": "Συμφωνίες",
    "type_label": "Τύπος συμφωνίας",
    "type_one_off": "Με ημ. λήξης",
    "type_one_off_sub": "Μία εργασία, συγκεκριμένη προθεσμία",
    "type_ongoing": "Διαρκής",
    "type_ongoing_sub": "Ανοιχτή συνεργασία",
    "type_fixed_term": "Από-Έως",
    "type_fixed_term_sub": "Καθορισμένη περίοδος",
    "title": "Συμφωνίες",
    "new": "Νέα Συμφωνία",
    "all": "Όλες",
    "active": "Ενεργές",
    "pending": "Εκκρεμείς",
    "completed": "Ολοκληρωμένες",
    "status": {
      "pending": "Σε αναμονή",
      "active": "Ενεργή",
      "completed": "Ολοκληρωμένη",
      "cancelled": "Ακυρωμένη",
      "cancelled_mutual": "Ακυρώθηκε αμοιβαία",
      "cancelled_unilateral": "Μονομερής ακύρωση",
      "terminated": "Τερματισμένη",
      "disputed": "Σε διαφωνία",
      "frozen": "Παγωμένη",
      "draft": "Πρόχειρο",
      "cancel_requested": "Αίτημα ακύρωσης",
      "withdrawn": "Αποσύρθηκε",
      "pending_completion": "Εκκρεμής ολοκλήρωση",
      "cancelled_unsigned_timeout": "Ακύρωση - μη ανταπόκριση",
      "overdue": "Πέρασε η προθεσμία"
    },
    "typeLabel": {
      "one_off": "Μιας φοράς",
      "ongoing": "Μακράς διάρκειας"
    },
    "type": {
      "service": "Παροχή υπηρεσίας",
      "sale": "Πώληση",
      "loan": "Δάνειο",
      "rental": "Ενοικίαση",
      "other": "Άλλο"
    },
    "role": {
      "creator": "Δημιουργός",
      "counterparty": "Αντισυμβαλλόμενος"
    },
    "fields": {
      "title": "Τίτλος",
      "description": "Περιγραφή",
      "amount": "Ποσό (€)",
      "due_date": "Ημερομηνία λήξης",
      "type": "Τύπος συμφωνίας"
    },
    "agree_btn": "Συμφωνώ",
    "sign_btn": "Υπογραφή",
    "withdraw_btn": "Απόσυρση",
    "cancel_btn": "Ακύρωση συμφωνίας",
    "dispute_btn": "Διαφωνία",
    "complete_btn": "Ολοκλήρωση",
    "edit_btn": "Επεξεργασία",
    "share_btn": "Κοινοποίηση",
    "qr_btn": "QR Κώδικας",
    "pdf_btn": "Πιστοποιητικό PDF",
    "review_btn": "Αξιολόγηση",
    "both_agreed": "Και οι δύο συμφώνησαν",
    "waiting_other": "Αναμονή της άλλης πλευράς",
    "waiting_you": "Αναμένεται η συμφωνία σου",
    "signature_locked": "Η υπογραφή σου είναι κλειδωμένη — χρειάζεσαι περισσότερο μελάνι.",
    "error_sign": "Σφάλμα κατά την υπογραφή.",
    "error_load": "Αδύνατη φόρτωση συμφωνίας.",
    "empty": "Δεν υπάρχουν συμφωνίες.",
    "new_title": "Νέα Συμφωνία",
    "with": "με {{name}}",
    "draft_saved": "Το προσχέδιο αποθηκεύτηκε.",
    "confirm_withdraw": "Είσαι σίγουρος ότι θέλεις να αποσύρεις αυτή τη συμφωνία;",
    "confirm_cancel": "Είσαι σίγουρος ότι θέλεις να ακυρώσεις αυτή τη συμφωνία;",
    "notFound": "Η συμφωνία δεν βρέθηκε.",
    "inviteSuffix": "(πρόσκληση)",
    "openDuration": "Ανοιχτή διάρκεια",
    "noExpiry": "Χωρίς λήξη",
    "noCounterparty": "Χωρίς αντισυμβαλλόμενο",
    "signedByBoth": "✓ Ψηφιακά υπογεγραμμένο από αμφότερα τα μέρη",
    "signatureCode": "Κωδ. υπογραφής:",
    "signedDigitally": "✔ Υπέγραψε ψηφιακά",
    "pdfAvailableAfterSigning": "Διαθέσιμο μετά την αμοιβαία υπογραφή",
    "availableSoon": "Διαθέσιμη σε λίγο",
    "availableInHours": "Διαθέσιμη σε {{hours}} ώρες",
    "cooldownTitle": "Cooldown 24 ωρών",
    "cooldownBody": "Μπορείτε να στείλετε νέα συμφωνία σε αυτό το άτομο σε {{time}}.",
    "cancelRequestedWaiting": "Ζήτησες ακύρωση. Αναμονή απάντησης από {{name}}…",
    "cancelWaiting": "Αναμονή απάντησης για την ακύρωση…",
    "agreedWaitingOther": "Συμφώνησες ✓ — αναμονή του/της {{name}}…",
    "completionRequestedWaiting": "Ζήτησες ολοκλήρωση. Αναμονή επιβεβαίωσης από {{name}}…",
    "paymentDeclaredWaiting": "Δήλωσες εξόφληση. Αναμονή επιβεβαίωσης από {{name}}…",
    "paymentDeclaredQuestion": "Ο/Η {{name}} δηλώνει εξόφληση — ισχύει όντως;",
    "completionConfirmQuestion": "Ο/Η {{name}} ζητά ολοκλήρωση — επιβεβαιώνεις;",
    "cancelRequestQuestion": "Ο/Η {{name}} ζητά ακύρωση — συμφωνείς;",
    "cancelResponse": "Απάντηση:",
    "freeSigningNotice": "Υπογράφεις αυτή τη συμφωνία δωρεάν.",
    "signedFreeWaiting": "Υπέγραψες δωρεάν ✓ — αναμονή του/της {{name}}…",
    "agreedWaiting": "Συμφώνησες ✓ — αναμονή του/της {{name}}…",
    "invitePendingNotice": "Η πρόσκληση εστάλη. Αναμονή εγγραφής της άλλης πλευράς.",
    "section_terms": "Δέσμευση & Όροι Συμφωνίας",
    "section_signatures": "Ψηφιακές Υπογραφές",
    "section_cancelReasons": "Λόγοι ακύρωσης",
    "section_charges": "Χρεώσεις",
    "field_title": "Τίτλος",
    "field_counterparty": "Αντισυμβαλλόμενος",
    "field_creator": "Δημιουργός",
    "field_date": "Ημερομηνία",
    "field_percent": "Ποσοστό",
    "field_amount": "Ποσό",
    "field_dateType": "Τύπος ημερομηνίας",
    "field_expiryDate": "Ημερομηνία-ορόσημο (προαιρετική)",
    "field_termsOptional": "Όροι δέσμευσης (προαιρετικό)",
    "templatesLabel": "Πρότυπο κειμένου δέσμευσης",
    "templateFreeText": "Ελεύθερο κείμενο",
    "field_percentOptional": "Ποσοστό μεριδίου (προαιρετικό)",
    "field_amountOptional": "Ποσό συμφωνίας (προαιρετικό)",
    "type_withMilestone": "Με ορόσημο",
    "type_noMilestone": "Χωρίς ορόσημο",
    "action_editDraft": "Επεξεργασία πρόχειρου",
    "action_send": "Αποστολή",
    "action_saveDraft": "Αποθήκευση στα Πρόχειρα",
    "action_shareLink": "Κοινοποίηση συνδέσμου",
    "action_resendInviteLink": "Επαναποστολή συνδέσμου πρόσκλησης",
    "action_withdrawProposal": "Απόσυρση πρότασης",
    "action_requestCompletion": "Αίτημα Ολοκλήρωσης",
    "action_reportDispute": "Αναφορά Διαφωνίας",
    "action_exportPdf": "Εκτύπωση / Αποθήκευση PDF",
    "action_deleteDraft": "Διαγραφή πρόχειρου",
    "action_agreeCancellation": "Αποδοχή ακύρωσης",
    "action_rejectCancellation": "Απόρριψη ακύρωσης",
    "action_signFree": "Συμφωνώ & Υπογράφω (Δωρεάν)",
    "action_signInk": "Συμφωνώ & Υπογράφω (-1 μελάνι)",
    "action_sign": "Συμφωνώ & Υπογράφω",
    "action_signatureRequired": "Απαιτείται η υπογραφή σου",
    "action_send_agreement": "Αποστολή συμφωνίας",
    "confirm_accept_title": "Υπογραφή Συμφωνίας",
    "confirm_accept_message": "Με την υπογραφή σου αποδέχεσαι τους όρους αυτής της συμφωνίας.",
    "confirm_accept_label": "Υπογραφή",
    "confirm_reject_title": "Απόρριψη Συμφωνίας",
    "confirm_reject_message": "Είσαι σίγουρος ότι θέλεις να απορρίψεις αυτή τη συμφωνία;",
    "confirm_reject_label": "Απόρριψη",
    "confirm_withdraw_title": "Απόσυρση Συμφωνίας",
    "confirm_withdraw_message": "Η συμφωνία θα μεταφερθεί στα πρόχειρα. Ο άλλος δεν θα τη βλέπει πλέον.",
    "confirm_withdraw_label": "Απόσυρση",
    "confirm_complete_title": "Ολοκλήρωση Συμφωνίας",
    "confirm_complete_message": "Είσαι σίγουρος ότι θέλεις να ολοκληρώσεις τη συμφωνία;",
    "confirm_complete_label": "Ολοκλήρωση",
    "confirm_cancel_request_title": "Αίτημα Ακύρωσης",
    "confirm_cancel_request_message": "Θα ζητήσεις ακύρωση. Ο άλλος πρέπει να συμφωνήσει.",
    "confirm_cancel_request_label": "Αίτημα",
    "confirm_cancel_agree_title": "Αποδοχή Ακύρωσης",
    "confirm_cancel_agree_message": "Η συμφωνία θα ακυρωθεί αμοιβαία.",
    "confirm_cancel_agree_label": "Αποδοχή",
    "confirm_request_completion_title": "Αίτημα Ολοκλήρωσης",
    "confirm_request_completion_message": "Θα ζητήσεις επιβεβαίωση ολοκλήρωσης από τον άλλο.",
    "confirm_request_completion_label": "Αίτημα",
    "confirm_confirm_completion_title": "Επιβεβαίωση Ολοκλήρωσης",
    "confirm_confirm_completion_message": "Είσαι σίγουρος ότι θέλεις να επιβεβαιώσεις την ολοκλήρωση;",
    "confirm_confirm_completion_label": "Επιβεβαίωση",
    "confirm_reject_completion_title": "Απόρριψη Ολοκλήρωσης",
    "confirm_reject_completion_message": "Το αίτημα ολοκλήρωσης θα απορριφθεί.",
    "confirm_reject_completion_label": "Απόρριψη",
    "confirm_declare_payment_title": "Δήλωση Εξόφλησης",
    "confirm_declare_payment_message": "Θα δηλώσεις ότι έχεις πληρώσει.",
    "confirm_declare_payment_label": "Δήλωση",
    "confirm_confirm_payment_title": "Επιβεβαίωση Εξόφλησης",
    "confirm_confirm_payment_message": "Θα επιβεβαιώσεις ότι έλαβες την πληρωμή.",
    "confirm_confirm_payment_label": "Επιβεβαίωση",
    "confirm_reject_payment_title": "Απόρριψη Εξόφλησης",
    "confirm_reject_payment_message": "Θα απορρίψεις τη δήλωση εξόφλησης.",
    "confirm_reject_payment_label": "Απόρριψη",
    "payment_status_charged": "Χρεώθηκε",
    "payment_status_cancelled": "Ακυρώθηκε",
    "payment_status_authorized": "Δέσμευση",
    "filter_all": "Όλες",
    "filter_needsAction": "Εκκρεμεί ενέργεια",
    "filter_active": "Ενεργές",
    "filter_completed": "Ολοκληρωμένες",
    "filter_cancelled": "Ακυρωμένες",
    "filter_drafts": "Πρόχειρες",
    "expiry_none": "Χωρίς λήξη",
    "expiry_due": "Ημερομηνία λήξης",
    "expiry_delivery": "Ημερομηνία παράδοσης",
    "expiry_milestone": "Ορόσημο",
    "empty_noResults": "Κανένα αποτέλεσμα",
    "empty_noAgreements": "Καμία συμφωνία ακόμη",
    "empty_allGood": "✅ Όλα καλά!",
    "empty_noneHere": "Καμία συμφωνία εδώ",
    "delete_draft_title": "Διαγραφή πρόχειρου",
    "delete_draft_message": "Αυτό θα διαγράψει μόνιμα το πρόχειρο.",
    "role_with": "Με",
    "role_from": "Από",
    "nav_back": "‹ Συμφωνίες",
    "sent_title": "Στάλθηκε",
    "sent_body": "Η συμφωνία στάλθηκε.",
    "sent_invite_body": "Η συμφωνία στάλθηκε και η πρόσκληση πήγε στο {{email}}.",
    "too_early_title": "Πολύ νωρίς",
    "too_early_body": "Πρέπει να περάσει λίγος χρόνος από την υπογραφή πριν ολοκληρωθεί η συμφωνία.",
    "too_early_body_withTime": "Η συμφωνία μπορεί να ολοκληρωθεί μετά τις {{time}} (3 ώρες μετά την υπογραφή — προστασία από βιαστική ολοκλήρωση).",
    "completion_requested": "Στάλθηκε αίτημα ολοκλήρωσης.",
    "completion_rejected": "Απορρίφθηκε το αίτημα ολοκλήρωσης.",
    "payment_rejected": "Απορρίφθηκε η δήλωση εξόφλησης.",
    "search_placeholder": "Αναζήτηση τίτλου ή ατόμου…",
    "share_message": "Δες και αποδέξου αυτή τη συμφωνία στη Χειραψία:",
    "share_invite_code": "\nΚωδικός πρόσβασης: {{code}}",
    "cooldown_chip": "Διαθέσιμη σε λίγο",
    "cooldown_chip_hours": "Διαθέσιμη σε {{hours}} ώρες",
    "waiting_my_signature": "Συμφώνησες ✓ — αναμονή του/της {{name}}…",
    "review_summary_title": "Σύνοψη συμφωνίας",
    "completedTitle": "Συμφωνία Ολοκληρώθηκε!",
    "completedSub": "Μπορείτε πλέον να αξιολογήσετε τη συνεργασία σας.",
    "coach1_title": "Τίτλος συμφωνίας",
    "coach1_text": "Ένα σύντομο, περιγραφικό όνομα. Π.χ. «Ανάπτυξη ιστοσελίδας», «Ενοικίαση εξοπλισμού». Θα φαίνεται και στις δύο πλευρές.",
    "coach2_title": "Ημερομηνία-ορόσημο",
    "coach2_text": "Προαιρετική ένδειξη. Όταν φτάσει η ημερομηνία, ειδοποιείστε και οι δύο — δεν γίνεται τίποτα αυτόματα. Εσείς αποφασίζετε τι θα κάνετε.",
    "coach3_title": "Αντισυμβαλλόμενος",
    "coach3_text": "Το άτομο που θα υπογράψει μαζί σου. Αναζήτησέ το με το όνομά του αν είναι στη Χειραψία, ή γράψε email για πρόσκληση.",
    "coach4_title": "Ποσό / Ποσοστό",
    "coach4_text": "Προαιρετικό. Μόλις ξεκινήσει η συμφωνία, μπορείτε να καταγράφετε πληρωμές απευθείας μέσα από τη σελίδα της.",
    "coach5_title": "Όροι δέσμευσης",
    "coach5_text": "Περίγραψε τι συμφωνείτε. Π.χ. «Ο Α παραδίδει Χ έως Υ ημερομηνία· ο Β καταβάλλει Ζ€». Όσο πιο σαφές, τόσο ισχυρότερη η προστασία.",
    "errorTitleRequired": "Δώσε τίτλο στη συμφωνία.",
    "errorCounterpartyRequired": "Γράψε όνομα ή email αντισυμβαλλόμενου.",
    "errorStartDateRequired": "Επίλεξε ημερομηνία έναρξης.",
    "errorEndDateRequired": "Επίλεξε ημερομηνία λήξης.",
    "errorEndAfterStart": "Η ημερομηνία λήξης πρέπει να είναι μετά την έναρξη.",
    "errorInvalidAmount": "Μη έγκυρο ποσό.",
    "errorSuspended": "Ο λογαριασμός σου έχει ανασταλεί. Επικοινώνησε στο hello@heirapsia.gr.",
    "errorFrozen": "Ο λογαριασμός σου βρίσκεται σε προσωρινή αναστολή εν αναμονή ελέγχου περιεχομένου. Δοκίμασε αργότερα.",
    "errorDailyLimit": "Έχεις φτάσει το ημερήσιο όριο νέων συμφωνιών για το επίπεδό σου ({{limit}}/ημέρα). Δοκίμασε ξανά αύριο.",
    "errorSelfAgreement": "Δεν μπορείς να συνάψεις συμφωνία με τον εαυτό σου.",
    "errorCreateFailed": "Αποτυχία δημιουργίας συμφωνίας.",
    "errorSaveDraftFailed": "Αποτυχία αποθήκευσης προχείρου.",
    "errorSaveFailed": "Αποτυχία αποθήκευσης.",
    "untitled": "Χωρίς τίτλο",
    "selectedUserFallback": "Επιλεγμένος χρήστης",
    "saveDraftPromptTitle": "Αποθήκευση στο πρόχειρο;",
    "saveDraftPromptBody": "Δεν έχεις ολοκληρώσει τη συμφωνία. Δεν θα σταλεί σε κανέναν — μπορείς να την ολοκληρώσεις αργότερα από τα Πρόχειρα.",
    "discard": "Απόρριψη",
    "newAgreementTitle": "Νέα Συμφωνία",
    "templateBusinessTermsClause": "Ο/Η {{name}} ανέγνωσε και αποδέχεται τους όρους και προϋποθέσεις της επιχείρησης {{business}}.",
    "partyModeSubtitle": "Ανάμεσα σε πόσα άτομα;",
    "twoPartyTitle": "Μεταξύ 2 ατόμων",
    "twoPartySubtitle": "Η κλασική ροή — εσύ και ένας αντισυμβαλλόμενος.",
    "multiPartyTitle": "Πολλών ατόμων",
    "multiPartySubtitle": "3 ή περισσότερα άτομα, με ποσοστά συμμετοχής (πρωτότυπο λειτουργία).",
    "wizardStep1Title": "Στοιχεία συμφωνίας",
    "wizardStep2Title": "Ποσό & Όροι",
    "wizardStep3Title": "Επισκόπηση",
    "wizardStep1Subtitle": "Δώσε τίτλο, επίλεξε αντισυμβαλλόμενο και ημερομηνία.",
    "wizardStep2Subtitle": "Προαιρετικό ποσό και λεπτομέρειες δέσμευσης.",
    "wizardStep3Subtitle": "Έλεγξε τα στοιχεία πριν στείλεις.",
    "titlePlaceholder": "π.χ. Ενοικίαση εξοπλισμού",
    "counterpartyPlaceholder": "Όνομα ή email…",
    "counterpartyInviteHint": "Αν δεν είναι εγγεγραμμένος, θα του σταλεί πρόσκληση με email.",
    "counterpartySearchHint": "Γράψε όνομα για αναζήτηση ή @ για email.",
    "unregisteredNamePlaceholder": "Όνομα αντισυμβαλλόμενου (προαιρετικό)",
    "milestoneDateLabel": "Ημερομηνία-ορόσημο (προαιρετικό)",
    "milestoneDateHintSet": "Ειδοποίηση και στους δύο — δεν γίνεται τίποτα αυτόματα.",
    "milestoneDateHintEmpty": "Χωρίς ορόσημο: ανοιχτή προθεσμία.",
    "startDateLabel": "Ημερομηνία έναρξης",
    "endDateLabel": "Ημερομηνία λήξης",
    "fixedTermDurationHint": "Διάρκεια: {{days}} ημέρες. Όταν λήξει, θα ερωτηθείτε και οι δύο αν θέλετε ανανέωση.",
    "ongoingHint": "Ανοιχτή συνεργασία χωρίς προκαθορισμένο τέλος.",
    "amountPercentLabel": "Ποσοστό μεριδίου (προαιρετικό)",
    "amountEurLabel": "Ποσό συμφωνίας (προαιρετικό)",
    "amountPercentPlaceholder": "π.χ. 10",
    "amountEurPlaceholder": "π.χ. 150",
    "amountPercentHint": "Για συμφωνίες μεριδίου — π.χ. % εταιρείας ή % αμοιβής.",
    "amountEurHint": "Η αξία της συμφωνίας σε {{currency}}.",
    "termsPlaceholder": "π.χ. Ο πωλητής παραδίδει… ο αγοραστής καταβάλλει…",
    "reviewTypeLabel": "Τύπος",
    "reviewPeriodLabel": "Περίοδος",
    "reviewOpenDuration": "Ανοιχτή διάρκεια",
    "submitHint": "Μόλις στείλεις, ο αντισυμβαλλόμενος θα λάβει ειδοποίηση για να υπογράψει. Η χρέωση 1 μελάνι γίνεται μόνο αν συμφωνήσετε και οι δύο.",
    "cooldown12Title": "Cooldown 12 ωρών",
    "cooldown12Body": "Έχετε ήδη δημιουργήσει συμφωνία μεταξύ σας τις τελευταίες 12 ώρες.\nΜπορείτε να στείλετε ξανά:",
    "expiryLabelPayment": "Ημερομηνία εξόφλησης",
    "multi_userFallback": "Χρήστης",
    "multi_emailInviteLabel": "{{email}} (πρόσκληση)",
    "multi_maxPartiesError": "Μέγιστο 6 επιπλέον συμβαλλόμενοι στο πρωτότυπο.",
    "multi_duplicatePartyError": "Αυτό το άτομο/email υπάρχει ήδη στη λίστα.",
    "multi_invalidEmailError": "Γράψε ένα έγκυρο email.",
    "multi_titleTooShort": "Δώσε έναν τίτλο τουλάχιστον 3 χαρακτήρων.",
    "multi_needTwoParties": "Χρειάζονται τουλάχιστον 2 επιπλέον συμβαλλόμενοι.",
    "multi_amountRequired": "Συμπλήρωσε το συνολικό ποσό για να μοιραστεί σε €.",
    "multi_percentMismatch": "Τα ποσοστά πρέπει να αθροίζουν σε 100% (τώρα: {{total}}%).",
    "multi_amountMismatch": "Τα ποσά πρέπει να αθροίζουν στο συνολικό ποσό ({{splitTotal}}€, τώρα: {{total}}€).",
    "multi_createFailed": "Η δημιουργία απέτυχε.",
    "multi_incompleteTitle": "Ημιτελής συμφωνία",
    "multi_incompleteBody": "{{msg}}\n\nΔεν μπορεί να αποθηκευτεί ως πρόχειρο έτσι όπως είναι. Θέλεις να την απορρίψεις;",
    "multi_continueEditing": "Συνέχισε την επεξεργασία",
    "multi_saveDraftPromptBody": "Δεν θα σταλεί σε κανέναν τώρα — μπορείς να την ολοκληρώσεις και να τη στείλεις αργότερα από τα Πρόχειρα.",
    "multi_wizardTitle": "Συμφωνία Πολλών Ατόμων",
    "multi_wizardReviewTitle": "Επισκόπηση",
    "multi_wizardFormSubtitle": "Πρωτότυπο λειτουργία — πρόσθεσε 2+ άτομα και όρισε επιμερισμό.",
    "multi_wizardReviewSubtitle": "Έλεγξε τα στοιχεία πριν αποθηκεύσεις ως πρόχειρο.",
    "multi_prototypeNotice": "Πρωτότυπο χαρακτηριστικό. Reviews/υπενθυμίσεις λειτουργούν απλοποιημένα προς το παρόν.",
    "multi_titleFieldLabel": "Τίτλος συμφωνίας",
    "multi_titleFieldPlaceholder": "π.χ. Κοινή εκδρομή — έξοδα διαμονής",
    "multi_termsFieldLabel": "Όροι / Περιγραφή (προαιρετικό)",
    "multi_termsFieldPlaceholder": "Περιγραφή δέσμευσης",
    "multi_amountFieldLabelRequired": "Συνολικό ποσό € (υποχρεωτικό)",
    "multi_amountFieldLabelOptional": "Συνολικό ποσό € (προαιρετικό)",
    "multi_amountFieldPlaceholder": "π.χ. 300",
    "multi_sectionTitle": "Συμβαλλόμενοι & Επιμερισμός",
    "multi_lockHint": "Πάτα το λουκέτο δίπλα σε ένα ποσοστό για να το κλειδώσεις — δεν θα αλλάζει όταν προσαρμόζεις τα υπόλοιπα.",
    "multi_percentMode": "Ποσοστό %",
    "multi_amountMode": "Ποσό €",
    "multi_youCreator": "Εσύ (δημιουργός)",
    "multi_unlockShare": "Ξεκλείδωμα ποσοστού",
    "multi_lockShare": "Κλείδωμα ποσοστού",
    "multi_totalLabel": "Σύνολο: {{total}}{{unit}} {{ofTotal}}",
    "multi_addPersonLabel": "Πρόσθεσε άτομο (+)",
    "multi_searchPlaceholder": "Αναζήτηση ονόματος…",
    "multi_inviteResultText": "Πρόσκληση «{{query}}» με email (δεν έχει λογαριασμό ακόμα)",
    "multi_reviewButton": "Επισκόπηση",
    "multi_reviewTotalAmount": "Συνολικό ποσό: {{amount}}€",
    "multi_reviewNotice": "Θα αποθηκευτεί ως πρόχειρο. Δεν θα σταλεί σε κανέναν μέχρι να πατήσεις ρητά \"Αποστολή\" από τη σελίδα της συμφωνίας.",
    "multi_back": "Πίσω",
    "multi_saveAsDraft": "Αποθήκευση ως Πρόχειρο",
    "listLoadFailed": "Αποτυχία φόρτωσης.",
    "groupPending": "Εκκρεμείς",
    "groupActive": "Ενεργές",
    "groupArchive": "Αρχείο",
    "emptySearchBody": "Δεν βρέθηκε συμφωνία για «{{query}}».",
    "emptyAllBody": "Δημιούργησε την πρώτη σου ψηφιακή συμφωνία.",
    "emptyNeedsActionBody": "Δεν υπάρχει καμία εκκρεμής ενέργεια αυτή τη στιγμή.",
    "emptyOtherBody": "Δοκίμασε άλλο φίλτρο ή τράβα κάτω για ανανέωση.",
    "fromOfferChip": "Από προσφορά",
    "daysAbbrev": "{{count}}μ",
    "editSubtitle": "Τροποποίησε τους όρους και αποστείλε ξανά.",
    "editErrorStartDateRequired": "Επίλεξε ημερομηνία έναρξης.",
    "editErrorEndDateRequired": "Επίλεξε ημερομηνία λήξης.",
    "editErrorEndAfterStart": "Η ημερομηνία λήξης πρέπει να είναι μετά την έναρξη.",
    "editErrorSaveFailed": "Αποτυχία αποθήκευσης.",
    "editTypeLabel": "Τύπος",
    "editTypeOneOff": "Εφάπαξ",
    "editTypeOngoing": "Αορίστου",
    "editTypeFixedTerm": "Από-Έως",
    "editStartDateLabel": "Ημερομηνία έναρξης",
    "editEndDateLabel": "Ημερομηνία λήξης",
    "editDurationHint": "Διάρκεια: {{days}} ημέρες.",
    "editOngoingHint": "Ανοιχτή συνεργασία χωρίς προκαθορισμένο τέλος.",
    "editPartiesLabel": "Συμβαλλόμενοι & ποσοστά",
    "editYouCreator": "Εσύ (δημιουργός)",
    "editUserFallback": "Χρήστης",
    "editPartiesHint": "Οι συμβαλλόμενοι και τα ποσοστά δεν αλλάζουν εδώ — μόνο τίτλος, ποσό, όροι και ημερομηνίες.",
    "editMultiAmountLabel": "Συνολικό ποσό € (προαιρετικό)",
    "editAmountPercentPlaceholder": "π.χ. 10",
    "editCounterpartyShareHint": "Ο αντισυμβαλλόμενος θα έχει {{percent}}%.",
    "editAmountEurPlaceholder": "π.χ. 150",
    "editExpiryLabelAgreementEnd": "Λήξη συμφωνίας",
    "editExpiryLabelDelivery": "Παράδοση έργου",
    "editExpiryLabelPaymentDeadline": "Προθεσμία πληρωμής",
    "editExpiryLabelStartDate": "Ημ. έναρξης",
    "editExpiryLabelOther": "Άλλο"
  },
  "agreementDetail": {
    "insufficientInkTitle": "Ανεπαρκές μελάνι",
    "insufficientInkBody": "Δεν έχεις αρκετό μελάνι ούτε δωρεάν υπογραφές για να συνεχίσεις. Κάνε top-up μελανιού για να ολοκληρώσεις.",
    "newStateBubble": "Νέα κατάσταση - Πάτησε εδώ!",
    "percentSplitValue": "{{creatorName}}: {{creatorPercent}}% · {{counterpartyName}}: {{counterpartyPercent}}%",
    "staleActionState": "Η κατάσταση της συμφωνίας άλλαξε στο μεταξύ (π.χ. απαντήθηκε ήδη). Ανανεώνουμε τα στοιχεία — δοκίμασε ξανά αν χρειάζεται.",
    "dealOwnerLabel": "Υπεύθυνος συμφωνίας",
    "dealOwnerValue": "{{name}}, της επιχείρησης {{business}}",
    "reliabilityChangeTitle": "Ποσοστό αξιοπιστίας",
    "reliabilityChangeBody": "Η αξιοπιστία σου {{sign}}{{diff}}% — από {{before}}% σε {{after}}%.",
    "pdfOutdated": "Ενημερώθηκε",
    "sendFailed": "Αποτυχία αποστολής.",
    "pdfExportFailed": "Η δημιουργία PDF απέτυχε.",
    "editRequestNoteRequired": "Περιέγραψε τι αλλαγές θέλεις.",
    "editRequestSent": "Το αίτημα επεξεργασίας στάλθηκε.",
    "editRequestSendFailed": "Αποτυχία αποστολής αιτήματος.",
    "editRequestApproved": "Ενέκρινες το αίτημα επεξεργασίας.",
    "editRequestRejected": "Απέρριψες το αίτημα επεξεργασίας.",
    "actionFailed": "Η ενέργεια απέτυχε.",
    "editSavedPendingApproval": "Οι αλλαγές αποθηκεύτηκαν — αναμονή τελικής έγκρισης.",
    "saveFailed": "Αποτυχία αποθήκευσης.",
    "editFinalized": "Η συμφωνία ενημερώθηκε.",
    "editFinalizeRejected": "Οι αλλαγές απορρίφθηκαν — επαναφορά παλιών τιμών.",
    "multiSignSuccess": "Υπέγραψες τη συμφωνία.",
    "signFailed": "Η υπογραφή απέτυχε.",
    "disputeOpened": "Η διαφωνία ανοίχτηκε.",
    "disputeOpenFailed": "Αποτυχία ανοίγματος διαφωνίας.",
    "blameAccepted": "Αποδέχθηκες την ευθύνη.",
    "disputeGoesToVote": "Η διαφωνία προχωρά σε ψηφοφορία από τα υπόλοιπα μέρη.",
    "voteRecorded": "Η ψήφος σου καταχωρήθηκε.",
    "voteFailed": "Η ψήφος απέτυχε.",
    "sendActionFailed": "Η αποστολή απέτυχε.",
    "earlyCompletionTitle": "Πρόωρη ολοκλήρωση",
    "earlyCompletionBody": "Η συμφωνία λήγει στις {{date}}. Θέλεις να ολοκληρώσεις πρόωρα;",
    "yesCompleteEarly": "Ναι, ολοκλήρωση",
    "completionRejectedContinues": "Απορρίφθηκε το αίτημα ολοκλήρωσης — η συμφωνία συνεχίζεται.",
    "inviteeLabel": "{{email}} (πρόσκληση)",
    "invitedLabel": "{{name}} (πρόσκληση)",
    "refundOnMutual": "\n\nΗ υπογραφή επιστρέφεται στο μελάνι σου.",
    "refundIfMutual": "\n\nΑν η ακύρωση γίνει αμοιβαία, η υπογραφή επιστρέφεται στο μελάνι σου.",
    "feeFromInk": "Χρεώνεται 1 υπογραφή από το μελάνι σου.",
    "feeChargeInk": "Χρέωση 1 μελάνι για την ενεργοποίηση της συμφωνίας.",
    "feeFree": "Δωρεάν — χωρίς χρέωση.",
    "acceptTitle": "Υπογραφή συμφωνίας",
    "acceptMessage": "Αποδέχεσαι τους όρους της συμφωνίας «{{title}}» και δεσμεύεσαι να τους τηρήσεις.\n\n{{feeNote}}",
    "acceptConfirmLabel": "Υπογράφω",
    "rejectTitle": "Απόρριψη συμφωνίας",
    "rejectMessage": "Απορρίπτεις την πρόταση συμφωνίας «{{title}}».\n\n{{article}} {{name}} θα ειδοποιηθεί για την απόρριψη. Δεν υπάρχει χρέωση.",
    "rejectConfirmLabel": "Απορρίπτω",
    "withdrawTitle": "Απόσυρση πρότασης",
    "withdrawMessage": "Αποσύρεις την πρόταση «{{title}}» πριν την αποδεχτεί ο/η {{name}}.\n\nΗ συμφωνία αποθηκεύεται ως πρόχειρο — μπορείς να την επεξεργαστείς και να την ξαναστείλεις όποτε θέλεις. Δεν υπάρχει χρέωση.",
    "withdrawConfirmLabel": "Αποσύρω",
    "completeTitle": "Σήμανση ως Ολοκληρωμένη",
    "completeMessage": "Σημαίνεις τη συμφωνία «{{title}}» ως ολοκληρωμένη.\n\nΜετά την ολοκλήρωση, και οι δύο πλευρές μπορούν να αξιολογήσουν τη συνεργασία.",
    "completeConfirmLabel": "Ολοκλήρωση",
    "terminateTitle": "Ολοκλήρωση συμφωνίας",
    "terminateMessage": "Ολοκληρώνεις τη συμφωνία «{{title}}».\n\n{{article}} {{name}} θα ειδοποιηθεί. Μετά την ολοκλήρωση, και οι δύο μπορούν να αξιολογήσουν τη συνεργασία.",
    "terminateConfirmLabel": "Ολοκληρώνω",
    "cancelRequestTitle": "Αίτημα ακύρωσης",
    "cancelRequestMessage": "Ζητάς ακύρωση της ενεργής συμφωνίας «{{title}}».\n\n{{article}} {{name}} θα ειδοποιηθεί και μπορεί να συμφωνήσει ή να αρνηθεί. Αν αρνηθεί, η συμφωνία συνεχίζεται κανονικά.",
    "cancelRequestConfirmLabel": "Ζητώ ακύρωση",
    "cancelAgreeTitle": "Αποδοχή ακύρωσης",
    "cancelAgreeMessage": "Συμφωνείς στην ακύρωση της συμφωνίας «{{title}}» από τον/την {{name}}.\n\nΗ ακύρωση γίνεται αμοιβαία — κανένας δεν χάνει βαθμολογία.",
    "cancelAgreeConfirmLabel": "Συμφωνώ στην ακύρωση",
    "completeAgreementBtn": "Ολοκλήρωση συμφωνίας",
    "endOngoingAgreementBtn": "Τερματισμός συνεργασίας",
    "cancelAgreementBtn": "Ακύρωση συμφωνίας",
    "multiCancelRequestBtn": "Ζήτησε ακύρωση όλης",
    "multiCancelRequestTitle": "Ακύρωση συμφωνίας πολλών ατόμων",
    "multiCancelRequestMessage": "Θα ζητηθεί η συναίνεση όλων των μελών για ακύρωση. Αν έστω ένας διαφωνήσει, η ακύρωση ματαιώνεται και η συμφωνία συνεχίζεται κανονικά. Κανένας δεν χάνει βαθμολογία αν όλοι συμφωνήσουν.",
    "multiCancelRequestConfirm": "Ζήτησε ακύρωση",
    "multiCancelRequestSent": "Το αίτημα ακύρωσης στάλθηκε σε όλα τα μέλη.",
    "multiCancelRejectedContinues": "Κάποιο μέλος διαφώνησε — η ακύρωση ματαιώθηκε, η συμφωνία συνεχίζεται.",
    "multiCancelVoteRecorded": "Η ψήφος σου καταγράφηκε ({{agreed}}/{{total}} συμφώνησαν μέχρι τώρα).",
    "multiCancelWaitingOthers": "Συμφώνησες στην ακύρωση — αναμονή των υπολοίπων ({{agreed}}/{{total}}).",
    "multiCancelRequestedBy": "{{name}} ζήτησε ακύρωση της συμφωνίας ({{agreed}}/{{total}} έχουν συμφωνήσει). Συμφωνείς κι εσύ;",
    "multiWithdrawBtn": "Αποχώρηση μόνος/η",
    "multiWithdrawTitle": "Μονομερής αποχώρηση",
    "multiWithdrawMessage": "Θα αποχωρήσεις από τη συμφωνία — οι υπόλοιποι συνεχίζουν κανονικά και το μερίδιό σου αναδιανέμεται σε αυτούς. Αυτό μετράει σαν μονομερή ακύρωση στη δική σου βαθμολογία αξιοπιστίας. Η ενέργεια δεν αναιρείται.",
    "multiWithdrawConfirm": "Αποχώρησε",
    "multiWithdrawDone": "Αποχώρησες από τη συμφωνία.",
    "multiPartyWithdrawnTag": "Αποχώρησε",
    "youWithdrewFromThisAgreement": "Έχεις αποχωρήσει από αυτή τη συμφωνία. Δεν έχεις πλέον πρόσβαση στο περιεχόμενό της.",
    "multiCancelAllAgreedDone": "Όλοι συμφώνησαν — η συμφωνία ακυρώθηκε αμοιβαία.",
    "requestCompletionTitle": "Δήλωση Ολοκλήρωσης",
    "requestCompletionMessage": "Δηλώνεις ότι ολοκλήρωσες τη συμφωνία «{{title}}».\n\n{{article}} {{name}} θα ειδοποιηθεί και πρέπει να επιβεβαιώσει ή να αρνηθεί. Αν αρνηθεί, η δήλωση ακυρώνεται και μπορείς να ξαναδηλώσεις ή να ανοίξεις διαφορά.",
    "requestCompletionConfirmLabel": "Δηλώνω ολοκλήρωση",
    "confirmCompletionTitle": "Επιβεβαίωση Ολοκλήρωσης",
    "confirmCompletionMessage": "{{article}} {{name}} δηλώνει ότι ολοκλήρωσε τη συμφωνία «{{title}}».\n\nΑν επιβεβαιώσεις, η συμφωνία κλείνει οριστικά και και οι δύο μπορείτε να αξιολογήσετε τη συνεργασία.",
    "confirmCompletionConfirmLabel": "Επιβεβαιώνω ολοκλήρωση",
    "rejectCompletionTitle": "Άρνηση Ολοκλήρωσης",
    "rejectCompletionMessage": "Αρνείσαι τη δήλωση ολοκλήρωσης του/της {{name}} για τη συμφωνία «{{title}}».\n\nΗ δήλωση ακυρώνεται. {{article}} {{name}} θα ειδοποιηθεί και μπορεί να ξαναδηλώσει ή να ανοίξει διαφορά.",
    "declarePaymentTitle": "Δήλωση Εξόφλησης",
    "declarePaymentMessage": "Δηλώνεις ότι εξόφλησες τη συμφωνία «{{title}}».\n\n{{article}} {{name}} θα ειδοποιηθεί και πρέπει να επιβεβαιώσει παραλαβή ή να αρνηθεί. Αν αρνηθεί, η δήλωση ακυρώνεται.",
    "declarePaymentConfirmLabel": "Δηλώνω εξόφληση",
    "confirmPaymentTitle": "Επιβεβαίωση Εξόφλησης",
    "confirmPaymentMessage": "{{article}} {{name}} δηλώνει ότι εξόφλησε τη συμφωνία «{{title}}».\n\nΑν επιβεβαιώσεις, καταγράφεται η εξόφληση στη συμφωνία. Βεβαιώσου ότι έχεις λάβει την πληρωμή πριν επιβεβαιώσεις.",
    "confirmPaymentWarning": "Η επιβεβαίωση είναι οριστική. Αν δεν έχεις λάβει πληρωμή, πάτα \"Αρνούμαι\".",
    "confirmPaymentConfirmLabel": "Επιβεβαιώνω παραλαβή",
    "rejectPaymentTitle": "Άρνηση Εξόφλησης",
    "rejectPaymentMessage": "Αρνείσαι τη δήλωση εξόφλησης του/της {{name}} για τη συμφωνία «{{title}}».\n\nΗ δήλωση ακυρώνεται. {{article}} {{name}} θα ειδοποιηθεί. Αν επιμένει η διαφωνία, μπορείτε να ανοίξετε διαφορά.",
    "rejectPaymentConfirmLabel": "Δεν έχω λάβει πληρωμή",
    "rejectCancelTitle": "Απόρριψη αιτήματος ακύρωσης",
    "rejectCancelMessage": "Απορρίπτεις το αίτημα ακύρωσης του/της {{name}}.\n\n{{article}} {{name}} θα ειδοποιηθεί. Η συμφωνία συνεχίζεται κανονικά χωρίς καμία συνέπεια.",
    "rejectCancelConfirmLabel": "Απόρριψη αιτήματος",
    "declineVerb": "Αρνούμαι",
    "messagesTitle": "Μηνύματα",
    "messagesParticipantsPrefix": "Συμμετέχουν οι",
    "messagesReadBy": "διαβάστηκε από {{names}}",
    "messagesEmpty": "Στείλε μήνυμα στον αντισυμβαλλόμενο μέσα από την εφαρμογή.",
    "messagesUnreadDivider": "ΜΗ ΑΝΑΓΝΩΣΜΕΝΑ",
    "messagesPlaceholder": "Γράψε μήνυμα…",
    "messagesGdprNotice": "Τα μηνύματα εδώ αποθηκεύονται και μπορεί να χρησιμοποιηθούν ως αποδεικτικό σε τυχόν διαφωνία για αυτή τη συμφωνία. Προτείνεται να συνεννοείστε για ό,τι αφορά τη συμφωνία μέσα από αυτό το chat, ώστε να έχετε αποδείξεις αν χρειαστεί να διαφωνήσετε.",
    "messagesGdprAck": "Ενημερώθηκα",
    "messagesFromBusiness": "από {{name}}",
    "messagesLoadError": "Δεν ήταν δυνατή η φόρτωση των μηνυμάτων.",
    "messagesSendError": "Το μήνυμα δεν στάλθηκε. Δοκίμασε ξανά.",
    "circleChatEmpty": "Στείλε μήνυμα στον/στην {{name}} μέσα από την εφαρμογή.",
    "circleChatPlaceholder": "Γράψε μήνυμα…",
    "circleChatBlockConfirmBody": "Δεν θα μπορείτε πλέον να στέλνετε μηνύματα μεταξύ σας. Μπορείς να το αναιρέσεις αργότερα.",
    "circleChatBlockedByMeNotice": "Έχεις αποκλείσει τον/την {{name}}. Δεν μπορείτε να στέλνετε μηνύματα μεταξύ σας.",
    "circleChatBlockedMeNotice": "Ο/Η {{name}} σε έχει αποκλείσει — δεν μπορείς να στείλεις μήνυμα.",
    "messagesClosedAgreement": "Η συμφωνία έχει ολοκληρωθεί — δεν μπορείς πια να στείλεις μηνύματα.",
    "messagesNeedsSignature": "Πρέπει πρώτα να υπογράψεις τη συμφωνία για να συμμετάσχεις στη συνομιλία.",
    "messagesDisputeLocked": "Η συνομιλία κλείδωσε όσο εκκρεμεί διαφωνία — οι κριτές μπορούν να τη δουν ανώνυμα ως αποδεικτικό.",
    "messagesYou": "Εσύ",
    "messagesSearchLabel": "Αναζήτηση στα μηνύματα",
    "messagesSearchPlaceholder": "Αναζήτηση λέξης…",
    "messagesTypingOne": "{{name}} πληκτρολογεί…",
    "messagesTypingMany": "{{names}} πληκτρολογούν…",
    "replyAction": "Απάντηση",
    "reportMessageAction": "Αναφορά μηνύματος",
    "messageOptionsAction": "Επιλογές μηνύματος",
    "blockUserAction": "Αποκλεισμός {{name}}",
    "reportModalTitle": "Γιατί αναφέρεις αυτό το μήνυμα;",
    "reportReason_spam": "Ανεπιθύμητο / Spam",
    "reportReason_offensive": "Προσβλητικό περιεχόμενο",
    "reportReason_scam": "Απάτη",
    "reportReason_harassment": "Παρενόχληση",
    "reportReason_other": "Άλλο",
    "reportNotePlaceholder": "Προαιρετικό σχόλιο…",
    "reportSubmit": "Αποστολή αναφοράς",
    "reportSentTitle": "Η αναφορά στάλθηκε",
    "reportSentBody": "Ευχαριστούμε — η ομάδα μας θα το εξετάσει.",
    "reportError": "Η αναφορά δεν στάλθηκε. Δοκίμασε ξανά.",
    "blockConfirmTitle": "Αποκλεισμός {{name}};",
    "blockConfirmBody": "Δεν θα μπορείτε πλέον να στέλνετε μηνύματα μεταξύ σας σε καμία κοινή συμφωνία. Μπορείς να το αναιρέσεις αργότερα.",
    "blockAction": "Αποκλεισμός",
    "blockError": "Κάτι πήγε στραβά. Δοκίμασε ξανά.",
    "unblockAction": "Άρση αποκλεισμού",
    "blockedByMeNotice": "Έχεις αποκλείσει τον/την {{name}}. Δεν μπορείτε να στέλνετε μηνύματα μεταξύ σας.",
    "blockedMeNotice": "Ο/Η {{name}} σε έχει αποκλείσει — δεν μπορείς να στείλεις μήνυμα σε αυτή τη συμφωνία.",
    "labelType": "Τύπος",
    "typeFixedTerm": "Ορισμένης διάρκειας",
    "typeOngoing": "Ανοιχτή / Αορίστου",
    "typeOneOff": "Εφάπαξ",
    "labelDuration": "Διάρκεια",
    "notSet": "Δεν ορίστηκε",
    "labelDate": "Ημερομηνία",
    "partiesCount": "Συμβαλλόμενοι ({{count}})",
    "creatorTag": "(δημιουργός)",
    "multiSignedWaitingOthers": "Υπέγραψες ✓ — αναμονή υπογραφής από τους υπόλοιπους.",
    "acceptBlame": "Αποδέχομαι ευθύνη",
    "disagree": "Διαφωνώ",
    "waitingAccusedResponse": "Αναμονή απάντησης από τον κατηγορούμενο…",
    "othersVoting": "Τα υπόλοιπα μέρη ψηφίζουν ποιος έχει δίκιο…",
    "juryReviewWaiting": "Η διαφωνία πέρασε σε κληρωτούς κριτές — θα ενημερωθείς μόλις αποφασίσουν.",
    "juryReviewBystander": "Κληρώθηκαν κριτές για αυτή τη διαφωνία (ένας εκ των οποίων μπορεί να είσαι κι εσύ — έλεγξε τα «Καθήκοντα Κριτή»).",
    "voteWhoIsRight": "Ψήφισε ποιος έχει δίκιο",
    "initiatorSays": "{{name}} λέει:",
    "initiatorFallback": "Ανοίγων",
    "accusedReplies": "{{name}} απαντά:",
    "accusedFallback": "Κατηγορούμενος",
    "neutralVote": "Ουδέτερος / Δεν γνωρίζω",
    "voteAlreadyCast": "Ψήφισες: {{name}}. Η ψήφος σου καταχωρήθηκε — περιμένουμε τους υπόλοιπους να ψηφίσουν.",
    "noMajorityAdminReview": "Δεν προέκυψε σαφής πλειοψηφία — η διαφωνία περιμένει κρίση από τη διαχείριση.",
    "outcomeEvidenceBased": "Η διαφωνία επιλύθηκε βάσει αντικειμενικών στοιχείων πληρωμών. Η συμφωνία ακυρώθηκε.",
    "outcomeVoteMajority": "Η ψηφοφορία των υπολοίπων μερών κατέληξε σε απόφαση. Η συμφωνία ακυρώθηκε.",
    "outcomePenaltyRespondent": "Ο κατηγορούμενος αποδέχτηκε την ευθύνη. Η συμφωνία ακυρώθηκε.",
    "outcomeDefault": "Η διαφωνία ολοκληρώθηκε. Η συμφωνία ακυρώθηκε.",
    "multiCommitmentIntro": "Οι συμβαλλόμενοι ({{names}}) δεσμεύονται αμοιβαία στην τήρηση των παρακάτω:",
    "creatorSavedChangesApprove": "Ο δημιουργός αποθήκευσε αλλαγές στη συμφωνία — τις εγκρίνεις;",
    "approve": "Εγκρίνω",
    "waitingFinalApproval": "Αναμονή τελικής έγκρισης των αλλαγών από {{name}}…",
    "editRequestPendingApproval": "Αίτημα επεξεργασίας σε αναμονή έγκρισης από {{name}}…",
    "editRequestTitle": "Αίτημα Επεξεργασίας: «{{note}}»",
    "approvalNoun": "Έγκριση",
    "editAgreementTitle": "Επεξεργασία Συμφωνίας",
    "editApprovedWaitingChanges": "Εγκρίθηκε το αίτημα — αναμονή αλλαγών από {{name}}…",
    "editRequestLinkLabel": "Αίτημα επεξεργασίας συμφωνίας",
    "termsAndConditionsOf": "Όροι & Προϋποθέσεις {{name}}",
    "signedByAllParties": "✓ Ψηφιακά υπογεγραμμένο από όλα τα μέρη",
    "completionRequestSent48h": "⏳ Αίτημα ολοκλήρωσης στάλθηκε στον/στην {{name}}. Αν δεν απαντήσει εντός 48 ωρών, η συμφωνία ολοκληρώνεται αυτόματα.",
    "freeSendNotice": "Η αποστολή είναι δωρεάν. Η χρέωση 1 μελάνι γίνεται μόνο αν συμφωνήσετε και οι δύο — τότε χρεώνεστε 1 μελάνι ο καθένας. Αν δεν κλείσει, δεν χρεώνεται κανείς.",
    "signedFreeWaitingActivation": "Υπέγραψες δωρεάν ✓ — Αναμονή υπογραφής από τον/την {{name}} για να ενεργοποιηθεί.",
    "inviteSentAutoLink": "Στάλθηκε πρόσκληση στο {{email}}. Θα συνδεθεί αυτόματα στη συμφωνία μόλις εγγραφεί με αυτό το email.",
    "sendingCompletionRequestIn": "Αποστολή αιτήματος ολοκλήρωσης σε {{count}}…",
    "paymentDeclaredConfirmQuestion": "{{article}} {{name}} δηλώνει εξόφληση — ισχύει όντως;",
    "confirmVerb": "Επιβεβαιώνω",
    "waitingPaymentConfirmation": "Αναμονή επιβεβαίωσης εξόφλησης από {{name}}…",
    "completionRequestConfirmQuestion": "{{article}} {{name}} ζητά την ολοκλήρωση της συμφωνίας — συμφωνείς;",
    "cancelRequestConfirmQuestion": "{{article}} {{name}} ζητά ακύρωση — συμφωνείς;",
    "doNotWantCancel": "Δεν επιθυμώ ακύρωση",
    "respondToDispute": "Απάντηση στη Διαφωνία",
    "manageDispute": "Διαχείριση Διαφωνίας",
    "awaitingMutualResolutionResponse": "Αναμένεις απόκριση για αμοιβαία επίλυση. {{article}} {{name}} έχει ως {{date}} να απαντήσει.",
    "respondToResolutionProposal": "Απόκριση σε Πρόταση Επίλυσης",
    "agreementIsStatus": "Η συμφωνία είναι «{{status}}».",
    "disputeEndedLeaveReview": "Η διαφωνία με {{name}} έληξε — άφησε την αξιολόγησή σου",
    "collaborationEndedLeaveReview": "Η συνεργασία με {{name}} τελείωσε — άφησε την αξιολόγησή σου",
    "reviewName": "Αξιολόγησε {{name}}",
    "allPartiesReviewed": "Αξιολόγησες όλους τους συμβαλλόμενους ✓",
    "disputeEndedLeaveReviews": "Η διαφωνία έληξε — άφησε τις αξιολογήσεις σου ({{count}} απομένουν)",
    "collaborationEndedLeaveReviews": "Η συνεργασία τελείωσε — άφησε τις αξιολογήσεις σου ({{count}} απομένουν)",
    "editRequestModalTitle": "Αίτημα Επεξεργασίας",
    "editRequestModalSubtitle": "Περίγραψε τι αλλαγές θέλεις στη συμφωνία.",
    "editRequestPlaceholder": "π.χ. Αλλαγή ποσού σε 250€ και νέα ημερομηνία λήξης",
    "whoIsDisputeAbout": "Ποιον αφορά η διαφωνία;",
    "openDispute": "Άνοιγμα Διαφωνίας",
    "termsDescriptionLabel": "Όροι / Περιγραφή",
    "labelAmountPlain": "Ποσό"
  },
  "offers": {
    "tab_label": "Προσφορές",
    "type_label": "Τύπος προσφοράς",
    "type_one_off": "Με ημ. λήξης",
    "type_one_off_sub": "Μία εργασία",
    "type_ongoing": "Διαρκής",
    "type_ongoing_sub": "Ανοιχτή συνεργασία",
    "type_fixed_term": "Από-Έως",
    "type_fixed_term_sub": "Καθορισμένη περίοδος",
    "title": "Προσφορές",
    "new": "Νέα Προσφορά",
    "received": "Ληφθείσες",
    "sent": "Απεσταλμένες",
    "accept": "Αποδοχή",
    "decline": "Απόρριψη",
    "withdraw": "Απόσυρση",
    "status": {
      "pending": "Εκκρεμής",
      "accepted": "Αποδεκτή",
      "declined": "Απορριφθείσα",
      "withdrawn": "Αποσυρθείσα",
      "expired": "Ληγμένη",
      "draft": "Πρόχειρο"
    },
    "fields": {
      "title": "Τίτλος",
      "description": "Περιγραφή",
      "amount": "Ποσό (€)",
      "expires_at": "Λήγει"
    },
    "empty_received": "Δεν έχεις λάβει προσφορές.",
    "empty_sent": "Δεν έχεις στείλει προσφορές.",
    "error_load": "Αδύνατη φόρτωση προσφοράς.",
    "confirm_decline": "Είσαι σίγουρος ότι θέλεις να απορρίψεις αυτή την προσφορά;",
    "confirm_withdraw": "Είσαι σίγουρος ότι θέλεις να αποσύρεις αυτή την προσφορά;",
    "notFound": "Η προσφορά δεν βρέθηκε.",
    "noDescription": "Χωρίς περιγραφή",
    "expired": "Έληξε",
    "declined": "Απορρίφθηκε",
    "closedByOther": "Έκλεισε με άλλον",
    "from": "Από",
    "expiresIn_one": "Λήγει σε 1 μέρα",
    "expiresIn_other": "Λήγει σε {{count}} μέρες",
    "deliveryDays": "{{count}} μέρες παράδοση",
    "acceptanceInfo": "Η αποδοχή θα δημιουργήσει αυτόματα συμφωνία Χειραψία.",
    "waitingForAcceptance": "Αναμονή αποδοχής από την άλλη πλευρά…",
    "acceptedSuccess": "Η προσφορά αποδεκτή! Η συμφωνία δημιουργήθηκε.",
    "acceptedWaiting": "Αποδέχτηκες. Αναμονή υπογραφής από τον δημιουργό.",
    "inkInfo": "Ο πελάτης υπογράφει δωρεάν, εσύ τελευταίος με 1 μελάνι.",
    "created_title": "Η προσφορά δημιουργήθηκε!",
    "created_body": "Μοιράσου τον παρακάτω σύνδεσμο ώστε η άλλη πλευρά να την αποδεχτεί.",
    "shareFromLine": "Προσφορά από {{name}}",
    "share_invite_code": "\nΚωδικός πρόσβασης: {{code}}",
    "emailSent": "Το email στάλθηκε στον παραλήπτη.",
    "field_title": "Τίτλος εργασίας",
    "field_recipient": "Αποδέκτης (προαιρετικό)",
    "field_cost": "Κόστος (€)",
    "field_deliveryTime": "Χρόνος παράδοσης",
    "field_descriptionOptional": "Περιγραφή υπηρεσίας (προαιρετική)",
    "field_description": "Περιγραφή υπηρεσίας",
    "section_description": "Περιγραφή",
    "section_terms": "Όροι & Προϋποθέσεις",
    "section_declineReason": "Λόγος απόρριψης",
    "field_cost_label": "Κόστος",
    "field_delivery_label": "Παράδοση",
    "days_suffix": "μέρες",
    "review_title": "Σύνοψη προσφοράς",
    "review_titleLabel": "Τίτλος",
    "review_recipientLabel": "Αποδέκτης",
    "review_costLabel": "Κόστος",
    "review_deliveryLabel": "Παράδοση",
    "review_descriptionLabel": "Περιγραφή",
    "action_accept": "Αποδοχή Προσφοράς",
    "action_withdrawDraft": "Ανάκληση σε πρόχειρο",
    "action_reuseAsDraft": "Επανάχρηση ως πρόχειρο",
    "action_shareLink": "Αντιγραφή / Κοινοποίηση συνδέσμου",
    "action_resendEmail": "Επαναποστολή email",
    "action_viewAgreement": "Προβολή συμφωνίας",
    "action_send": "Αποστολή Προσφοράς",
    "confirmAccept_title": "Αποδοχή Προσφοράς",
    "confirmAccept_message": "Θα δημιουργηθεί αυτόματα συμφωνία Χειραψία.",
    "confirmAccept_label": "Αποδέχομαι",
    "decline_title": "Απόρριψη Προσφοράς",
    "decline_subtitle": "Εξήγησε σύντομα γιατί απορρίπτεις.",
    "shareLink_label": "Στείλε το link της προσφοράς",
    "copy_chip": "Αντιγραφή",
    "other_chip": "Άλλο",
    "withdraw_title": "Ανάκληση προσφοράς",
    "withdraw_message": "Είσαι σίγουρος ότι θέλεις να αποσύρεις αυτή την προσφορά;",
    "withdraw_confirm": "Ανάκληση",
    "link_copied_title": "Αντιγράφηκε",
    "link_copied_body": "Το link της προσφοράς αντιγράφηκε στο πρόχειρο.",
    "resent_title": "Εστάλη",
    "resent_body": "Το email στάλθηκε ξανά στο {{email}}.",
    "incoming_title": "Εισερχόμενες Προσφορές",
    "incoming_empty_title": "Δεν έχεις εισερχόμενες προσφορές",
    "incoming_empty_body": "Εδώ θα εμφανίζονται προσφορές που σου έχουν στείλει άλλοι χρήστες.",
    "sent_title_screen": "Προσφορές μου",
    "sent_empty_title": "Δεν έχεις στείλει ακόμη προσφορά",
    "sent_empty_body": "Δημιούργησε μια νέα προσφορά για να ξεκινήσεις.",
    "filter_all": "Όλες",
    "filter_empty": "Καμία προσφορά με αυτό το φίλτρο."
  },
  "offersScreens": {
    "currencyLabel": "Νόμισμα",
    "errorRecipientNameRequired": "Το ονοματεπώνυμο του παραλήπτη είναι υποχρεωτικό.",
    "recipientNameLabel": "Ονοματεπώνυμο παραλήπτη",
    "recipientNamePlaceholder": "π.χ. Γιώργος Παπαδόπουλος",
    "offerAddressedTo": "Προσφορά προς: {{name}}",
    "printOrSendOffer": "Εκτύπωση / Αποστολή προσφοράς",
    "printFailed": "Η εκτύπωση της προσφοράς απέτυχε.",
    "printAgainButton": "Εκτύπωση / Αποθήκευση PDF προσφοράς",
    "coach1_title": "Τίτλος εργασίας",
    "coach1_text": "Σύντομο, περιγραφικό όνομα για την εργασία σου. Π.χ. «Κατασκευή ιστοσελίδας». Ο πελάτης το βλέπει ως επικεφαλίδα της προσφοράς.",
    "coach2_title": "Περιγραφή υπηρεσίας",
    "coach2_text": "Τι ακριβώς παρέχεις, τι περιλαμβάνεται και τι εξαιρείται. Όσο πιο αναλυτική η περιγραφή, τόσο λιγότερες παρεξηγήσεις με τον πελάτη.",
    "coach3_title": "Κόστος (€)",
    "coach3_text": "Το συνολικό ποσό της εργασίας σε ευρώ. Μπορείς να το αφήσεις κενό αν δεν έχεις ακόμα καταλήξει σε τιμή.",
    "coach4_title": "Χρόνος παράδοσης",
    "coach4_text": "Σε πόσες ημέρες θα παραδώσεις το έργο μετά την έναρξη της συνεργασίας. Ο πελάτης θα δει αυτή την πληροφορία πριν υπογράψει.",
    "coach5_title": "Αποστολή σε πελάτη",
    "coach5_text": "Αναζήτησε με όνομα αν ο πελάτης είναι ήδη στη Χειραψία (θα λάβει notification), ή γράψε email για εξωτερικό πελάτη (θα λάβει σύνδεσμο).",
    "coachSkip": "Παράλειψη",
    "coachNext": "Επόμενο →",
    "coachStart": "Ξεκινάμε ✓",
    "saveTemplateFailed": "Η αποθήκευση προτύπου απέτυχε.",
    "replaceTemplateFailed": "Η αντικατάσταση απέτυχε.",
    "saveAsTemplateTitle": "Αποθήκευση ως πρότυπο;",
    "saveAsTemplateMessage": "Θες να αποθηκευτεί και σαν πρότυπο αυτή η προσφορά, για να τη χρησιμοποιείς ξανά αλλάζοντας μόνο τον παραλήπτη;",
    "createOfferFailed": "Αποτυχία δημιουργίας προσφοράς.",
    "duplicateBusinessOffer": "Ο συνέταιρός σου {{name}} έχει ήδη στείλει προσφορά σε αυτόν τον πελάτη/αίτημα — απόφυγε διπλή προσφορά από την ίδια επιχείρηση.",
    "successBody": "Στείλε τον σύνδεσμο στον πελάτη. Μόλις υπογράψει, θα λάβεις ειδοποίηση να υπογράψεις κι εσύ.",
    "successBodyRegistered": "Στάλθηκε στον/στην {{name}} — θα ενημερωθεί μέσα στην εφαρμογή. Αν θέλεις, μπορείς επίσης να στείλεις τον σύνδεσμο ή να την εκτυπώσεις για να τη δώσεις από κοντά.",
    "emailSentTo": "Email προσφοράς στάλθηκε στο {{email}}",
    "templateNameTitle": "Όνομα προτύπου",
    "templateNameLabel": "Όνομα",
    "templateNamePlaceholder": "π.χ. Βασική προσφορά ιστοσελίδας",
    "hasThreeTemplatesTitle": "Έχεις ήδη 3 πρότυπα",
    "chooseTemplateToReplace": "Επίλεξε ποιο θες να αντικαταστήσεις:",
    "newOfferTitle": "Νέα προσφορά",
    "entryChoiceSubtitle": "Θες να ξεκινήσεις από την αρχή ή να χρησιμοποιήσεις ένα αποθηκευμένο πρότυπο;",
    "entryNewTitle": "Νέα προσφορά",
    "entryNewSub": "Ξεκίνα από κενή φόρμα.",
    "entryTemplateTitle": "Χρήση προτύπου",
    "entryTemplateSub_one": "{{count}} αποθηκευμένο — άλλαξε μόνο τον παραλήπτη.",
    "entryTemplateSub_other": "{{count}} αποθηκευμένα — άλλαξε μόνο τον παραλήπτη.",
    "manageTemplates": "Διαχείριση προτύπων",
    "chooseTemplateTitle": "Επίλεξε πρότυπο",
    "titlePlaceholder": "π.χ. Κατασκευή ιστοσελίδας",
    "recipientPlaceholder": "Όνομα ή email πελάτη…",
    "recipientHintUser": "Χρήστης Χειραψία — θα λάβει ειδοποίηση.",
    "recipientHintSearch": "Αναζήτησε με όνομα ή γράψε email. Μπορείς να το παρακάμψεις.",
    "offerKindLabel": "Τύπος προσφοράς",
    "offerKindService": "Υπηρεσία",
    "offerKindGoods": "Εμπόρευμα",
    "sendAsLabel": "Αποστολή ως",
    "sendAsMe": "Εγώ",
    "sendAsBusiness": "Η επιχείρηση",
    "costPlaceholder": "π.χ. 500",
    "vatLabel": "ΦΠΑ",
    "vatWithout": "Χωρίς ΦΠΑ",
    "vatWith": "Με ΦΠΑ",
    "vatRateLabel": "ΦΠΑ %",
    "vatRatePlaceholder": "π.χ. 24",
    "priceWithoutVat": "Τιμή (χωρίς ΦΠΑ)",
    "finalPriceWithVat": "Τελική τιμή (με ΦΠΑ)",
    "vatAmountLabel": "ΦΠΑ ({{rate}}%)",
    "totalWithoutVat": "Σύνολο (χωρίς ΦΠΑ)",
    "finalTotalWithVat": "Τελικό Σύνολο (με ΦΠΑ)",
    "subtotalLabel": "Σύνολο",
    "discountLabel": "-Έκπτωση",
    "deliveryDaysPlaceholder": "π.χ. 7",
    "daysSuffix": "μέρες",
    "startDateLabel": "Ημερομηνία έναρξης",
    "endDateLabel": "Ημερομηνία λήξης",
    "durationHint": "Διάρκεια: {{days}} ημέρες.",
    "serviceDescriptionPlaceholder": "Αναλυτική περιγραφή του τι παρέχεις…",
    "goodsDescriptionPlaceholder": "Επιπλέον σημειώσεις για την παραγγελία…",
    "productTitle": "Προϊόν {{index}}",
    "productDescriptionLabel": "Περιγραφή προϊόντος",
    "productDescriptionPlaceholder": "π.χ. Σακίδιο πλάτης μοντέλο X",
    "productQuantityLabel": "Τεμάχια",
    "productUnitPriceLabel": "Τιμή μονάδας €",
    "productDiscountLabel": "Έκπτωση",
    "addProduct": "Νέο προϊόν",
    "reviewTypeLabel": "Τύπος",
    "reviewPeriodLabel": "Περίοδος",
    "finalPriceWithVatTag": "{{cost}} € (με ΦΠΑ)",
    "finalPriceLabel": "Τελική τιμή",
    "errorTitleRequired": "Δώσε τίτλο στην προσφορά.",
    "errorProductsRequired": "Συμπλήρωσε περιγραφή, τεμάχια (>0) και τιμή για κάθε προϊόν.",
    "errorDescriptionRequired": "Συμπλήρωσε περιγραφή.",
    "errorInvalidAmount": "Μη έγκυρο ποσό.",
    "errorInvalidDays": "Μη έγκυρος αριθμός ημερών.",
    "errorStartDateRequired": "Επίλεξε ημερομηνία έναρξης.",
    "errorEndDateRequired": "Επίλεξε ημερομηνία λήξης.",
    "errorEndAfterStart": "Η λήξη πρέπει να είναι μετά την έναρξη.",
    "errorInvalidEmail": "Μη έγκυρο email.",
    "errorLoadFailed": "Αποτυχία φόρτωσης.",
    "errorAcceptFailed": "Αποτυχία αποδοχής.",
    "errorDeclineFailed": "Αποτυχία απόρριψης.",
    "shareCodeLine": "\nΚωδικός πρόσβασης: {{code}}",
    "shareOfferText": "Σου έστειλα επαγγελματική προσφορά «{{title}}» μέσω Χειραψία:",
    "errorResendFailed": "Αποτυχία αποστολής.",
    "resentTitle": "Εστάλη",
    "resentBody": "Το email στάλθηκε ξανά στο {{email}}.",
    "errorResendEmailFailed": "Αποτυχία αποστολής email.",
    "errorWithdrawFailed": "Αποτυχία ανάκλησης.",
    "errorCloneFailed": "Αποτυχία κλωνοποίησης.",
    "goodsSectionTitle": "Εμπορεύματα",
    "finalTotalLabel": "Τελικό Σύνολο",
    "resendEmailButton": "Επαναποστολή email στο {{email}}",
    "declineReasonPlaceholder": "π.χ. Το κόστος δεν ταιριάζει στο budget μου",
    "loadFailed": "Η φόρτωση απέτυχε.",
    "renameFailed": "Η μετονομασία απέτυχε.",
    "deleteFailed": "Η διαγραφή απέτυχε.",
    "deleteTemplateTitle": "Διαγραφή προτύπου",
    "deleteTemplateMessage": "Θέλεις σίγουρα να διαγράψεις το «{{name}}»;",
    "templatesTitle": "Πρότυπα προσφορών",
    "noTemplatesTitle": "Δεν έχεις αποθηκευμένα πρότυπα",
    "noTemplatesBody": "Όταν δημιουργείς μια προσφορά, μπορείς να την αποθηκεύσεις ως πρότυπο για να την ξαναχρησιμοποιείς.",
    "templatesCountHint": "{{count}}/{{max}} πρότυπα",
    "productCount_one": "{{count}} προϊόν — {{total}}€",
    "productCount_other": "{{count}} προϊόντα — {{total}}€",
    "noSetCost": "Χωρίς καθορισμένο κόστος",
    "useAction": "Χρήση",
    "renameAction": "Μετονομασία",
    "deleteAction": "Διαγραφή",
    "renameTemplateTitle": "Μετονομασία προτύπου",
    "templateNameFieldPlaceholder": "Όνομα προτύπου"
  },
  "contactsMatch": {
    "title": "Επαφές στη Χειραψία",
    "homeBannerFind": "Επαφές μου στη Χειραψία",
    "homeBannerCount_one": "{{count}} επαφή σου είναι ήδη στη Χειραψία",
    "homeBannerCount_other": "{{count}} επαφές σου είναι ήδη στη Χειραψία",
    "homeChipFind": "Επαφές",
    "homeChipCount_one": "{{count}} επαφή",
    "homeChipCount_other": "{{count}} επαφές",
    "outsideCircleBanner_one": "{{count}} από τις επαφές σου είναι εκτός κύκλου σου!",
    "outsideCircleBanner_other": "{{count}} από τις επαφές σου είναι εκτός κύκλου σου!",
    "circleDiscoverBanner": "Ποιες επαφές σου είναι ήδη στη Χειραψία; 🔎",
    "explainerTitle": "Πρόσβαση στις επαφές σου",
    "explainerIntro": "Για να σου δείξουμε ποιοι φίλοι σου είναι ήδη στη Χειραψία, χρειαζόμαστε πρόσβαση στις επαφές της συσκευής σου.",
    "explainerWhat": "Τι διαβάζουμε: τα ονόματα και τους αριθμούς τηλεφώνου των επαφών σου.",
    "explainerWhy": "Γιατί: για να δούμε ποιοι από αυτούς έχουν ήδη λογαριασμό στη Χειραψία, ώστε να τους προσθέσεις εύκολα στον Κύκλο σου.",
    "explainerHow": "Πώς: οι αριθμοί τηλεφώνου στέλνονται με ασφαλή κρυπτογραφημένη σύνδεση μόνο για τη σύγκριση — δεν αποθηκεύονται μόνιμα στους διακομιστές μας.",
    "explainerAgree": "Συμφωνώ",
    "explainerDecline": "Όχι ευχαριστώ",
    "permissionDenied": "Δεν δόθηκε πρόσβαση στις επαφές. Μπορείς να την ενεργοποιήσεις από τις ρυθμίσεις της συσκευής.",
    "loadError": "Αδυναμία φόρτωσης επαφών.",
    "empty": "Δε βρέθηκαν επαφές σου στη Χειραψία.",
    "connect": "Αίτημα",
    "connected": "Στον κύκλο σου",
    "pending": "Στάλθηκε",
    "pendingReceived": "Σε προσκάλεσε"
  },
  "circle": {
    "tab_label": "Κύκλος",
    "title": "Κύκλος",
    "my_circle": "Ο κύκλος μου",
    "search_placeholder": "Αναζήτηση χρήστη...",
    "no_connections": "Δεν έχεις ακόμα επαφές.",
    "request_sent": "Αίτημα εστάλη",
    "connected": "Συνδεδεμένος",
    "connect": "Σύνδεση",
    "pending": "Σε αναμονή",
    "accept": "Αποδοχή",
    "decline": "Απόρριψη",
    "remove": "Αφαίρεση από κύκλο",
    "view_profile": "Προφίλ",
    "new_agreement": "Νέα Συμφωνία",
    "new_offer": "Νέα Προσφορά",
    "me": "Εγώ",
    "connectionCount": "{{count}} συνδ.",
    "connectionRequests": "Αιτήματα σύνδεσης ({{count}})",
    "newAnnouncement": "Νέα ανακοίνωση",
    "announcement": "Κάνε μια\nανακοίνωση",
    "outsideCircle": "εκτός κύκλου",
    "userNotFound": "Δεν βρέθηκε χρήστης",
    "stats": "{{connections}} επαφές · {{mutual}} αμοιβαίες συνδέσεις μεταξύ τους",
    "empty_title": "Ο κύκλος σου είναι άδειος",
    "empty_body": "Πρόσθεσε επαφές για να τις βλέπεις εδώ.",
    "action_findUsers": "Βρες χρήστες",
    "action_newAgreement": "+ Συμφωνία",
    "action_sendOffer": "Αποστολή προσφοράς",
    "filter_all": "Όλοι",
    "filter_activeAgreement": "Ενεργή συμφωνία",
    "filter_professionals": "Επαγγελματίες",
    "badge_professional": "Επαγγελματίας",
    "filter_recent": "Πρόσφατοι",
    "retry": "Επανάληψη",
    "tab_contacts": "Επαφές",
    "tab_feed": "Αναρτήσεις",
    "feed_empty": "Δεν υπάρχουν ακόμα αναρτήσεις επαγγελματιών στον κύκλο σου.",
    "pro_notice": "Εμφανίζονται όλοι οι επαγγελματίες με Δημόσιο προφίλ",
    "facet_services": "Υπηρεσίες",
    "facet_eshop": "Με eShop",
    "facet_physical_only": "Φυσικό κατάστημα",
    "map_expand": "Πάτα για να μεγαλώσει ο χάρτης",
    "map_collapse": "Σμίκρυνση χάρτη",
    "sonar_nearestRegion": "Δεν βρέθηκαν επαγγελματίες στον νομό σου — δείχνουμε τον πλησιέστερο: {{region}}",
    "sonar_noneNearby": "Δεν βρέθηκαν επαγγελματίες κοντά σου.",
    "sonar_seeAll": "Δες όλη την Ελλάδα",
    "sonar_openMap": "Άνοιξε τον χάρτη",
    "sonar_scanning": "Σαρώνουμε για επαγγελματίες κοντά σου...",
    "intro_title": "Βρες επαγγελματίες",
    "intro_map": "Δες τους επαγγελματίες σε χάρτη ανά νομό, ή σε λίστα.",
    "intro_facets": "Φιλτράρισε με capsules: Υπηρεσίες, eShop, φυσικό κατάστημα.",
    "intro_sonar": "Αυτόματα σου δείχνουμε τον νομό σου — αν δεν έχει επαγγελματίες, σκανάρουμε τους πλησιέστερους.",
    "intro_requests": "Στην καρτέλα «Αιτήματα Προσφοράς» μπορείς να ζητήσεις αυτό που χρειάζεσαι και να δεχτείς προσφορές.",
    "intro_gotIt": "Κατάλαβα",
    "pro_empty": "Δεν βρέθηκαν επαγγελματίες με αυτά τα κριτήρια.",
    "pro_resultsCount": "Βρέθηκαν {{count}} αποτελέσματα.",
    "pro_completedCount": "{{count}} ολοκληρωμένες",
    "pro_sponsored": "Προωθημένο",
    "filters": "Φίλτρα",
    "filtersRegion": "Φίλτρα Περιοχή",
    "showResults": "Εμφάνιση",
    "filter_region": "Νομός",
    "filter_profession": "Επάγγελμα",
    "filter_professionAll": "Όλα",
    "filter_apply": "Εφαρμογή",
    "viewAnnouncement": "Προβολή ανακοίνωσης",
    "zoomIn": "Μεγέθυνση",
    "zoomOut": "Σμίκρυνση",
    "stats_connections_one": "{{count}} επαφή",
    "stats_connections_other": "{{count}} επαφές",
    "stats_mutual_one": " · {{count}} αμοιβαία σύνδεση μεταξύ τους",
    "stats_mutual_other": " · {{count}} αμοιβαίες συνδέσεις μεταξύ τους",
    "time_justNow": "μόλις τώρα",
    "time_minutesAgo": "πριν από {{count}} λ.",
    "time_hoursAgo": "πριν από {{count}} ω.",
    "time_daysAgo": "πριν από {{count}} μέρ."
  },
  "profile": {
    "title": "Προφίλ",
    "edit_title": "Επεξεργασία προφίλ",
    "full_name": "Ονοματεπώνυμο",
    "bio": "Βιογραφικό",
    "phone": "Τηλέφωνο",
    "specialty": "Ειδικότητα",
    "business_name": "Επωνυμία",
    "contact_email": "Email επικοινωνίας",
    "signature": "Υπογραφή",
    "save": "Αποθήκευση αλλαγών",
    "saved": "Οι αλλαγές αποθηκεύτηκαν.",
    "avatar_change": "Άλλαξε φωτογραφία",
    "adminControls": "Admin controls",
    "logo_change": "Άλλαξε λογότυπο",
    "verified": "Επαληθευμένος",
    "not_verified": "Μη επαληθευμένος",
    "level": "Επίπεδο {{level}}",
    "agreements_count": "{{count}} συμφωνίες",
    "reviews": "Αξιολογήσεις",
    "no_reviews": "Δεν υπάρχουν αξιολογήσεις ακόμα.",
    "portfolio": "Portfolio",
    "portfolio_empty": "Δεν υπάρχουν ανακοινώσεις.",
    "signature_locked_hint": "Χρειάζεσαι περισσότερο μελάνι για να ξεκλειδώσεις την υπογραφή σου.",
    "section_professional": "Λογαριασμός Επαγγελματία",
    "tab_personal": "Προσωπικό",
    "tab_professional": "Επαγγελματικό",
    "signatureLocked_title": "Υπογραφή κλειδωμένη",
    "signatureLocked_body": "Χρειάζεσαι περισσότερο μελάνι για να υπογράψεις.",
    "signature_welcome": "Σχεδίασε την υπογραφή σου παρακάτω",
    "portfolio_enable": "Ενεργοποίηση σελίδας portfolio",
    "portfolio_public": "Δημόσιο",
    "portfolio_private": "Κρυφό",
    "portfolio_showBusiness": "Εμφάνιση ονόματος επιχείρησης στο προφίλ",
    "portfolio_useLogo": "Χρήση λογοτύπου ως εικόνα προφίλ",
    "field_firstName": "Όνομα",
    "field_lastName": "Επώνυμο",
    "field_phone": "Κινητό τηλέφωνο",
    "field_specialty": "Ειδικότητα (προαιρετικό)",
    "field_businessName": "Όνομα Επιχείρησης (προαιρετικό)",
    "field_businessLogo": "Λογότυπο επιχείρησης (προαιρετικό)",
    "action_newSignature": "Νέα υπογραφή",
    "action_removeSignature": "Αφαίρεση υπογραφής",
    "action_addSignature": "Προσθήκη υπογραφής",
    "action_saveChanges": "Αποθήκευση αλλαγών",
    "action_saveShort": "Αποθήκευση",
    "action_addLogo": "Προσθήκη λογοτύπου",
    "action_viewPortfolio": "Δες πώς φαίνεται το portfolio σου",
    "action_setupAccount": "Ρύθμιση Λογαριασμού",
    "sponsor_title": "Προώθηση προφίλ",
    "sponsor_body": "Εμφανίσου πιο ψηλά στη λίστα αναζήτησης επαγγελματιών, πληρώνοντας με μελάνια — χρέωση ανά ημέρα, χωρίς προπληρωμή.",
    "sponsor_activeRegional": "Ενεργή προβολή στον νομό σου, {{rate}} μελάνια/ημέρα.",
    "sponsor_activeNationwide": "Ενεργή προβολή παντού, {{rate}} μελάνια/ημέρα.",
    "sponsor_actionStart": "Ξεκίνα προώθηση",
    "sponsor_actionEdit": "Αλλαγή τιμής / επιπέδου",
    "sponsor_actionUpdate": "Ενημέρωση προώθησης",
    "sponsor_actionCancel": "Απενεργοποίηση προώθησης",
    "sponsor_modalTitle": "Προώθηση προφίλ",
    "sponsor_modalHint": "Οι προωθημένοι επαγγελματίες εμφανίζονται πρώτοι στα αποτελέσματα αναζήτησης, με ένδειξη \"Προωθημένο\". Η κατάταξη μεταξύ τους καθορίζεται από την ημερήσια τιμή τους — όποιος πληρώνει περισσότερο εμφανίζεται πρώτος.",
    "sponsor_tierRegional": "Στον νομό μου ({{region}})",
    "sponsor_tierNoRegion": "χρειάζεται νομός",
    "sponsor_tierNationwide": "Παντού",
    "sponsor_pricePerDayFrom": "από {{amount}} μελάνια/ημέρα",
    "sponsor_rateLabel": "Η ημερήσια τιμή σου",
    "sponsor_ratePlaceholder": "Μελάνια/ημέρα",
    "sponsor_perDay": "/ημέρα",
    "sponsor_outbid": "Ξεπέρασε τον πρώτο ({{amount}} μελάνια/ημέρα)",
    "sponsor_nightlyNote": "Καμία προπληρωμή — χρεώνεσαι κάθε βράδυ για την επόμενη μέρα. Αν δεν επαρκεί το μελάνι σου, η προώθηση σταματάει αυτόματα.",
    "sponsor_confirm": "Ενεργοποίηση προώθησης",
    "sponsor_errorMinRate": "Η ελάχιστη ημερήσια τιμή είναι {{amount}} μελάνια.",
    "sponsor_errorGeneric": "Η προώθηση απέτυχε.",
    "sponsor_whereTitle": "Πού θα εμφανίζεσαι",
    "sponsor_whereListRegion": "Πρώτος στα αποτελέσματα αναζήτησης στον νομό {{region}}",
    "sponsor_whereListEverywhere": "Πρώτος στα αποτελέσματα αναζήτησης σε όλους τους νομούς",
    "sponsor_whereBanner": "Στο κυλιόμενο banner της «Βρες επαγγελματίες», για όσους βλέπουν τον νομό {{region}}",
    "action_changeLogo": "Αλλαγή",
    "verifyHint": "Επαλήθευσε το κινητό σου για να αυξήσεις την αξιοπιστία σου.",
    "otpSent": "Στάλθηκε SMS. Πληκτρολόγησε τον 6-ψήφιο κωδικό.",
    "uploading": "Μεταφόρτωση…",
    "tapToChange": "Πάτησε για αλλαγή",
    "addSignature": "Προσθήκη υπογραφής",
    "wizard_step1_title": "Στοιχεία επιχείρησης",
    "wizard_step1_subtitle": "Πες μας για την επιχείρησή σου.",
    "wizard_step2_title": "Λογότυπο",
    "wizard_step2_subtitle": "Πρόσθεσε λογότυπο επιχείρησης.",
    "wizard_step3_title": "Επισκόπηση",
    "wizard_step3_subtitle": "Έλεγξε πριν αποθηκεύσεις.",
    "setupWizard_step1_title": "Ταυτότητα",
    "setupWizard_step1_subtitle": "Πες μας τι κάνεις και πού βρίσκεσαι.",
    "setupWizard_step2_title": "Λογότυπο",
    "setupWizard_step2_subtitle": "Πρόσθεσε λογότυπο επιχείρησης (προαιρετικό).",
    "setupWizard_step3_title": "Στοιχεία επικοινωνίας",
    "setupWizard_step3_subtitle": "Πώς θα σε βρίσκουν οι πελάτες.",
    "setupWizard_step4_title": "Πληρωμές & eShop",
    "setupWizard_step4_subtitle": "Τρόποι πληρωμής και online κατάστημα, αν υπάρχει.",
    "setupWizard_step5_title": "Όροι & Συνεργάτες",
    "setupWizard_step5_subtitle": "Οι όροι σου, και αν δουλεύεις με συνεταίρους.",
    "setupWizard_step6_title": "Επισκόπηση",
    "setupWizard_partnersQuestion": "Δουλεύεις μόνος ή έχεις συνεταίρους;",
    "setupWizard_worksAlone": "Δουλεύω μόνος",
    "setupWizard_hasPartners": "Έχω συνεταίρους",
    "setupWizard_alreadyInBusiness": "Είσαι μέλος της επιχείρησης «{{business}}».",
    "setupWizard_paymentsHint": "Βάλε τους τρόπους με τους οποίους δέχεσαι πληρωμές, και προαιρετικά τη σελίδα του eShop σου, αν έχεις.",
    "business_needNameFirst": "Συμπλήρωσε πρώτα το όνομα της επιχείρησης στο βήμα «Ταυτότητα».",
    "review_business": "Επιχείρηση",
    "review_specialty": "Ειδικότητα",
    "review_visibility": "Ορατότητα",
    "review_logo": "Λογότυπο",
    "saving_portfolio": "Αποθήκευση…",
    "complete_portfolio": "Ολοκλήρωση",
    "hint_fullName": "Όπως αναγράφεται στην ταυτότητά σου — εμφανίζεται στις συμφωνίες που υπογράφεις.",
    "hint_phone": "Δεν εμφανίζεται δημόσια. Χρησιμοποιείται για επαλήθευση ταυτότητας.",
    "hint_phone_icon": "Δημιουργεί ένα εικονίδιο επικοινωνίας στο προφίλ σας για διευκόλυνση της επικοινωνίας με άτομα του κύκλου σας.",
    "hint_phone_noVerify": "Λειτουργεί και χωρίς επαλήθευση κινητού.",
    "info_fullName": "Το ονοματεπώνυμο πρέπει να είναι όπως στην ταυτότητά σου — εμφανίζεται στις συμφωνίες που υπογράφεις και στο πλήρες προφίλ σου. Στις αναζητήσεις και τον Κύκλο θα εμφανίζεται το «Με γνωρίζουν και ως…» + το επώνυμό σου.",
    "info_signature": "Η υπογραφή σου χρησιμοποιείται για ψηφιακή υπογραφή συμφωνιών.",
    "info_portfolio": "Το portfolio σου είναι η δημόσια επαγγελματική σου σελίδα.",
    "info_portfolioPublic": "Το portfolio σου είναι ορατό σε όλους.",
    "info_portfolioPrivate": "Το portfolio σου είναι ορατό μόνο στον κύκλο σου.",
    "alert_signatureSaved": "Η υπογραφή σου αποθηκεύτηκε.",
    "alert_signatureRemoved": "Η υπογραφή αφαιρέθηκε.",
    "alert_profileSaved_title": "Αποθηκεύτηκε",
    "alert_profileSaved_body": "Το προφίλ σου ενημερώθηκε.",
    "verify_banner_title": "Επαλήθευση Ταυτότητας",
    "verify_banner_sub": "Χωρίς επαλήθευση το ανώτατο όριο αξιοπιστίας είναι έως 80% — με φωτογραφία ταυτότητας ανεβαίνει έως 100%",
    "section_verifications": "Επαληθεύσεις",
    "verify_identity_title": "Επαλήθευση Ταυτότητας",
    "verify_identity_sub": "Τώρα το ανώτατο όριο αξιοπιστίας σου είναι έως 80% — ανέβασε φωτογραφία ταυτότητας για να ανέβει έως 100%",
    "verify_done": "Ολοκληρώθηκε ✓",
    "phone_verified": "Επαληθ. κινητό",
    "level2_pill": "Επ.2 Ταυτότητα",
    "comm_title": "Τρόποι Επικοινωνίας",
    "providesBadge": "Παρέχει Υπηρεσίες",
    "signaturePadPlaceholder": "Ζωγράφισε την υπογραφή σου εδώ ✍️",
    "tour_signature_title": "Φτιάξε την υπογραφή σου ✍️",
    "tour_phone_title": "Επαλήθευση κινητού",
    "verify_identity_pending": "Σε αναμονή επαλήθευσης",
    "error_uploadFailed": "Η μεταφόρτωση απέτυχε.",
    "error_logoUploadFailed": "Η μεταφόρτωση λογοτύπου απέτυχε.",
    "error_saveFailed": "Η αποθήκευση απέτυχε.",
    "business_sectionTitle": "Επιχείρηση (συνέταιροι)",
    "business_info": "Αν η επιχείρησή σου έχει 2+ συνεταίρους, μπορείτε να μοιράζεστε ένα κοινό επαγγελματικό προφίλ — ίδιο rating και ολοκληρωμένες συμφωνίες συγκεντρωτικά, αντί να το προσθέτει ο καθένας ξεχωριστά.",
    "business_create": "Δημιούργησε επιχείρηση με συνεταίρους",
    "business_createHint": "Θα γίνεις ιδιοκτήτης — μπορείς να προσκαλέσεις συνεταίρους μετά.",
    "business_invitePartner": "Πρόσκληση συνεταίρου",
    "business_searchPartnerPlaceholder": "Αναζήτηση με όνομα...",
    "business_inviteByEmail": "Πρόσκληση στο {{email}}",
    "business_inviteByEmailHint": "Δεν βρέθηκε στη Χειραψία — θα του σταλεί email πρόσκλησης.",
    "business_inviteSent": "Η πρόσκληση στάλθηκε.",
    "business_inviteReceived": "{{name}} σε προσκάλεσε στην επιχείρηση «{{business}}».",
    "business_you": "εσύ",
    "business_owner": "Ιδιοκτήτης",
    "business_showsAsBusinessBadge": "Ενεργή στην αναζήτηση",
    "identityPicker_title": "Ενεργό επάγγελμα στην αναζήτηση",
    "identityPicker_hint": "Επίλεξε με ποια ταυτότητα θέλεις να εμφανίζεσαι στη λίστα αναζήτησης επαγγελματιών.",
    "identityPicker_personal": "Βασικό επάγγελμα",
    "businessAddress_public": "Δημόσια ορατή διεύθυνση",
    "businessAddress_private": "Ιδιωτική διεύθυνση (μόνο εσύ)",
    "business_ownedTag": "Η δική σου επιχείρηση",
    "business_partnerTag": "Συμμετέχεις ως συνέταιρος",
    "business_equityPlaceholder": "Ποσοστό συμμετοχής % (προαιρετικό)",
    "business_invitedPending": "Προσκλήθηκε",
    "business_leaveAction": "Αποχώρηση από την επιχείρηση",
    "business_leaveConfirmTitle": "Αποχώρηση επιχείρησης;",
    "business_leaveConfirmBody": "Θα αποχωρήσεις από την επιχείρηση «{{business}}». Μπορείς να δημιουργήσεις ή να ενταχθείς σε άλλη επιχείρηση αργότερα.",
    "business_removeConfirmTitle": "Αφαίρεση συνεταίρου;",
    "business_removeConfirmBody": "Ο/Η {{name}} θα αφαιρεθεί από την επιχείρηση.",
    "levelProgress": "{{completed}}/{{required}} → Level {{level}}",
    "sigLockedActive": "Δεν μπορείς να αλλάξεις υπογραφή ενώ έχεις ενεργές συμφωνίες.",
    "sigLockedUsed": "Η υπογραφή έχει καταχωρηθεί σε συμφωνία και δεν μπορεί να αλλάξει.",
    "sigWelcomeBanner": "✍️ Φτιάξε την υπογραφή σου για να ξεκινήσουμε!",
    "info_professionalAccount": "Ενεργοποίησε τον Λογαριασμό Επαγγελματία αν προσφέρεις υπηρεσίες. Αποκτάς σήμα «Πάροχος Υπηρεσιών», δημόσιο portfolio και δυνατότητα αποστολής Επαγγελματικών Προσφορών σε πελάτες.",
    "professionalAccount_active": "Λογαριασμός Επαγγελματία ενεργός",
    "professionalAccount_activate": "Ενεργοποίηση Λογαριασμού",
    "portfolio_visibleAll": "(εμφανίζεται σε όλους)",
    "portfolio_visibleCircle": "(εμφανίζεται μόνο στον Κύκλο μου)",
    "field_region": "Νομός δραστηριοποίησης",
    "info_region": "Ο νομός όπου δραστηριοποιείσαι επαγγελματικά. Χρησιμοποιείται στο φίλτρο τοποθεσίας της καρτέλας Επαγγελματίες.",
    "region_select": "Επιλογή νομού",
    "info_specialty": "Σύντομη περιγραφή της υπηρεσίας που προσφέρεις. Εμφανίζεται ως chip στο portfolio σου.",
    "info_businessName": "Εμφανίζεται κάτω από το όνομά σου στο δημόσιο προφίλ σου.",
    "placeholder_businessName": "π.χ. Γιώργος Τεχνικές Υπηρεσίες",
    "info_businessLogo": "Εμφανίζεται στο portfolio σου κάτω από την ειδικότητα.",
    "field_professionalTerms": "Όροι & Προϋποθέσεις",
    "info_professionalTerms": "Οι δικοί σου όροι εμφανίζονται σε ξεχωριστή σελίδα-εξώφυλλο (με το λογότυπό σου) στο PDF των συμφωνιών σου. Ξεκίνα μια γραμμή με «- » για κουκίδα, ή «1. » για αρίθμηση.",
    "placeholder_professionalTerms": "π.χ.\n- Προκαταβολή 30% πριν την έναρξη\n- Ακυρώσεις εντός 48ωρών επιστρέφονται πλήρως\n1. Παράδοση εντός των συμφωνημένων ημερών\n2. Τυχόν καθυστέρηση ενημερώνεται εγκαίρως",
    "hint_professionalTerms": "Γραμμή με «- » = κουκίδα · «1. » = αρίθμηση. Το κείμενο εμφανίζεται πάντα ως απλό, ασφαλές κείμενο — δεν γίνεται δεκτός κώδικας/HTML.",
    "field_eshopUrl": "Σύνδεσμος eShop",
    "info_eshopUrl": "Αν έχεις online κατάστημα, βάλε τον σύνδεσμο εδώ — θα εμφανίζεται στο δημόσιο προφίλ σου ως κουμπί.",
    "placeholder_eshopUrl": "https://...",
    "hint_eshopUrl": "Προαιρετικό. Για επιχειρήσεις λιανικής με online κατάστημα.",
    "field_businessAddress": "Διεύθυνση επιχείρησης",
    "info_businessDetails": "Προαιρετικά στοιχεία της επιχείρησής σου — εμφανίζονται στα PDF προσφορών και συμφωνιών που προέρχονται από προσφορά σου.",
    "placeholder_businessAddress": "π.χ. Ερμού 25",
    "field_businessCity": "Πόλη",
    "placeholder_businessCity": "π.χ. Αθήνα",
    "field_businessPostalCode": "Τ.Κ.",
    "placeholder_businessPostalCode": "π.χ. 10563",
    "field_businessPhone": "Σταθερό τηλέφωνο",
    "placeholder_businessPhone": "π.χ. 2101234567",
    "field_businessEmail": "Email επιχείρησης",
    "placeholder_businessEmail": "π.χ. info@epixeirisi.gr",
    "field_businessVatNumber": "ΑΦΜ",
    "placeholder_businessVatNumber": "π.χ. 123456789",
    "section_paymentMethods": "Τρόποι πληρωμής",
    "info_paymentMethods": "Εμφανίζονται στο δημόσιο προφίλ σου ώστε οι πελάτες να ξέρουν πώς να σε πληρώσουν. Είναι καθαρά πληροφοριακά — η Χειραψία δεν επεξεργάζεται καμία πληρωμή, η συναλλαγή γίνεται απευθείας εκτός εφαρμογής.",
    "hint_paymentMethods": "Προαιρετικό. Συμπλήρωσε όσα θέλεις να δείχνεις.",
    "field_paymentAccountHolderName": "Εμφανιζόμενο όνομα δικαιούχου",
    "placeholder_paymentAccountHolderName": "Το όνομα όπως εμφανίζεται στον τραπεζικό λογαριασμό",
    "placeholder_bankName": "Τράπεζα",
    "placeholder_paymentIban": "IBAN",
    "action_addBank": "Προσθήκη άλλης τράπεζας",
    "placeholder_paymentIris": "IRIS (κινητό ή alias)",
    "placeholder_paymentRevolut": "Σύνδεσμος πληρωμής Revolut",
    "placeholder_paymentViva": "Σύνδεσμος πληρωμής Viva Wallet",
    "region_search_placeholder": "Πόλη, νομός ή Τ.Κ.…",
    "region_none": "— Κανένας —",
    "region_notFound": "Δεν βρέθηκε νομός.",
    "regionSectionTitle": "Περιοχή/Τ.Κ.",
    "regionNotSet": "Δεν έχει οριστεί — πάτησε για να επιλέξεις τον νομό σου",
    "nameLockHint": "🔒 Το όνομά σου επιβεβαιώθηκε με επαλήθευση ταυτότητας και δεν μπορεί να αλλάξει. Επικοινώνησε με την υποστήριξη αν υπάρχει λάθος.",
    "nameAccentHint": "⚠️ Έλεγξε αν λείπει τόνος από το όνομα/επώνυμο (π.χ. Γεώργιος, όχι Γεωργιος).",
    "nameLockHintActiveAgreement": "🔒 Το όνομα δεν μπορεί να αλλάξει όσο έχεις ενεργή συμφωνία. Θα ξεκλειδώσει όταν ολοκληρωθούν/ακυρωθούν όλες.",
    "nicknameCheckboxLabel": "Με γνωρίζουν και με άλλο όνομα",
    "nicknameCheckboxSublabel": "π.χ. Θάνος αντί για Αθανάσιος",
    "field_nickname": "Με γνωρίζουν και ως... (προαιρετικό)",
    "placeholder_nickname": "π.χ. Άκης, Κώστας, Νάντια…",
    "hint_nickname": "Αυτό είναι το όνομα που θα βλέπουν οι άλλοι στις αναζητήσεις, τον Κύκλο και τις λίστες — για ευκολότερη αναγνώριση.",
    "nicknamePreview": "Θα εμφανίζεται στο προφίλ σου ως: «Με γνωρίζουν και ως: {{nickname}}»",
    "nicknameLockHint": "Το άλλαξες πρόσφατα — μπορείς να το ξαναλλάξεις σε {{count}} ημέρες.",
    "nicknameWillLockWarning": "⚠️ Μόλις αποθηκευτεί, θα κλειδώσει — θα μπορείς να το ξαναλλάξεις μετά από 30 ημέρες.",
    "field_location": "Περιοχή (προαιρετικό)",
    "field_professionCategory": "Κλάδος εργασίας (προαιρετικό)",
    "field_secondaryCategories": "Δευτερεύουσες κατηγορίες",
    "info_secondaryCategories": "Επίλεξε κι άλλες κατηγορίες που δουλεύεις, εκτός από τον κύριο κλάδο σου. Θα ειδοποιείσαι για σχετικά αιτήματα προσφοράς σε αυτές τις κατηγορίες. Μέγιστο 5.",
    "field_addSecondaryCategory": "Προσθήκη κατηγορίας",
    "comm_call": "Κανονική κλήση",
    "validation_required": "Συμπλήρωσε το {{label}}.",
    "validation_tooLong": "Το {{label}} δεν μπορεί να ξεπερνά 40 χαρακτήρες.",
    "validation_lettersOnly": "Χρησιμοποίησε μόνο γράμματα και παύλες.",
    "validation_tooShort": "Το {{label}} πρέπει να έχει τουλάχιστον 2 γράμματα.",
    "label_firstName": "όνομα",
    "label_lastName": "επώνυμο",
    "error_genericRetry": "Κάτι πήγε στραβά. Δοκίμασε ξανά.",
    "comm_infoTitle": "Τρόποι Επικοινωνίας",
    "comm_infoBody": "Επίλεξε πώς μπορούν να επικοινωνήσουν μαζί σου οι χρήστες μέσα από ενεργές συμφωνίες. Φαίνονται μόνο σε άτομα με τα οποία έχεις ενεργή συμφωνία.",
    "comm_needPhone": "Συμπληρώστε αριθμό κινητού για να ενεργοποιηθούν.",
    "field_bio": "Λίγα λόγια για σένα (προαιρετικό)",
    "placeholder_bio": "Σύντομη περιγραφή",
    "field_specialtyFull": "Ειδικότητα / Τι προσφέρω (προαιρετικό)",
    "placeholder_specialtyFull": "π.χ. Ηλεκτρολόγος, Web Developer, Φωτογράφος…"
  },
  "settings": {
    "title": "Ρυθμίσεις",
    "account": "Λογαριασμός",
    "edit_profile": "Επεξεργασία προφίλ",
    "identity_verify": "Επαλήθευση ταυτότητας 🎖️",
    "payments": "Πληρωμές & αποδείξεις",
    "my_pen": "Το στυλό υπογραφών μου",
    "jury_duty": "Καθήκοντα Κριτή",
    "preferences": "Προτιμήσεις",
    "appearance": "Εμφάνιση",
    "theme_light": "Φωτεινό",
    "theme_dark": "Σκοτεινό",
    "theme_auto": "Αυτόματο",
    "sounds": "Ηχητικά εφέ",
    "language": "Γλώσσα",
    "my_user_id": "Το UserID μου",
    "user_id_hint": "Δώσε αυτό στον αντισυμβαλλόμενό σου για εύκολη εύρεση στην αναζήτηση.",
    "upload_error_default": "Δεν ήταν δυνατή η μεταφόρτωση.",
    "attach_uploading": "Μεταφόρτωση…",
    "attach_attached": "Επισυνάφθηκε screenshot",
    "attach_screenshot": "Επισύναψη screenshot (προαιρετικό)",
    "feedback": "Feedback",
    "suggest_feature": "Πρότεινε μια λειτουργία",
    "feature_modal_title": "Πρότεινε μια λειτουργία",
    "feature_modal_subtitle": "Τι θα ήθελες να βελτιώσουμε ή να προσθέσουμε στη Χειραψία;",
    "feature_placeholder": "Τι θα ήθελες να προσθέσουμε στη Χειραψία;",
    "feature_too_short": "Κενό μήνυμα",
    "feature_too_short_msg": "Γράψε ένα μήνυμα.",
    "feature_error": "Σφάλμα",
    "feature_error_msg": "Δεν ήταν δυνατή η αποστολή. Δοκίμασε ξανά.",
    "feature_done_title": "Ευχαριστούμε!",
    "feature_done_body": "Η πρότασή σου καταγράφηκε. Θα την εξετάσουμε σύντομα.",
    "legal": "Νομικά & δεδομένα",
    "my_data": "Τα δεδομένα μου",
    "terms": "Όροι Χρήσης",
    "privacy": "Πολιτική Απορρήτου",
    "how_it_works": "Πώς λειτουργεί",
    "usage_guide": "Οδηγός χρήσης",
    "sign_out": "Αποσύνδεση",
    "admin": "Admin",
    "admin_verifications": "Επαληθεύσεις χρηστών",
    "rate_app": "Βαθμολόγησε ★"
  },
  "payment": {
    "status": {
      "pending": "Εκκρεμεί",
      "paid": "Πληρώθηκε",
      "failed": "Απέτυχε",
      "refunded": "Επιστράφηκε"
    }
  },
  "wallet": {
    "topUp": "Φόρτωση μελανιού",
    "kind": {
      "credit_cancellation": "Επιστροφή υπογραφής",
      "debit_agreement": "Χρέωση υπογραφής",
      "refund": "Επιστροφή",
      "credit": "Πίστωση",
      "debit": "Χρέωση",
      "topup": "Γέμισμα μελανιού"
    },
    "title": "Στυλό & Μελάνι",
    "tab_label": "Στυλό",
    "ink_balance": "Υπόλοιπο μελανιού",
    "ink_unit": "υπογραφές",
    "buy_ink": "Αγορά μελανιού",
    "topup_title": "Γέμισε το στυλό σου",
    "free_remaining": "{{count}} δωρεάν υπογραφές",
    "history": "Ιστορικό",
    "no_history": "Δεν υπάρχουν συναλλαγές.",
    "transaction": {
      "debit_agreement": "Υπογραφή συμφωνίας",
      "credit": "Πίστωση",
      "topup": "Αγορά μελανιών",
      "refund": "Επιστροφή",
      "credit_cancellation": "Ακύρωση πίστωσης"
    },
    "balance_label": "Διαθέσιμες υπογραφές (μελάνι)",
    "balance_hint": "Κάθε συμφωνία καταναλώνει μία υπογραφή από το υπόλοιπό σου.",
    "balance_after": "Υπόλοιπο: {{amount}}",
    "freeAgreements": "Δωρεάν συμφωνίες",
    "transactions": "Κινήσεις",
    "empty_title": "Καμία κίνηση ακόμη",
    "empty_body": "Εδώ θα εμφανίζεται το ιστορικό χρήσης μελανιού.",
    "action_topup": "Γέμισμα μελανιού",
    "topup_screen_title": "Γέμισμα Μελανιού",
    "topup_subtitle": "Επίλεξε πακέτο μελανιού",
    "topup_loadingPrices": "Φόρτωση τιμών…",
    "topup_unit": "μελάνια",
    "topup_info": "Οι αγορές γίνονται ασφαλώς μέσω Apple/Google.",
    "topup_buyButton": "Αγορά {{count}} μελανιών",
    "topup_webOnly": "Οι αγορές μελανιού είναι διαθέσιμες στην εφαρμογή κινητού.",
    "topup_purchase_title": "Επιτυχής αγορά!",
    "topup_purchase_body": "{{count}} μελάνια προστέθηκαν στο στυλό σου.",
    "purchase_failed": "Η αγορά απέτυχε. Δοκίμασε ξανά.",
    "web_title": "Αγορά Μελανιών",
    "web_subtitle": "Η αγορά μελανιών είναι διαθέσιμη μόνο από την Android εφαρμογή μέσω Google Play.",
    "topup_subtitle_detail": "Επίλεξε πακέτο μελανιού. Κάθε μελάνι ισοδυναμεί με μία υπογραφή συμφωνίας!",
    "topup_infoText": "Η αγορά γίνεται μέσω Google Play. Τα μελάνια πιστώνονται αυτόματα μετά την επιβεβαίωση. Δεν εξαργυρώνονται σε μετρητά."
  },
  "notifications": {
    "title": "Ειδοποιήσεις",
    "empty": "Δεν υπάρχουν ειδοποιήσεις.",
    "mark_read": "Ανάγνωση",
    "agreement_new": "Νέα πρόσκληση συμφωνίας",
    "agreement_signed": "Υπεγράφη η συμφωνία",
    "agreement_completed": "Η συμφωνία ολοκληρώθηκε",
    "agreement_cancelled": "Η συμφωνία ακυρώθηκε",
    "agreement_disputed": "Διαφωνία στη συμφωνία",
    "offer_received": "Νέα προσφορά",
    "offer_accepted": "Η προσφορά αποδεκτή",
    "offer_declined": "Η προσφορά απορρίφθηκε",
    "review_received": "Νέα αξιολόγηση",
    "level_up": "Ανέβηκες επίπεδο!",
    "identity_verified": "Η ταυτότητά σου επαληθεύτηκε",
    "connection_request": "Αίτημα σύνδεσης",
    "agreement_expiry": "Συμφωνία που λήγει σύντομα"
  },
  "identity": {
    "title": "Επαλήθευση ταυτότητας",
    "subtitle": "Επαλήθευσε την ταυτότητά σου για να αποκτήσεις το σήμα 🎖️",
    "step_front": "Φωτογραφία μπροστά ταυτότητας",
    "step_back": "Φωτογραφία πίσω ταυτότητας",
    "step_selfie": "Selfie",
    "submit": "Υποβολή",
    "pending": "Σε αναμονή ελέγχου",
    "approved": "Επαληθευμένος ✓",
    "rejected": "Απορρίφθηκε",
    "already_verified": "Η ταυτότητά σου είναι ήδη επαληθευμένη."
  },
  "identityVerify": {
    "title": "Επαλήθευση ταυτότητας",
    "consent_title": "Τι θα χρησιμοποιηθεί",
    "consent_1": "Φωτογραφία μπροστά ταυτότητας",
    "consent_2": "Φωτογραφία πίσω ταυτότητας",
    "consent_3": "Selfie για σύγκριση",
    "step": "Βήμα {{step}}/3 — {{title}}",
    "action_start": "Συμφωνώ — Ξεκινώ",
    "action_takePhoto": "Τράβηξε φωτογραφία",
    "status_verified": "Η ταυτότητά σας έχει επαληθευτεί 🎖️",
    "status_pending": "Η αίτησή σας βρίσκεται υπό εξέταση",
    "status_rejected": "Η αίτησή σας απορρίφθηκε",
    "resubmit": "Μπορείς να υποβάλεις νέα αίτηση.",
    "uploading": "Αποστολή φωτογραφιών…",
    "uploadingHint": "Παρακαλώ περίμενε, μην κλείσεις την εφαρμογή.",
    "done_title": "Η αίτησή σου υποβλήθηκε!",
    "done_body": "Θα την εξετάσουμε και θα σε ενημερώσουμε για το αποτέλεσμα.",
    "step1_title": "Μπροστά ταυτότητας",
    "step1_hint": "Τοποθέτησε την μπροστά πλευρά της ταυτότητάς σου καθαρά στο πλαίσιο.",
    "step2_title": "Πίσω ταυτότητας",
    "step2_hint": "Τοποθέτησε την πίσω πλευρά της ταυτότητάς σου καθαρά στο πλαίσιο.",
    "step3_title": "Selfie",
    "step3_hint": "Τράβα selfie με καλό φωτισμό, κοιτώντας την κάμερα.",
    "step4_title": "Λογαριασμός (Προαιρετικό)",
    "step4_hint": "Τράβα φωτογραφία λογαριασμού τηλεφώνου ή ρεύματος όπου φαίνεται το όνομά σου και η διεύθυνσή σου. Αυξάνει την αξιοπιστία σου.",
    "action_skipBill": "Παράλειψη",
    "consentBullet_photos": "Θα τραβήξεις 3-4 φωτογραφίες: μπροστά ταυτότητας, πίσω ταυτότητας, selfie και προαιρετικά ένα λογαριασμό (τηλεφώνου/ρεύματος).",
    "consentBullet_usage": "Οι φωτογραφίες χρησιμοποιούνται ΜΟΝΟ για χειροκίνητη επαλήθευση ταυτότητας από την ομάδα της Χειραψίας.",
    "consentBullet_deletion": "Διαγράφονται αμέσως μετά τον έλεγχο, είτε εγκριθεί είτε απορριφθεί η αίτηση.",
    "consentBullet_noSharing": "Δεν αποθηκεύονται μόνιμα και δεν κοινοποιούνται σε τρίτους.",
    "captureError_default": "Δεν ήταν δυνατή η λήψη.",
    "submitError_default": "Αποτυχία αποστολής. Δοκίμασε ξανά."
  },
  "review": {
    "recordedTitle": "Η αξιολόγηση καταγράφηκε.",
    "addToCircleTitle": "Πρόσθεσέ τον/την στον κύκλο σου",
    "addToCircleBody": "Πρόσθεσε {{name}} στον κύκλο σου για να τον/την βρίσκεις ευκολότερα!",
    "addToCircleAction": "Προσθήκη",
    "recordedNoChange": "Η αξιολόγηση καταγράφηκε. Είναι ίδια με την προηγούμενή σου — δεν άλλαξε κάτι στο σκορ.",
    "title": "Αξιολόγηση",
    "stars_label": "Βαθμολογία",
    "comment_label": "Σχόλιο (προαιρετικό)",
    "submit": "Υποβολή αξιολόγησης",
    "success": "Η αξιολόγησή σου υποβλήθηκε.",
    "already_reviewed": "Έχεις ήδη αξιολογήσει αυτή τη συμφωνία.",
    "myReview": "Η αξιολόγησή σου",
    "noTagsForRating": "Δεν υπάρχουν ετικέτες για αυτή τη βαθμολογία.",
    "permanentWarning": "Οι αξιολογήσεις είναι μόνιμες και δεν μπορούν να επεξεργαστούν.",
    "summary_title": "Σύνοψη αξιολόγησης",
    "summary_rating": "Βαθμολογία",
    "summary_tags": "Ετικέτες",
    "starLabel_1": "Κακή",
    "starLabel_2": "Μέτρια",
    "starLabel_3": "Ουδέτερη",
    "starLabel_4": "Καλή",
    "starLabel_5": "Εξαιρετική",
    "wizard_step1_title": "Βαθμολογία",
    "wizard_step1_subtitle": "Πώς πήγε αυτή η συμφωνία;",
    "wizard_step2_title": "Ετικέτες",
    "wizard_step2_subtitle": "Επίλεξε ετικέτες που περιγράφουν καλύτερα την εμπειρία σου.",
    "wizard_step3_title": "Επιβεβαίωση",
    "wizard_step3_subtitle": "Έλεγξε πριν αποστείλεις.",
    "confirm_title": "Υποβολή αξιολόγησης",
    "confirm_message": "Η αξιολόγησή σου είναι μόνιμη και δεν μπορεί να επεξεργαστεί.",
    "confirm_label": "Υποβολή",
    "action_submit": "Υποβολή αξιολόγησης",
    "action_review": "Αξιολόγησε {{name}}",
    "error_rating": "Διάλεξε βαθμολογία από 1 έως 5 αστέρια.",
    "error_tagsRequired": "Διάλεξε τουλάχιστον μία ετικέτα.",
    "errorSubmitFailed": "Η υποβολή απέτυχε.",
    "wizard_step1_subtitle_named": "Πώς ήταν η συνεργασία με {{name}};",
    "nowReviewing": "Αξιολογείς: {{name}}",
    "defaultCounterparty": "τον αντισυμβαλλόμενο",
    "defaultCounterpartyGen": "αντισυμβαλλόμενου",
    "publicPermanentNotice": "Η αξιολόγηση θα είναι δημόσια και μόνιμη στο προφίλ του/της {{name}}.",
    "action_submitAndNext": "Υποβολή & επόμενος",
    "photoLabel": "Φωτογραφία (προαιρετικό)",
    "photoAddFromGallery": "Από συλλογή",
    "photoTakePhoto": "Λήψη φωτογραφίας",
    "confirmNoPhoto_title": "Δημοσίευση αξιολόγησης χωρίς φωτογραφία;",
    "confirmNoPhoto_body": "Οι αξιολογήσεις με φωτογραφία βοηθούν περισσότερο τον επαγγελματία και εμφανίζονται και στο portfolio του.",
    "confirmNoPhoto_confirm": "Συνέχεια χωρίς φωτογραφία",
    "confirmNoPhoto_cancel": "Προσθήκη φωτογραφίας"
  },
  "dispute": {
    "banner_juryReviewTitle": "Η υπόθεση πέρασε σε κληρωτούς κριτές.",
    "banner_juryReviewBody": "3-5 ανεξάρτητοι χρήστες κληρώθηκαν τυχαία για να την κρίνουν αμερόληπτα — βλέπουν μόνο τους λόγους διαφωνίας κάθε πλευράς, ποτέ ονόματα ή στοιχεία σας. {{votes}}/{{total}} έχουν ήδη ψηφίσει.",
    "banner_stakeLocked": "Χρεώθηκες {{amount}} μελάνια παράβολο για την κρίση των κριτών.",
    "banner_adminReview": "Η υπόθεση παραπέμφθηκε σε χειροκίνητο έλεγχο από τη διαχείριση.",
    "banner_juryWon": "Οι κριτές έκριναν υπέρ σου. Το παράβολο ({{amount}} μελάνια) δεν επιστρέφεται — ήταν η χρέωση για την κρίση των κριτών, όχι επιστρέψιμο ενέχυρο.",
    "banner_juryLost": "Οι κριτές έκριναν εναντίον σου — το παράβολο ({{amount}} μελάνια) δεν επιστρέφεται.",
    "banner_juryWon_accused": "Οι κριτές έκριναν υπέρ σου — δεν έχασες μελάνια, δεν πλήρωσες παράβολο σε αυτή τη διαφωνία.",
    "banner_juryLost_accused": "Οι κριτές έκριναν εναντίον σου — χάνεις βαθμολογία, αλλά δεν έχασες μελάνια (το παράβολο το πλήρωσε μόνο ο καταγγέλλων).",
    "banner_maliciousStrike": "Ομόφωνη κρίση κατά επαναλαμβανόμενου προτύπου — μεγάλη μείωση αξιοπιστίας.",
    "title": "Διαφωνία",
    "open": "Άνοιγμα διαφωνίας",
    "reason_label": "Αιτία διαφωνίας",
    "submit": "Υποβολή",
    "status": {
      "open": "Ανοιχτή",
      "resolved": "Επιλύθηκε",
      "closed": "Κλειστή"
    },
    "outcome": {
      "favor_creator": "Υπέρ δημιουργού",
      "favor_counterparty": "Υπέρ αντισυμβαλλόμενου",
      "split": "Διαμοιρασμός",
      "dismissed": "Απορρίφθηκε"
    },
    "action_respond": "Απάντηση στη Διαφωνία",
    "action_manage": "Διαχείριση Διαφωνίας",
    "action_respondMutual": "Απόκριση σε Πρόταση Επίλυσης",
    "mutualResolutionWaiting": "Πρότεινες αμοιβαία επίλυση. Αναμονή της άλλης πλευράς…",
    "banner_withdrawn": "Η διαφωνία αποσύρθηκε — η συμφωνία συνεχίζεται κανονικά.",
    "banner_autoCancelled_title": "Αυτόματη ακύρωση",
    "banner_autoCancelled_body": "Η συμφωνία ακυρώθηκε αυτόματα λόγω αδιευθέτητης διαφωνίας.",
    "banner_resolvedAccepted_title": "Επιλύθηκε",
    "banner_resolvedAccepted_body": "Η διαφωνία επιλύθηκε αμοιβαία.",
    "banner_penaltyRespondent_title": "Η διαφωνία επιλύθηκε",
    "banner_penaltyRespondent_body": "Ο αντίδικος παραδέχτηκε την ευθύνη του.",
    "banner_bothSubmitted_initiator": "Και οι δύο δηλώσεις υποβλήθηκαν. Αναμονή διαχειριστή.",
    "banner_bothSubmitted_respondent": "Και οι δύο δηλώσεις υποβλήθηκαν. Αναμονή διαχειριστή.",
    "banner_waiting": "Η δήλωσή σου υποβλήθηκε. Η άλλη πλευρά έχει έως {{date}} να απαντήσει.",
    "banner_respondentWarning": "Έχεις έως {{date}} να απαντήσεις, αλλιώς η διαφωνία θα επιλυθεί αυτόματα.",
    "banner_submittedWaiting": "Η δήλωσή σου υποβλήθηκε. Αναμονή της άλλης πλευράς…",
    "open_step1_title": "Αιτία διαφωνίας",
    "open_step1_body": "Επέλεξε έναν ή περισσότερους λόγους (μένουν κρυφοί μέχρι να απαντήσει ο άλλος):",
    "open_step2_title": "Επεξήγηση (προαιρετική)",
    "open_step2_body": "Περίγραψε λεπτομερώς τη διαφωνία σου με τον άλλο χρήστη, χωρίς να μοιραστείς ευαίσθητες λεπτομέρειες της συμφωνίας. Εξήγησε γιατί έχεις δίκιο και ο άλλος άδικο. Αυτό θα φανεί στον άλλο μόνο αφού υποβάλει κι αυτός τη δήλωσή του.",
    "open_step3_title": "Επιβεβαίωση",
    "open_step3_body": "Διάβασε τι θα συμβεί αφού υποβάλεις:",
    "evidence_title": "Αποδεικτικά (προαιρετικό)",
    "evidence_body": "Αν έχεις σχετική συνομιλία στο chat της συμφωνίας, άνοιξέ το, τράβηξε screenshot και επισύναψέ το εδώ ως αποδεικτικό. Θα φανεί στον άλλο μόνο αφού υποβάλει κι αυτός τη δική του δήλωση.",
    "evidence_openChat": "Άνοιγμα chat συμφωνίας",
    "evidence_addScreenshot": "Επισύναψη screenshot",
    "evidence_takePhoto": "Λήψη φωτογραφίας",
    "respond_title": "Διαφωνία σε εξέλιξη",
    "respond_note_label": "Σημείωση:",
    "respond_note_body": "Οι λόγοι του άλλου ΔΕΝ σου φαίνονται ακόμα — θα αποκαλυφθούν ταυτόχρονα όταν και οι δύο δηλώσετε.",
    "action_commDeclare": "Θα επιδιώξω επίλυση εκτός εφαρμογής (+24 ώρες)",
    "inAppMessagesNote": "Τα μηνύματα που έχετε ανταλλάξει μέσα στην εφαρμογή για αυτή τη συμφωνία καταγράφονται ήδη αυτόματα.",
    "commDeclared": "Δήλωσες επικοινωνία ✓",
    "action_acceptDispute": "Παραδέχομαι ότι φταίω",
    "action_contestDispute": "Διαφωνώ — θέλω να απαντήσω",
    "action_decideLater": "Άκυρο (θα αποφασίσω αργότερα)",
    "accept_title": "Αποδοχή Διαφωνίας",
    "action_acceptPenalty": "Αποδέχομαι (-0.25★)",
    "myStatement_title": "Η δική σου δήλωση",
    "myStatement_body": "Επέλεξε λόγους (δεν θα φανούν στον άλλο μέχρι να τους δεις και οι δύο ταυτόχρονα):",
    "action_submitStatement": "Υποβολή Δήλωσης",
    "reveal_title": "Αποκάλυψη Δηλώσεων",
    "reveal_body": "Και οι δύο έχετε υποβάλει. Οι λόγοι αποκαλύπτονται τώρα ταυτόχρονα.",
    "reveal_myReasons": "Οι λόγοι σου:",
    "reveal_otherReasons": "Οι λόγοι του/της {{name}}:",
    "reveal_whatToDo": "Τι θέλεις να κάνεις;",
    "action_withdrawPenaltySmall": "Απόσυρση Διαφωνίας — ξεπάγωμα (-0.1★)",
    "action_persistPenalty": "Επιμένω — ακύρωση με ποινή (έως -0.5★)",
    "action_sendProposal": "Αποστολή πρότασης",
    "withdraw_title": "Απόσυρση Διαφωνίας",
    "persist_title": "Επιμονή στη Διαφωνία",
    "action_persistFinal": "Επιμένω (έως -0.5★)",
    "respondMutual_title": "Πρόταση Αμοιβαίας Επίλυσης",
    "action_acceptMutual": "Αποδέχομαι — ακύρωση χωρίς ποινή",
    "action_rejectMutual": "Αρνούμαι — συνέχεια διαφωνίας",
    "initiator_role": "Άνοιξε διαφωνία",
    "banner_bothSubmitted": "Και οι δύο έχετε υποβάλει δηλώσεις. Πάτα «Διαχείριση Διαφωνίας» για να δεις τους λόγους και να αποφασίσεις.",
    "banner_waitingOther": "Αναμονή απάντησης από {{name}} ως {{date}}.",
    "banner_bothSubmittedWaiting": "Και οι δύο έχετε υποβάλει. Περίμενε την απόφαση του/της {{name}}.",
    "banner_respondDeadline": "Έχεις ως {{date}}. Αν δεν απαντήσεις, χάνεις 0.5★ αυτόματα.",
    "banner_statementSubmitted": "Η δήλωσή σου υποβλήθηκε. Αναμονή απόφασης από {{name}}.",
    "errorGeneric": "Σφάλμα.",
    "open_step2_placeholder": "π.χ. Δεν έγινε παράδοση εντός της συμφωνηθείσας προθεσμίας…",
    "open_step3_bullet_stake": "Θα χρεωθείς το παράβολο διαφωνίας 15 μελάνια. Αν αποσύρεις πριν κληρωθούν οι κριτές, σου επιστρέφεται.",
    "open_step3_bullet_freeze": "Η συμφωνία παγώνει μέχρι επίλυση.",
    "open_step3_bullet_deadline": "Ο αντισυμβαλλόμενος έχει 48ώρες να απαντήσει.",
    "open_step3_bullet_accept": "Αν αποδεχτεί την ευθύνη → χάνει 0.25★ και η συμφωνία ακυρώνεται.",
    "open_step3_bullet_contest": "Αν διαφωνήσει → η υπόθεση περνάει σε τυχαία κλήρωση 3-5 ανεξάρτητων κριτών. Όποιος χάσει, χάνει βαθμολογία.",
    "open_step3_bullet_withdraw": "Σε αυτή την περίπτωση δεν χάνει κανείς βαθμολογία — μόνο η απόσυρση πριν την κλήρωση κριτών είναι «χωρίς συνέπειες».",
    "submitCountdown": "Υποβολή ({{count}})",
    "submitDispute": "Υποβολή Διαφωνίας",
    "respond_body": "Ο αντισυμβαλλόμενός σου ανέφερε διαφωνία. Η συμφωνία είναι παγωμένη.\n\nΈχεις ως {{date}} να απαντήσεις. Αν δεν απαντήσεις, θα χάσεις 0.5★ αυτόματα.",
    "respond_hintAccept": "Χάνεις 0.25★, η συμφωνία ακυρώνεται — τέλος.",
    "respond_hintContest": "Αν επιμείνεις → η υπόθεση περνάει σε τυχαία κλήρωση 3-5 ανεξάρτητων κριτών. Ό,τι κρίνουν, ισχύει.",
    "accept_body": "Αν αποδεχτείς τη διαφωνία:",
    "accept_bullet_rating": "Η βαθμολογία σου μειώνεται κατά 0.25★.",
    "accept_bullet_cancel": "Η συμφωνία ακυρώνεται χωρίς άλλες συνέπειες.",
    "myStatement_bullet_reveal": "Οι λόγοι και των δύο αποκαλύπτονται αμέσως μόλις υποβάλεις.",
    "myStatement_bullet_final": "Η υποβολή είναι ΟΡΙΣΤΙΚΗ: η διαφωνία λήγει αμέσως σε αδιέξοδο.",
    "myStatement_bullet_stars": "Μόνο όποιος χάσει στην κρίση των κριτών χάνει βαθμολογία (έως 0.5★). Το παράβολο του καταγγέλλοντα (15 μελάνια) δεν επιστρέφεται σε καμία περίπτωση — πάει πάντα στους κριτές.",
    "mutual_proposal": "Στέλνεις πρόταση στον/στην {{name}} για αμοιβαία επίλυση.",
    "mutual_deadline": "Έχει 48 ώρες να αποδεχτεί ή να αρνηθεί.",
    "banner_waitingMutualDecision": "Αναμένουμε τώρα και την απόφαση του/της {{name}}.",
    "mutual_deadline_until": "Έχει προθεσμία μέχρι {{date}}.",
    "mutual_accept": "Αν αποδεχτεί → ακύρωση χωρίς ποινή για κανέναν.",
    "mutual_reject": "Αν αρνηθεί/λήξει → επιστρέφεις στις επιλογές σου.",
    "withdraw_unfreeze": "Η συμφωνία ξεπαγώνει και συνεχίζεται κανονικά.",
    "withdraw_penalty": "Επειδή αποσύρεις ΜΕΤΑ την αποκάλυψη → -0.1★ στη βαθμολογία σου.",
    "persist_loss": "{{article}} {{name}} χάνει έως 0.5★ από τη βαθμολογία.",
    "persist_cancel": "Η συμφωνία ακυρώνεται οριστικά.",
    "persist_record": "Τα αποτελέσματα καταγράφονται στα προφίλ και των δύο.",
    "respondMutual_body": "{{article}} {{name}} προτείνει αμοιβαία επίλυση της διαφωνίας.",
    "respondMutual_accept": "Αν αποδεχτείς → η συμφωνία ακυρώνεται αμοιβαία, κανείς δεν χάνει βαθμολογία.",
    "respondMutual_reject": "Αν αρνηθείς → η διαφωνία συνεχίζεται κανονικά.",
    "respondMutual_deadline": "Η πρόταση λήγει: {{date}}",
    "banner_autoCancelled_initiator": "Η διαφωνία έληξε αυτόματα. {{article}} {{name}} δεν απάντησε εντός 5 ημερών και έχασε 0.5★.",
    "banner_autoCancelled_respondent": "Η διαφωνία έληξε αυτόματα. Δεν απάντησες εντός 5 ημερών — έχασες 0.5★.",
    "banner_acceptedByRespondent_initiator": "{{article}} {{name}} αποδέχτηκε τη διαφωνία (-0.25★). Η συμφωνία ακυρώθηκε.",
    "banner_acceptedByRespondent_self": "Αποδέχτηκες τη διαφωνία (-0.25★). Η συμφωνία ακυρώθηκε.",
    "banner_deadlock": "Η συμφωνία σας κατέληξε σε διαφωνία που έφτασε σε αδιέξοδο. Έχασες {{myLoss}}★ και {{article}} {{name}} {{otherLoss}}★. Η συμφωνία ακυρώθηκε.",
    "banner_penaltyRespondent_initiator": "Επέμεινες — {{article}} {{name}} έχασε 0.5★. Η συμφωνία ακυρώθηκε.",
    "banner_penaltyRespondent_respondent": "Ο/Η αντισυμβαλλόμενος επέμεινε. Έχασες 0.5★.",
    "banner_frozenTitle": "⏸ Συμφωνία παγωμένη",
    "banner_pendingResponseTitle": "⚠ Εκκρεμεί απάντησή σου!"
  },
  "disputeOutcomeCard": {
    "outcomeLabel_accepted": "Παραδοχή λάθους",
    "outcomeLabel_penaltyRespondent": "Επιμονή",
    "outcomeLabel_autoCancelled": "Αυτόματη ακύρωση",
    "outcomeLabel_timeoutDefault": "Αυτόματη λήξη",
    "outcomeLabel_baselessComplaint": "Αβάσιμη καταγγελία",
    "outcomeLabel_juryVerdict": "Απόφαση κριτών",
    "juryFavorsBusiness": "Η διαφωνία κρίθηκε υπέρ της επιχείρησης",
    "juryFavorsClient": "Η διαφωνία κρίθηκε υπέρ του πελάτη",
    "outcomeLabel_adminReview": "Υπό εξέταση διαχείρισης",
    "verdict_pendingAdmin": "Εκκρεμεί κρίση διαχείρισης",
    "outcomeLabel_default": "Διαφωνία",
    "verdict_right": "Δικαιώθηκε",
    "verdict_admitFault": "Παραδέχθηκε λάθος",
    "verdict_atFault": "Κρίθηκε υπαίτιος",
    "verdict_noResponse": "Δεν απάντησε",
    "verdict_baseless": "Αβάσιμη καταγγελία",
    "verdict_withdrawn": "Απέσυρε τη διαφωνία",
    "verdict_mutual": "Αμοιβαία επίλυση",
    "verdict_deadlock": "Δεν βρέθηκε λύση",
    "defaultUser": "Χρήστης",
    "defaultAgreement": "Συμφωνία",
    "respondentRole_admitted": "Παραδέχθηκε",
    "respondentRole_noResponse": "Δεν απάντησε",
    "respondentRole_responded": "Απάντησε"
  },
  "announcements": {
    "published": "Δημοσιεύθηκε!",
    "freeBanner": "Η δημοσίευση ανακοίνωσης είναι δωρεάν. Η ειδοποίηση με κουδούνισμα στα κινητά κοστίζει 1 μελάνι.",
    "field_text": "Κείμενο ανακοίνωσης",
    "field_image": "Εικόνα (προαιρετικό)",
    "action_pickImage": "Επιλογή εικόνας",
    "push_limit": "Μέγιστο 1 ανά 7 μέρες",
    "push_availableAt": "Διαθέσιμο ξανά στις {{date}}",
    "freeCooldownUntil": "Θα μπορέσεις να δημοσιεύσεις ξανά στις {{date}}.",
    "action_publish": "Δημοσίευση",
    "requiresProfessional": "Χρειάζεσαι ενεργό Λογαριασμό Επαγγελματία για να δημοσιεύσεις ανακοίνωση.",
    "requiresProfessionalShort": "Χρειάζεσαι ενεργό Λογαριασμό Επαγγελματία.",
    "field_text_placeholder": "Γράψε μια σύντομη ανακοίνωση για τον κύκλο σου…",
    "push_label": "Ειδοποίηση με κουδούνισμα (1 μελάνι)",
    "success_body": "Η ανακοίνωσή σου έχει σταλεί στις επαφές σου.",
    "success_body_push_suffix": " Εστάλη και ειδοποίηση με κουδούνισμα στα κινητά.",
    "error_writeText": "Γράψε κάτι.",
    "error_cooldown": "Μπορείς ξανά σε {{hours}} ώρες.",
    "error_paid_cooldown": "Μπορείς να στείλεις επί πληρωμή notification μόνο μία φορά ανά 7 μέρες."
  },
  "disputeOutcome": {
    "accepted": "Εθελοντική αποδοχή",
    "persisted": "Επιμονή",
    "autoCancelled": "Αυτόματη ακύρωση",
    "default": "Διαφωνία",
    "openedDispute": "Άνοιξε διαφωνία",
    "responded": "Απάντησε"
  },
  "payments": {
    "title": "Πληρωμές",
    "subtitle": "Τέλη συμφωνιών (1 μελάνι ανά υπογραφή)",
    "walletMethod": " · Πορτοφόλι",
    "empty_title": "Καμία πληρωμή ακόμη",
    "empty_body": "Εδώ θα εμφανίζεται το ιστορικό πληρωμών σου.",
    "agreement_fallback": "Συμφωνία"
  },
  "receipt": {
    "label": "Απόδειξη",
    "notFound": "Η απόδειξη δεν βρέθηκε.",
    "wallet": "Πορτοφόλι",
    "field_number": "Αριθμός",
    "field_date": "Ημερομηνία",
    "field_agreement": "Συμφωνία",
    "field_method": "Μέθοδος",
    "field_orderCode": "Κωδ. παραγγελίας",
    "field_transactionCode": "Κωδ. συναλλαγής",
    "note_wallet": "Αφαίρεση μελανιού από το υπόλοιπο στυλό.",
    "note_viva": "Επεξεργάστηκε μέσω Viva Wallet.",
    "action_share": "Κοινοποίηση απόδειξης",
    "share_header": "Χειραψία — Απόδειξη",
    "share_status": "Κατάσταση: {{status}}",
    "share_amount": "Ποσό: {{amount}}",
    "share_date": "Ημερομηνία: {{date}}",
    "share_agreement": "Συμφωνία: {{title}}",
    "share_method": "Μέθοδος: Πορτοφόλι",
    "share_order": "Κωδ. παραγγελίας: {{code}}",
    "share_transaction": "Κωδ. συναλλαγής: {{code}}",
    "share_fee": "Τέλος πλατφόρμας"
  },
  "search": {
    "title": "Αναζήτηση",
    "field_label": "Όνομα ή UserID",
    "hint": "Γράψε τουλάχιστον 2 χαρακτήρες (όνομα ή UserID).",
    "noResults": "Δε βρήκα χρήστη με αυτό το όνομα.",
    "suggestions": "Μήπως εννοείτε κάποιον από αυτούς;"
  },
  "user": {
    "deletedMember": "Δεν είναι πια μέλος της Χειραψίας",
    "knownAs": "Με γνωρίζουν και ως: {{nickname}}",
    "memberSince": "Μέλος από",
    "visitEshop": "🛍️ Επισκέψου το eShop",
    "openInMaps": "📍 Άνοιξε σε χάρτες",
    "completed": "ολοκληρωμένες",
    "commonAgreements": "Κοινές Συμφωνίες",
    "professionalProfile": "Επαγγελματικό Προφίλ",
    "requestQuoteGeneral": "Αίτημα Προσφοράς",
    "responsiblePerson": "Υπεύθυνος: {{name}}",
    "announcement": "Ανακοίνωση",
    "expiresIn_one": "Λήγει σε 1 μέρα",
    "expiresIn_other": "Λήγει σε {{count}} μέρες",
    "error_sendRequest": "Δεν ήταν δυνατή η αποστολή αιτήματος.",
    "error_response": "Αποτυχία απόκρισης.",
    "error_remove": "Αποτυχία αφαίρεσης.",
    "shareTitle": "{{name}} στη Χειραψία",
    "shareMessage": "Δες το προφίλ του {{name}} στη Χειραψία\n{{url}}",
    "unusualDisputeWinRate": "Ασυνήθιστα υψηλό ποσοστό επιτυχίας σε διαφωνίες",
    "searchFailed": "Η αναζήτηση απέτυχε.",
    "portfolioPreviewBanner": "Προεπισκόπηση — το portfolio δεν είναι ακόμα ενεργό. Ενεργοποίησέ το από το Προφίλ σου.",
    "verifiedIdentity": "Επαληθευμένη ταυτότητα"
  },
  "portfolio": {
    "stat_completed": "Ολοκληρωμένες",
    "stat_success": "Επιτυχία",
    "stat_rating": "Βαθμολογία",
    "businessMembers": "Συνέταιροι της επιχείρησης",
    "businessMemberViewing": "τον βλέπεις",
    "businessHiddenMembers_one": "και {{count}} ακόμα συνέταιρος (ιδιωτικό προφίλ)",
    "businessHiddenMembers_other": "και {{count}} ακόμα συνέταιροι (ιδιωτικά προφίλ)",
    "completedAgreements": "Ολοκληρωμένες Συμφωνίες",
    "paymentMethodsDisclaimer": "Πληροφοριακά στοιχεία — η πληρωμή γίνεται απευθείας μεταξύ σας, εκτός εφαρμογής. Η Χειραψία δεν διαμεσολαβεί.",
    "paymentMethodsShow": "Πάτα για να δεις τους τρόπους πληρωμής",
    "openLink": "Άνοιγμα συνδέσμου →",
    "noAccount": "Δεν υπάρχει διαθέσιμος Λογαριασμός Επαγγελματία.",
    "noCompletedAgreements": "Δεν υπάρχουν ολοκληρωμένες συμφωνίες ακόμα.",
    "resolvedDispute": "Επιλύθηκε με διαφωνία"
  },
  "connection": {
    "inCircle": "Στον κύκλο σου",
    "addedYou": "Σε πρόσθεσε στον κύκλο του/της",
    "pending": "Εκκρεμεί αίτηση",
    "action_add": "Προσθήκη στον κύκλο μου",
    "action_remove": "Αφαίρεση"
  },
  "freeze": {
    "suspended": "Ο λογαριασμός σου έχει ανασταλεί μόνιμα. Επικοινώνησε στο hello@heirapsia.gr",
    "frozen": "Προσωρινή αναστολή έως {{until}}. Η δημιουργία και αποδοχή συμφωνιών είναι απενεργοποιημένη."
  },
  "update": {
    "title_forced": "Απαιτείται ενημέρωση",
    "title_available": "Νέα έκδοση διαθέσιμη",
    "body_forced": "Παρακαλώ ενημέρωσε την εφαρμογή για να συνεχίσεις να χρησιμοποιείς τη Χειραψία.",
    "body_available": "Μια νέα έκδοση της Χειραψίας είναι διαθέσιμη.",
    "action_now": "Ενημέρωση τώρα",
    "action_later": "Αργότερα"
  },
  "consent": {
    "text": "Χρησιμοποιούμε απαραίτητα cookies για τη λειτουργία της υπηρεσίας. Δες την",
    "privacyLink": "Πολιτική Απορρήτου",
    "ok": "Εντάξει"
  },
  "invite": {
    "notFound": "Η πρόσκληση δεν βρέθηκε ή έχει λήξει.",
    "loadError": "Αδυναμία φόρτωσης πρόσκλησης.",
    "tagline": "Επαγγελματικές συμφωνίες, ψηφιακά.",
    "action_registerAndSign": "Εγγραφή & Υπογραφή",
    "action_registerAndAccept": "Εγγραφή & Αποδοχή",
    "agreement_title": "Πρόσκληση Συμφωνίας",
    "agreement_header": "Πρόσκληση σε Συμφωνία",
    "youLabel": "Εσύ",
    "agreement_body": "Σε κάλεσαν να υπογράψεις συμφωνία Χειραψία.",
    "agreement_notFound": "Δεν βρέθηκε η συμφωνία.",
    "agreement_loadError": "Αδυναμία φόρτωσης συμφωνίας.",
    "agreement_loginPrompt": "Σύνδεσε ή δημιούργησε λογαριασμό Χειραψία για να αποδεχτείς τη συμφωνία.",
    "offer_header": "Επαγγελματική Προσφορά",
    "offer_notFound": "Η προσφορά δεν βρέθηκε ή έχει λήξει.",
    "offer_acceptError": "Αποτυχία αποδοχής προσφοράς.",
    "offer_loadError": "Αδυναμία φόρτωσης προσφοράς.",
    "offer_accepting": "Αποδοχή προσφοράς…",
    "offer_acceptPrompt": "Αποδέξου την προσφορά για να δημιουργηθεί αυτόματα συμφωνία Χειραψία.",
    "offer_codePrompt": "Για να δεις αυτή την προσφορά, πληκτρολόγησε τον 6ψήφιο κωδικό που σου στάλθηκε μαζί με το link.",
    "offer_codePlaceholder": "6ψήφιος κωδικός",
    "offer_codeSubmit": "Συνέχεια",
    "offer_codeInvalid": "Λάθος κωδικός. Δοκίμασε ξανά.",
    "offer_codeTooManyAttempts": "Πάρα πολλές λανθασμένες προσπάθειες. Ζήτησε από τον αποστολέα να σου στείλει ξανά την προσφορά.",
    "offer_codeRequired": "Χρειάζεται κωδικός.",
    "professionalTerms": "Όροι & Προϋποθέσεις {{name}}",
    "have_account": "Έχεις ήδη λογαριασμό;",
    "agreement_inviteText": "σε προσκαλεί να υπογράψεις αυτή τη συμφωνία.\nΚάνε εγγραφή για να συνεχίσεις."
  },
  "onboarding": {
    "title": "Πες μας ποιος είσαι",
    "subtitle": "Συμπλήρωσε το προφίλ σου για να ξεκινήσεις.",
    "continue": "Συνέχεια"
  },
  "reviewSummary": {
    "disputedLossBadge": "⚠️ Ο αξιολογητής έχασε διαφωνία με αυτόν τον χρήστη — μειωμένο βάρος στον μέσο όρο",
    "characterization_excellent": "Εξαιρετικός συνεργάτης",
    "characterization_reliable": "Αξιόπιστος συνεργάτης",
    "characterization_pleasant": "Ευχάριστη συνεργασία",
    "characterization_new": "Νέο μέλος",
    "reliability_known": "Ποσοστό αξιοπιστίας",
    "reliability_unknown": "Αξιοπιστία άγνωστη",
    "reviewerReliability": "({{percent}}% αξιοπιστία)",
    "uniqueUsers_one": "από {{count}} χρήστη",
    "uniqueUsers_other": "από {{count}} χρήστες",
    "noReviews": "Χωρίς αξιολογήσεις ακόμα",
    "tapForMore": "Πάτα για περισσότερα ℹ",
    "toggle_hide": "Απόκρυψη αξιολογήσεων",
    "toggle_show": "Εμφάνιση αναλυτικών αξιολογήσεων",
    "stat_completed": "Ολοκληρωμένες",
    "stat_mutualCancellations": "Αμοιβαίες ακυρώσεις",
    "stat_unilateralCancellations": "Μονομερείς ακυρώσεις",
    "stat_disputes": "Διαφωνίες",
    "disputeResults": "Αποτελέσματα διαφωνιών",
    "emptyFilter": "Δεν υπάρχουν αξιολογήσεις για αυτή την κατηγορία.",
    "capHint_id": "Επαλήθευσε ταυτότητα για {{target}}%",
    "ok": "Εντάξει",
    "info_reliability": "Ποσοστό Αξιοπιστίας 🏆",
    "info_disputes": "Διαφωνίες",
    "capHint_fewAgreements": "Ολοκληρώστε περισσότερες συμφωνίες για υψηλότερη αξιοπιστία",
    "capHint_lowRating": "Βελτιώστε τις αξιολογήσεις σας για υψηλότερη αξιοπιστία",
    "reliability_info_body": "ΠΟΣΟΣΤΟ ΑΞΙΟΠΙΣΤΙΑΣ\nΔείχνει πόσο αξιόπιστος είναι ο χρήστης στην ολοκλήρωση των συμφωνιών του.\n\n✅ Ανεβαίνει όταν μια συμφωνία ολοκληρωθεί επιτυχώς και από τις δύο πλευρές.\n\n❌ Μειώνεται όταν ο χρήστης ακυρώσει μονομερώς μια ενεργή συμφωνία.\n\n➖ Δεν επηρεάζεται από αμοιβαίες ακυρώσεις — αν και οι δύο συμφωνήσουν να ακυρώσουν, το ποσοστό δεν αλλάζει.\n\n⭐ ΑΣΤΕΡΑΚΙΑ\nΔείχνουν πόσο ευχαριστημένοι έμειναν οι άλλοι από τη συνεργασία μαζί του (ποιότητα δουλειάς, συνέπεια, συμπεριφορά) — αξιολόγηση μετά από κάθε συμφωνία. Μετράει μόνο η πιο πρόσφατη αξιολόγηση από κάθε χρήστη, ώστε να μην «φουσκώνει» τεχνητά με επαναλαμβανόμενες συμφωνίες με το ίδιο άτομο.\n\n🔗 Η ΣΧΕΣΗ ΤΟΥΣ\nΑπό 5 διαφορετικούς χρήστες και πάνω, ένα σταθερά χαμηλό μέσο rating βάζει οροφή στο ποσοστό αξιοπιστίας — έτσι δεν φαίνεται άψογος κάποιος που ποτέ δεν ακυρώνει επίσημα, αλλά κάνει δουλειά προχείρως ή δεν σέβεται τους όρους.\n\n📊 ΛΙΓΕΣ ΣΥΜΦΩΝΙΕΣ\nΜε λίγες ολοκληρωμένες συμφωνίες το ποσοστό δεν μπορεί να φτάσει 100% ακόμα κι αν όλες πήγαν καλά — χρειάζεται μεγαλύτερο ιστορικό για να αποδειχθεί σταθερή αξιοπιστία.",
    "reliability_info_body_noData": "Το ποσοστό αξιοπιστίας είναι άγνωστο γιατί ο χρήστης δεν έχει ακόμα συνάψει καμία συμφωνία στη Χειραψία.",
    "disputes_info_body": "Πόσες διαφωνίες άνοιξε ο χρήστης σε σχέση με τον αριθμό συμφωνιών του.",
    "stat_completed_info": "Συμφωνίες που ολοκληρώθηκαν επιτυχώς και επιβεβαιώθηκαν και από τις δύο πλευρές.",
    "stat_unilateral_info": "Συμφωνίες που ακύρωσε μονομερώς, χωρίς συμφωνία του άλλου μέρους — επηρεάζει αρνητικά το ποσοστό αξιοπιστίας.",
    "unilateral_veryFrequent": "Ακυρώνει πολύ συχνά μονομερώς",
    "unilateral_frequent": "Ακυρώνει συχνά μονομερώς",
    "unilateral_sometimes": "Ακύρωσε μερικές φορές μονομερώς",
    "unilateral_rare": "Ακυρώνει σπάνια μονομερώς",
    "disputes_everyOther": "Διαφωνεί σε κάθε 2η συμφωνία",
    "disputes_veryFrequent": "Διαφωνεί πολύ συχνά",
    "disputes_quiteFrequent": "Διαφωνεί αρκετά συχνά",
    "disputes_frequent": "Διαφωνεί συχνά",
    "disputes_sometimes": "Διαφωνεί μερικές φορές",
    "disputes_rare": "Διαφωνεί σπάνια",
    "disputes_minimal": "Διαφωνεί ελάχιστα",
    "filter_completed": "Αξιολογήσεις από ολοκληρωμένες συμφωνίες",
    "filter_mutual": "Αξιολογήσεις από αμοιβαίες ακυρώσεις",
    "filter_unilateral": "Αξιολογήσεις από μονομερείς ακυρώσεις"
  },
  "notification_push": {
    "completionRequested_title": "🏁 Αίτημα ολοκλήρωσης",
    "completionRequested_body": "«{{title}}» — επιβεβαιώνεις;",
    "pendingSignature_title": "✍️ Εκκρεμεί η υπογραφή σου",
    "pendingSignature_body": "«{{title}}»",
    "cancelRequested_title": "⚠️ Αίτηση ακύρωσης",
    "cancelRequested_body": "{{name}} ζητά ακύρωση της «{{title}}»",
    "paymentDeclared_title": "💰 Δήλωση εξόφλησης",
    "paymentDeclared_body": "{{name}} δήλωσε εξόφληση για «{{title}}»",
    "connectionRequest_title": "🤝 Αίτημα σύνδεσης",
    "connectionRequest_body": "{{name}} θέλει να συνδεθεί μαζί σου",
    "newOffer_title": "📋 Νέα προσφορά προς εσένα",
    "newOffer_body": "{{name}} σου έστειλε προσφορά: «{{title}}»",
    "openDispute_title": "🚨 Ανοιχτή διαφορά",
    "openDispute_body": "{{name}} άνοιξε διαφωνία στη «{{title}}»"
  },
  "professionals": {
    "tab_browse": "Επαγγελματίες",
    "tab_requests": "Αιτήματα Προσφοράς"
  },
  "requests": {
    "title": "Αναζητήσεις",
    "subtitle": "Ζήτα αυτό που χρειάζεσαι και δέξου προσφορές από επαγγελματίες.",
    "subtitleForProfessionals": "Δες όλα τα αιτήματα υποψηφίων πελατών και δώσε τη δική σου προσφορά!",
    "demandInRegion": "Υπάρχει ζήτηση στον κλάδο σου, στη περιοχή σου!",
    "demandRemote": "Υπάρχει ζήτηση εξ αποστάσεως στον κλάδο σου!",
    "filter_open": "Ψάχνουν για προσφορά",
    "filter_mine": "Δικό μου αίτημα",
    "emptyOpen": "Δεν υπάρχουν ανοιχτές αναζητήσεις αυτή τη στιγμή.",
    "ownTag": "Δικό σου",
    "remoteTag": "Εξ αποστάσεως",
    "emptyMine": "Δεν έχεις δημοσιεύσει καμία αναζήτηση ακόμα.",
    "onlyProfessionalsSeeOpen": "Οι διαθέσιμες εργασίες φαίνονται μόνο σε επαγγελματίες. Εδώ βλέπεις τις δικές σου αναζητήσεις.",
    "status_closed": "Κλεισμένη",
    "status_cancelled": "Ακυρώθηκε",
    "newTitle": "Νέα αναζήτηση",
    "newSubtitle": "Περίγραψε τι χρειάζεσαι — οι επαγγελματίες θα σου στείλουν προσφορές.",
    "editTitle": "Επεξεργασία αναζήτησης",
    "editSubtitle": "Μπορείς να αλλάξεις τα στοιχεία όσο η αναζήτηση παραμένει ανοιχτή.",
    "action_edit": "Επεξεργασία",
    "directTitle": "Αίτημα Προσφοράς",
    "directSubtitle": "Περίγραψε τι χρειάζεσαι — θα σταλεί απευθείας στον/στην {{name}}, όχι στον δημόσιο πίνακα αναζητήσεων.",
    "action_sendDirect": "Αποστολή αιτήματος",
    "field_imageOptional": "Φωτογραφία (προαιρετικό)",
    "action_addImage": "Προσθήκη φωτογραφίας",
    "imageSourceCamera": "Λήψη φωτογραφίας",
    "imageSourceLibrary": "Επιλογή από τη συλλογή",
    "imageHint": "Βοηθάει τον επαγγελματία να καταλάβει τι ζητάς. Διαγράφεται αυτόματα μόλις κλείσει το αίτημα.",
    "errorImageFailed": "Η φωτογραφία δεν ανέβηκε. Δοκίμασε ξανά.",
    "field_title": "Τίτλος",
    "placeholder_title": "π.χ. Αναζητώ γραφίστα",
    "field_description": "Περιγραφή",
    "placeholder_description": "Πρόσθεσε λεπτομέρειες...",
    "field_category": "Κατηγορία",
    "field_regionOptional": "Επαγγελματία από περιοχή:",
    "regionAll": "Όλες",
    "action_publish": "Δημοσίευση",
    "postedSuccess": "Καταχωρήθηκε επιτυχώς!",
    "action_sendOffer": "Στείλε προσφορά",
    "action_cancelRequest": "Ακύρωση αναζήτησης",
    "cancelTitle": "Ακύρωση αναζήτησης",
    "cancelBody": "Σίγουρα θέλεις να ακυρώσεις αυτή την αναζήτηση;",
    "viewIncomingOffers": "Δες τις εισερχόμενες προσφορές σου",
    "offersReceived": "Προσφορές που έλαβες ({{count}})",
    "noOffersYet": "Δεν έχεις λάβει ακόμα προσφορές για αυτό το αίτημα.",
    "notFound": "Δεν βρέθηκε.",
    "errorTitleRequired": "Ο τίτλος είναι υποχρεωτικός.",
    "errorCategoryRequired": "Η κατηγορία είναι υποχρεωτική.",
    "errorCreateFailed": "Κάτι πήγε στραβά."
  },
  "services": {
    "sectionTitle": "Υπηρεσίες",
    "hint": "Λίστα υπηρεσιών με τιμές που θα βλέπουν οι πελάτες στο δημόσιο προφίλ σου.",
    "action_add": "Προσθήκη υπηρεσίας",
    "addTitle": "Νέα υπηρεσία",
    "editTitle": "Επεξεργασία υπηρεσίας",
    "placeholder_title": "Τίτλος υπηρεσίας",
    "placeholder_description": "Περιγραφή (προαιρετικό)",
    "placeholder_price": "Τιμή σε € (προαιρετικό)",
    "unit_fixed": "Σταθερή",
    "unit_hourly": "Ανά ώρα",
    "unit_per_item": "Ανά τεμάχιο",
    "unit_per_meter": "Ανά μ.",
    "unit_per_sqm": "Ανά μ²",
    "inactive": "Ανενεργή",
    "action_deactivate": "Απόκρυψη από το προφίλ",
    "action_activate": "Επανενεργοποίηση",
    "deleteTitle": "Διαγραφή υπηρεσίας",
    "deleteBody": "Οριστική διαγραφή της υπηρεσίας «{{title}}»;",
    "errorTitleRequired": "Ο τίτλος είναι υποχρεωτικός.",
    "errorInvalidPrice": "Μη έγκυρη τιμή.",
    "errorMaxReached": "Έχεις φτάσει το όριο των 30 υπηρεσιών.",
    "errorSaveFailed": "Η αποθήκευση απέτυχε.",
    "requestQuote": "Ζήτησε προσφορά"
  },
  "advancePayment": {
    "sectionTitle": "Προκαταβολή / Δόσεις",
    "totalAmount": "Συνολικό ποσό",
    "advance": "Προκαταβολή",
    "remaining": "Υπόλοιπο",
    "fullyPaid": "✓ Εξοφλήθηκε πλήρως",
    "amountExceedsRemaining": "Η προκαταβολή δεν μπορεί να ξεπερνά το υπόλοιπο ({{amount}}).",
    "errorRecordFailed": "Η καταγραφή απέτυχε.",
    "errorActionFailed": "Η ενέργεια απέτυχε.",
    "errorLoadFailed": "Αποτυχία φόρτωσης προκαταβολών. Δοκίμασε ξανά.",
    "pendingMine": "Κατέγραψες προκαταβολή {{amount}}. Αναμονή απάντησης από {{name}}…",
    "pendingOther": "{{article}} {{name}} κατέγραψε προκαταβολή {{amount}}. Υπόλοιπο: {{remaining}}. Συμφωνείτε;",
    "confirmYes": "Ναι",
    "confirmNo": "Όχι",
    "rejectedNotice": "Η προκαταβολή σου ({{amount}}) απορρίφθηκε και δεν υπολογίζεται στη συμφωνία.",
    "action_add": "Σημείωση Δόσης Ποσού",
    "action_declarePayment": "Σημείωση Πλήρους Εξόφλησης",
    "modalTitle": "Καταγραφή προκαταβολής / δόσης",
    "modalHint": "Υπόλοιπο διαθέσιμο: {{amount}}",
    "recordOnlyDisclaimer": "⚠️ Αυτό είναι απλή σημείωση/καταγραφή — η Χειραψία δεν πραγματοποιεί μεταφορά χρημάτων. Η πληρωμή γίνεται εκτός εφαρμογής, με όποιον τρόπο έχετε συμφωνήσει.",
    "placeholder_amount": "Ποσό (€)",
    "placeholder_note": "Αιτιολογία (π.χ. Πλήρωσα μετρητά)",
    "action_record": "Καταγραφή"
  },
  "renewal": {
    "waitingTitle": "Αναμονή ανανέωσης",
    "youAccepted": "Αποδέχτηκες ανανέωση. Περιμένουμε τον άλλο.",
    "youDeclined": "Αρνήθηκες ανανέωση. Η συμφωνία ολοκληρώνεται.",
    "otherDeclined": "Ο άλλος αρνήθηκε — η συμφωνία ολοκληρώνεται.",
    "promptTitle": "Ανανέωση συμφωνίας;",
    "promptBody": "Η συμφωνία έληξε. Θέλεις να συνεχίσετε με ίδια διάρκεια;",
    "otherAccepted": "Ο άλλος ήδη αποδέχτηκε.",
    "action_yes": "Ναι, ανανέωση",
    "action_no": "Όχι"
  },

  "reviewTags": {
    "professional": "Επαγγελματισμός",
    "fast_delivery": "Γρήγορη παράδοση",
    "honest": "Ειλικρινής",
    "good_communication": "Καλή επικοινωνία",
    "kept_terms": "Συνεπής στις υποχρεώσεις",
    "friendly": "Φιλικός",
    "precise": "Ακριβής στις λεπτομέρειες",
    "reliable": "Αξιόπιστος",
    "highly_recommended": "Συστήνεται ανεπιφύλακτα",
    "slow_delivery": "Αργή παράδοση",
    "bad_communication": "Κακή επικοινωνία",
    "no_delivery": "Δεν παρέδωσε όπως συμφωνήθηκε",
    "delay_no_notice": "Καθυστέρηση χωρίς ενημέρωση",
    "unprofessional_behavior": "Μη επαγγελματική συμπεριφορά",
    "unreliable": "Αναξιόπιστος",
    "different_from_agreed": "Διαφορά από τα συμφωνηθέντα",
    "not_recommended": "Δεν συστήνεται",
    "punctual": "Έγκαιρος",
    "straightforward": "Ντόμπρος",
    "cooperative": "Συνεργάσιμος",
    "late": "Άργησε",
    "broke_terms": "Δεν τήρησε τους όρους",
    "no_phone_response": "Δεν μου απαντάει στο τηλέφωνο"
  },

  "mobileWebBanner": {
    "message": "Κατέβασε το app για ευκολότερη αλληλεπίδραση!",
    "action": "Λήψη"
  },

  "chatBubble": {
    "callLabel": "Κλήση",
    "communicationAccessibilityLabel": "Επικοινωνία",
    "sheetTitle": "Επικοινωνία",
    "sheetTitleFor": "Βλέπεις τους διαθέσιμους τρόπους επικοινωνίας του {{name}}.",
    "pickPersonTitle": "Με ποιον θέλεις να επικοινωνήσεις;",
    "inAppOption": "Επικοινωνία εντός Χειραψίας",
    "recommendedBadge": "Προτείνεται",
    "externalOption": "Επικοινωνία εκτός",
    "inAppUnavailableHint": "Διαθέσιμο μόνο σε ενεργές συμφωνίες",
    "closeAccessibilityLabel": "Κλείσιμο",
    "moveToOtherSide": "Μετακίνηση στην απέναντι πλευρά",
    "inlineButtonLabel": "Επικοινωνία"
  },

  "level2ReviewModal": {
    "suggestSubject": "Πρόταση λειτουργίας - Χειραψία"
  },

  "professionReminderModal": {
    "title": "Δεν έχεις δηλώσει επάγγελμα",
    "body": "Ο επαγγελματικός σου λογαριασμός είναι ενεργός, αλλά χωρίς δηλωμένο επάγγελμα δεν θα εμφανίζεσαι σωστά σε αναζητήσεις και αντιστοιχίσεις πελατών.",
    "action": "Ορισμός επαγγέλματος"
  },

  "tutorial": {
    "skip": "Παράλειψη",
    "next": "Επόμενο",
    "start": "Ξεκίνα!",
    "slide1_title": "Ψηφιακές συμφωνίες",
    "slide1_text": "Τέλος στο \"σου είπα αυτό\", \"εγώ άλλο κατάλαβα\" κλπ. Σύναψε συμφωνίες με όποιον θέλεις ψηφιακά γιατί τα γραπτά… μένουν! Και μένουν μεταξύ σας! Κανένας δεν έχει πρόσβαση στο περιεχόμενο της συμφωνίας σας.",
    "slide2_title": "Δωρεάν δημιουργία",
    "slide2_text": "Η δημιουργία και η αποστολή είναι δωρεάν. Χρεώνεστε 1 μελάνι ο καθένας μόνο όταν συμφωνήσετε και οι δύο. Και για να ξεκινήσεις, σου χαρίζουμε 45 δωρεάν συμφωνίες και 15 μελάνια για να δοκιμάσεις!",
    "slide3_title": "Συμφωνείτε & υπογράφετε",
    "slide3_text": "Όταν πατήσετε και οι δύο «Συμφωνώ», η συμφωνία ενεργοποιείται. Μπορείς να κατεβάσεις το PDF έγγραφο — και να το εκτυπώσεις σαν κλασική συμφωνία!",
    "slide4_title": "Το στυλό υπογραφών σου",
    "slide4_text": "Κάθε φορά που υπογράφεις μια συμφωνία, το στυλό σου χάνει λίγο μελάνι! Ξεκινάς με 45 δωρεάν υπογραφές (αρκούν όσο είσαι \"Νέος\") και 15 μελάνια δώρο. Μόλις τελειώσουν, αγοράζεις μελάνι από μέσα στην εφαρμογή.",
    "slide5_title": "Εμπιστοσύνη & βαθμολογίες",
    "slide5_text": "Μετά από κάθε συμφωνία αξιολογείτε ο ένας τον άλλον. Χτίσε τη φήμη σου, απόκτησε το σήμα «Επαληθευμένος» και γίνε ο χρήστης που όλοι θέλουν να συνεργαστούν μαζί του!",
    "slide6_title": "Πώς λειτουργεί η Χειραψία",
    "slide6_text": "① Δημιουργείς συμφωνία → ο άλλος αποδέχεται → ξεκινάει.\n② Μετά την ολοκλήρωση αξιολογείτε με ετικέτες.\n③ Αν υπάρξει πρόβλημα → «Αναφορά Διαφωνίας».\n④ Κάθε μέρος επιλέγει λόγους χωριστά και κρυφά.\n⑤ Όταν και οι δύο δηλώσουν → αποκαλύπτονται ταυτόχρονα.\n⑥ Η ειλικρίνεια επιβραβεύεται — μικρότερη ποινή αν παραδεχτείς λάθος."
  },

  "portfolioTutorial": {
    "skip": "Παράλειψη",
    "next": "Επόμενο →",
    "start": "Ξεκίνα! Δημιούργησε προσφορά →",
    "slide1_title": "Λογαριασμός Επαγγελματία",
    "slide1_body": "Ο Λογαριασμός Επαγγελματία είναι η επαγγελματική σου ταυτότητα στη Χειραψία. Ενεργοποιώντας τον αποκτάς:\n\n• Εμφάνιση badge «Πάροχος Υπηρεσιών»\n• Δυνατότητα αποστολής επαγγελματικών προσφορών\n• Δημόσια σελίδα portfolio με αξιολογήσεις\n• Επαγγελματικό προφίλ για πελάτες",
    "slide2_title": "Πώς δημιουργείς προσφορά",
    "slide2_body": "Δημιούργησε προσφορά με λίγα βήματα:",
    "slide2_mock": "📋 Τίτλος: «Κατασκευή ιστοσελίδας»\n💬 Περιγραφή: Landing page + SEO βελτιστοποίηση\n💶 Κόστος: 800 €\n⏱ Παράδοση: 14 μέρες\n📧 Email πελάτη (προαιρετικό)",
    "slide3_title": "Στέλνεις link ή email",
    "slide3_body": "Μετά τη δημιουργία έχεις δύο τρόπους:\n\n🔗 Αντιγραφή / Κοινοποίηση συνδέσμου — στέλνεις μόνος σου μέσω WhatsApp, Viber, SMS κ.λπ.\n\n✉️ Email — πληκτρολογείς το email του πελάτη και αποστέλλεται αυτόματα",
    "slide4_title": "Τι βλέπει ο πελάτης",
    "slide4_body": "Ο πελάτης ανοίγει τον σύνδεσμο και βλέπει preview της προσφοράς:\n\n• Τίτλος & περιγραφή εργασίας\n• Κόστος & χρόνος παράδοσης\n• Το προφίλ σου\n\nΠατώντας «Αποδοχή», υπογράφει δωρεάν και δημιουργείται αυτόματα συμφωνία Χειραψία.",
    "slide5_title": "Εσύ υπογράφεις τελευταίος",
    "slide5_body": "Μόλις ο πελάτης υπογράψει, λαμβάνεις push notification:\n\n«Ο πελάτης υπέγραψε! Υπόγραψε για να ενεργοποιηθεί.»\n\nΑνοίγεις τη συμφωνία και υπογράφεις. Τότε:\n\n💶 Χρεώνεσαι 1 μελάνι\n📄 Δημιουργείται ψηφιακή συμφωνία με PDF\n✅ Η συμφωνία ενεργοποιείται"
  },

  "circleTutorial": {
    "skip": "Παράλειψη",
    "next": "Επόμενο",
    "gotIt": "Κατάλαβα!",
    "slide1_title": "Καλώς ήρθες στον Κύκλο σου!",
    "slide1_body": "Εδώ έχεις άμεση πρόσβαση σε όλες τις επαφές σου — τα άτομα με τα οποία έχεις συνδεθεί.",
    "slide2_title": "Δίκτυο γνωριμιών",
    "slide2_body": "Αν δύο επαφές σου γνωρίζονται ήδη μεταξύ τους, τις βλέπεις συνδεδεμένες με διακεκομμένη γραμμή στο γράφο.",
    "slide3_title": "Ιδιωτικότητα",
    "slide3_body": "Αν ο Λογαριασμός Επαγγελματία δεν είναι δημόσιος, τον βλέπουν μόνο τα άτομα στον κύκλο του.",
    "slide4_title": "Ανακοινώσεις",
    "slide4_body": "Αν είσαι Επαγγελματίας, μπορείς να στείλεις ανακοίνωση σε όλες τις επαφές σου — δωρεάν! Με 1 μελάνι στέλνεις και ειδοποίηση με κουδούνισμα στα κινητά τους.",
    "slide5_title": "Η δύναμή σου είναι ο Κύκλος σου!",
    "slide5_body": "Χτίσε σχέσεις εμπιστοσύνης, μεγάλωσε το δίκτυό σου και ανακάλυψε ευκαιρίες συνεργασίας."
  },

  "coachmarks": {
    "skip": "Παράλειψη",
    "next": "Επόμενο",
    "done": "Τέλος"
  },

  "howItWorks": {
    "back": "‹ Πίσω",
    "title": "Πώς λειτουργεί",
    "intro": "Η Χειραψία είναι μια πλατφόρμα ψηφιακών συμφωνιών μεταξύ ιδιωτών, με ενσωματωμένο σύστημα επίλυσης διαφορών.",
    "step1_title": "Δημιουργία & αποστολή",
    "step1_text": "Δημιουργείς μια συμφωνία με τίτλο, τύπο, ποσό και όρους. Την στέλνεις στον αντισυμβαλλόμενο.",
    "step2_title": "Αμοιβαία αποδοχή",
    "step2_text": "Όταν και οι δύο πατήσουν «Συμφωνώ & Υπογράφω», η συμφωνία ενεργοποιείται και υπογράφεται ψηφιακά.",
    "step3_title": "Αξιολόγηση μετά την ολοκλήρωση",
    "step3_text": "Μετά την ολοκλήρωση, αξιολογείτε ο ένας τον άλλον με ετικέτες (Έγκαιρος, Ειλικρινής, Ντόμπρος). Η βαθμολογία φαίνεται στο προφίλ.",
    "step4_title": "Αναφορά Διαφωνίας",
    "step4_text": "Αν υπάρξει πρόβλημα σε ενεργή συμφωνία, μπορείς να ανοίξεις Διαφωνία. Η συμφωνία παγώνει μέχρι να επιλυθεί.",
    "step5_title": "Κρυφές δηλώσεις",
    "step5_text": "Κάθε μέρος επιλέγει τους λόγους του χωριστά και κρυφά. Ο άλλος δεν βλέπει τα tags σου μέχρι να δηλώσει και αυτός.",
    "step6_title": "Ταυτόχρονη αποκάλυψη",
    "step6_text": "Όταν και οι δύο υποβάλουν δήλωση, οι λόγοι αποκαλύπτονται ταυτόχρονα. Τότε ο εκκινητής αποφασίζει αν θα αποσύρει ή θα επιμείνει.",
    "step7_title": "Ειλικρίνεια επιβραβεύεται",
    "step7_text": "Αν αποδεχτείς τη διαφωνία χάνεις μόνο 0.25★. Αν επιμείνεις χωρίς δίκαιο λόγο, χάνεις 0.5★. Η ειλικρίνεια κοστίζει λιγότερο.",
    "step8_title": "Καταγραφή αποτελεσμάτων",
    "step8_text": "Κάθε διαφωνία και η έκβασή της καταγράφονται στο προφίλ και των δύο μερών για πλήρη διαφάνεια."
  },

  "dataScreen": {
    "back": "‹ Πίσω",
    "title": "Τα δεδομένα μου",
    "exportTitle": "Εξαγωγή δεδομένων",
    "exportText": "Κατέβασε όλα τα προσωπικά σου δεδομένα σε μορφή JSON (δικαίωμα φορητότητας GDPR).",
    "action_downloadJson": "Κατέβασε JSON",
    "action_exportShare": "Εξαγωγή & κοινοποίηση",
    "errorTitle": "Σφάλμα",
    "errorExportFailed": "Η εξαγωγή απέτυχε.",
    "errorDeleteFailed": "Η διαγραφή απέτυχε.",
    "storageNotice": "Τα δεδομένα σου αποθηκεύονται σε διακομιστές εντός ΕΕ (Frankfurt). Μπορείς ανά πάσα στιγμή να ζητήσεις",
    "deleteLinkText": "Διαγραφή λογαριασμού και δεδομένων",
    "deleteModalTitle": "Διαγραφή λογαριασμού",
    "deleteModalMessage": "Η ενέργεια είναι οριστική και δεν αναιρείται. Θα διαγραφούν:",
    "deleteBullet1": "Ο λογαριασμός και το προφίλ σου",
    "deleteBullet2": "Οι συμφωνίες που δημιούργησες",
    "deleteBullet3": "Οι αξιολογήσεις και τα δεδομένα σου",
    "deleteBullet4": "Το email σου δεν θα μπορεί να χρησιμοποιηθεί για νέα εγγραφή στο μέλλον",
    "deleteConfirmLabel": "Είμαι σίγουρος"
  },

  "newsScreen": {
    "title": "Εφημερίδα",
    "bookmarksTab": "Σελιδοδείκτες",
    "pageOf": "Σελίδα {{page}} από {{total}}",
    "timeAgo_justNow": "μόλις τώρα",
    "timeAgo_hours": "πριν {{count}} ώρ.",
    "timeAgo_days": "πριν {{count}} μέρ.",
    "removeBookmark": "Αφαίρεση σελιδοδείκτη",
    "saveBookmark": "Αποθήκευση",
    "openInBrowser": "Διάβασέ το",
    "searchPlaceholder": "Αναζήτηση ειδήσεων…",
    "emptyBookmarks": "Δεν έχεις αποθηκεύσει ακόμα ειδήσεις.",
    "emptySearch": "Δεν βρέθηκαν αποτελέσματα για «{{query}}».",
    "emptyNews": "Δεν υπάρχουν ειδήσεις ακόμα."
  },

  "verifyScreen": {
    "headerSub": "Επαλήθευση συμφωνίας",
    "notFoundTitle": "Δεν βρέθηκε συμφωνία",
    "notFoundBody": "Το αναγνωριστικό δεν αντιστοιχεί σε συμφωνία της Χειραψίας.",
    "validTitle": "Έγκυρη συμφωνία στη Χειραψία",
    "field_title": "Τίτλος",
    "field_status": "Κατάσταση",
    "field_type": "Τύπος",
    "field_created": "Δημιουργήθηκε",
    "type_oneOff": "Μιας φοράς",
    "type_longTerm": "Μακράς διάρκειας",
    "type_fixedTerm": "Ορισμένης διάρκειας",
    "withdrewOn": "Αποχώρησε στις {{date}}",
    "sectionTitle_parties": "Συμβαλλόμενα μέρη",
    "bothSignedSeal": "✓ Ψηφιακά υπογεγραμμένο από αμφότερα τα μέρη",
    "privacyNote": "Για λόγους απορρήτου δεν εμφανίζονται το ποσό και οι όροι της συμφωνίας.",
    "action_openApp": "Άνοιγμα Χειραψία",
    "defaultUser": "Χρήστης",
    "signedDigitally": "✔ Υπέγραψε ψηφιακά",
    "pendingSignature": "Εκκρεμεί υπογραφή"
  },

  "phoneInput": {
    "country_gr": "Ελλάδα",
    "country_cy": "Κύπρος",
    "country_al": "Αλβανία",
    "country_bg": "Βουλγαρία",
    "country_ro": "Ρουμανία",
    "country_de": "Γερμανία",
    "country_gb": "Ηνωμένο Βασίλειο",
    "country_us": "ΗΠΑ / Καναδάς",
    "country_fr": "Γαλλία",
    "country_it": "Ιταλία",
    "country_es": "Ισπανία",
    "country_pt": "Πορτογαλία",
    "country_nl": "Ολλανδία",
    "country_be": "Βέλγιο",
    "country_at": "Αυστρία",
    "country_ch": "Ελβετία",
    "country_se": "Σουηδία",
    "country_dk": "Δανία",
    "country_no": "Νορβηγία",
    "country_au": "Αυστραλία"
  },

  "disclaimerNote": {
    "title": "Αποποίηση ευθύνης Χειραψία",
    "text": "Αποποίηση ευθύνης: Η Χειραψία είναι ψηφιακό εργαλείο καταγραφής συμφωνιών μεταξύ ιδιωτών. Δεν παρέχει νομικές, λογιστικές ή τραπεζικές υπηρεσίες. Η καταγραφή δόσεων, προκαταβολών και πληρωμών γίνεται αποκλειστικά για λόγους τεκμηρίωσης μεταξύ των συμβαλλομένων."
  },

  "updatePrompt": {
    "title_forced": "Απαιτείται ενημέρωση",
    "title_ota": "Νέες διορθώσεις/προσθήκες διαθέσιμες!",
    "title_optional": "Νέα έκδοση διαθέσιμη",
    "body_forced": "Μια νέα έκδοση της Χειραψίας είναι υποχρεωτική. Παρακαλώ ενημέρωσε την εφαρμογή για να συνεχίσεις.",
    "body_ota": "Πατήστε επανεκκίνηση για εφαρμογή.",
    "body_optional": "Μια νέα έκδοση είναι διαθέσιμη. Ενημέρωσε για τις τελευταίες βελτιώσεις και διορθώσεις.",
    "action_restart": "Επανεκκίνηση τώρα",
    "action_updateNow": "Ενημέρωση τώρα",
    "action_later": "Αργότερα"
  },

  "professionalTermsOption": {
    "noTermsYet": "Δεν έχεις ορίσει ακόμα όρους συνεργασίας.",
    "action_addTerms": "Πρόσθεσε τους όρους σου",
    "attachLabel": "Επισύναψη των όρων συνεργασίας μου",
    "attachSublabel": "Εμφανίζει τους όρους σου στη σελίδα της συμφωνίας και προσθέτει σελίδα-εξώφυλλο στο PDF με το λογότυπο της επιχείρησής σου."
  },

  "legalScreen": {
    "back": "‹ Πίσω"
  },

  "starRating": {
    "starsAccessibilityLabel": "{{count}} αστέρια"
  },

  "userIdChip": {
    "copyAccessibilityLabel": "Αντιγραφή UserID"
  },

  "confirmModal": {
    "cancelDefault": "Ακύρωση ενέργειας",
    "tagsLabelDefault": "Επέλεξε λόγο (τουλάχιστον έναν):"
  },

  "errors": {
    "generic": "Κάτι πήγε στραβά. Δοκίμασε ξανά.",
    "network": "Πρόβλημα σύνδεσης. Έλεγξε το internet σου.",
    "session_expired": "Η συνεδρία έληξε. Συνδέσου ξανά.",
    "permission_denied": "Δεν έχεις δικαίωμα για αυτή την ενέργεια.",
    "not_found": "Δεν βρέθηκε.",
    "upload_failed": "Αποτυχία ανεβάσματος. Δοκίμασε ξανά.",
    "titleRequired": "Δώσε τίτλο στη συμφωνία.",
    "counterpartyRequired": "Γράψε όνομα ή email αντισυμβαλλόμενου.",
    "invalidAmount": "Μη έγκυρο ποσό.",
    "invalidDays": "Μη έγκυρος αριθμός ημερών.",
    "invalidEmail": "Μη έγκυρο email.",
    "accountSuspended": "Ο λογαριασμός σου έχει ανασταλεί.",
    "accountFrozen": "Ο λογαριασμός σου είναι προσωρινά παγωμένος.",
    "dailyLimit": "Έφτασες το ημερήσιο όριο συμφωνιών.",
    "selfAgreement": "Δεν μπορείς να δημιουργήσεις συμφωνία με τον εαυτό σου.",
    "selectAtLeastOneTag": "Επέλεξε τουλάχιστον μία ετικέτα.",
    "cannotWithdrawSigned": "Δεν μπορείς να αποσύρεις τη συμφωνία γιατί η άλλη πλευρά έχει ήδη υπογράψει.",
    "ratingRequired": "Διάλεξε βαθμολογία από 1 έως 5 αστέρια.",
    "offerTitleRequired": "Δώσε τίτλο στην προσφορά.",
    "passwordMismatch": "Οι κωδικοί δεν ταιριάζουν.",
    "termsRequired": "Πρέπει να αποδεχτείς τους Όρους Χρήσης.",
    "invalidOtp": "Λάθος ή ληγμένος κωδικός.",
    "fieldRequired": "Συμπλήρωσε το {{field}}.",
    "fieldTooLong": "Το {{field}} δεν μπορεί να ξεπερνά 40 χαρακτήρες.",
    "lettersOnly": "Χρησιμοποίησε μόνο γράμματα και παύλες.",
    "fieldTooShort": "Το {{field}} πρέπει να έχει τουλάχιστον 2 γράμματα.",
    "cooldown24h": "Cooldown 24 ωρών — μπορείτε να στείλετε ξανά: {{time}}"
  },
  "placeholder": {
    "agreementTitle": "π.χ. Ενοικίαση εξοπλισμού",
    "nameOrEmail": "Όνομα ή email…",
    "counterpartyName": "Όνομα αντισυμβαλλόμενου (προαιρετικό)",
    "agreementTerms": "Περίγραψε τους όρους…",
    "offerTitle": "π.χ. Κατασκευή ιστοσελίδας",
    "recipientSearch": "Όνομα ή email πελάτη…",
    "declineReason": "Εξήγησε σύντομα γιατί…",
    "search": "Αναζήτηση…",
    "userSearch": "Όνομα ή HEI-00123…",
    "userSearchExampleName": "Π.χ. Γιώργος Παπαδόπουλος",
    "userSearchExampleId": "HEI-00123",
    "yourName": "Το όνομά σου",
    "specialty": "π.χ. Γραφίστας",
    "firstName": "π.χ. Μαρία",
    "lastName": "π.χ. Παπαδοπούλου",
    "otp": "6-ψήφιος κωδικός",
    "passwordNew": "Τουλάχιστον 6 χαρακτήρες",
    "passwordConfirm": "Επανάληψε τον κωδικό",
    "password": "••••••••",
    "searchAgreements": "Αναζήτηση τίτλου ή ατόμου…",
    "nameOrUserId": "Όνομα ή HEI-00123…",
    "phoneNumber": "Αριθμός κινητού"
  },
  "hint": {
    "counterpartyNotification": "Θα λάβει notification για να υπογράψει.",
    "existsInApp": "Υπάρχει στη Χειραψία — πάτα για επιλογή",
    "emailInvite": "Θα στείλουμε σύνδεσμο πρόσκλησης σε αυτό το email.",
    "nameSearch": "Αναζήτηση με όνομα…",
    "milestone": "Η συμφωνία έχει σταθερή ημερομηνία ολοκλήρωσης.",
    "noMilestone": "Χωρίς σταθερή ημερομηνία — ανοιχτή διάρκεια.",
    "percentAgreement": "Κατανομή εσόδων μεταξύ των δύο μερών.",
    "eurAmount": "Σταθερό ποσό σε ευρώ για αυτή τη συμφωνία.",
    "bothPartiesCommit": "Και τα δύο μέρη δεσμεύονται στους παραπάνω όρους.",
    "sendAgreement": "Η αποστολή θα ειδοποιήσει την άλλη πλευρά να υπογράψει.",
    "recipientSearch": "Αναζήτηση χρήστη Χειραψίας ή εισαγωγή email."
  },
  "verifiedBadge": {
    "alert_title": "Επαληθευμένος χρήστης",
    "alert_body": "Ο χρήστης αυτός έχει επαληθεύσει την ταυτότητά του (φωτογραφία ταυτότητας, εγκεκριμένη από τη Χειραψία) — το ανώτερο επίπεδο επαλήθευσης.",
    "alert_title_phone": "Επαληθευμένο κινητό",
    "alert_body_phone": "Ο χρήστης αυτός έχει επαληθεύσει τον αριθμό κινητού του με κωδικό SMS."
  },
  "providerBadge": {
    "alert_title": "Παρέχει Υπηρεσίες",
    "alert_body": "Ο χρήστης αυτός έχει ενεργοποιήσει portfolio και προσφέρει υπηρεσίες μέσω Χειραψίας."
  },
  "levelBadge": {
    "accessibilityLabel": "Επίπεδο {{level}} {{title}}",
    "progressLabel": "{{completed}} / {{required}} συμφωνίες",
    "toNextLevel": "{{count}} ακόμα για Επίπεδο {{next}}",
    "avgRating": "Μέση βαθμολογία",
    "tier_new": "Νέος",
    "tier_active": "Ενεργός",
    "tier_experienced": "Έμπειρος",
    "tier_veteran": "Βετεράνος",
    "tier_expert": "Ειδικός",
    "tier_legend": "Θρύλος"
  },
  "jury": {
    "title": "Καθήκοντα Κριτή",
    "introAnonymous": "Οι υποθέσεις είναι πλήρως ανώνυμες — βλέπεις μόνο τους λόγους διαφωνίας κάθε πλευράς, ποτέ ονόματα.",
    "howToJudgeTitle": "Πώς κρίνεις μια υπόθεση",
    "howToJudgeBody": "Διάβασε τους λόγους και των δύο πλευρών και τα στατιστικά τους (ολοκληρωμένες συμφωνίες, μονομερείς ακυρώσεις, προηγούμενες διαφωνίες). Δες και τη συνομιλία της συμφωνίας παρακάτω για πραγματικά στοιχεία. Ψήφισε με βάση ποιος πιστεύεις ότι λέει την αλήθεια — δεν χρειάζεται απόλυτη βεβαιότητα, αρκεί ποιος είναι πιο πιθανό να έχει δίκιο.",
    "empty": "Δεν έχεις εκκρεμείς υποθέσεις προς κρίση αυτή τη στιγμή.",
    "caseStake": "Υπόθεση — παράβολο {{amount}} μελάνια (σου αναλογούν {{share}})",
    "viewChat": "Δες τη συνομιλία της συμφωνίας",
    "chatModalTitle": "Συνομιλία συμφωνίας (ανώνυμη)",
    "chatEmpty": "Δεν υπάρχουν μηνύματα σε αυτή τη συμφωνία.",
    "chatLoadError": "Δεν ήταν δυνατή η φόρτωση της συνομιλίας.",
    "chatSideInitiator": "Χρήστης Α",
    "chatSideAccused": "Χρήστης Β",
    "chatSideOther": "Άλλος συμβαλλόμενος",
    "chatReadByOther": "✓✓ Διαβάστηκε από την άλλη πλευρά",
    "chatUnreadByOther": "Δεν έχει διαβαστεί ακόμα από την άλλη πλευρά",
    "deadline": "Λήγει: {{date}}",
    "myDeadline": "Έχεις ως {{date}} να ψηφίσεις — αλλιώς κληρώνεται άλλος κριτής στη θέση σου.",
    "initiatorSide": "Χρήστης Α",
    "accusedSide": "Χρήστης Β",
    "openedDisputeBadge": "Άνοιξε τη διαφωνία",
    "noStatement": "Καμία δήλωση",
    "statRating_one": "από {{count}} αξιολόγηση",
    "statRating_other": "από {{count}} αξιολογήσεις",
    "statCompleted": "Ολοκληρωμένες",
    "statUnilateralCancel": "Μονομερείς ακυρώσεις",
    "statDisputesOpened": "Διαφωνίες που ξεκίνησε",
    "statFlagged": "Ασυνήθιστο ποσοστό νικών σε διαφωνίες",
    "voteInitiator": "Δίκιο στον Χρήστη Α",
    "voteAccused": "Δίκιο στον Χρήστη Β",
    "confirmTitle": "Επιβεβαίωση ψήφου",
    "confirmBody": "Η ψήφος σου είναι οριστική και δεν μπορεί να αλλάξει. Μόλις ψηφίσεις, λαμβάνεις αμέσως {{amount}} μελάνια ως αμοιβή κριτή, ανεξαρτήτως αποτελέσματος.",
    "voteFailed": "Η ψήφος απέτυχε."
  },
  "levelUp": {
    "levelLabel": "Επίπεδο {{level}}",
    "body": "Μπράβο! Ανέβηκες επίπεδο\nκαι κέρδισες 5 δωρεάν συμφωνίες!",
    "continue": "Συνέχεια"
  },
  "reviewModal": {
    "body": "Βοήθησέ μας να γίνουμε καλύτεροι — βαθμολόγησέ μας ή πρότεινε κάτι νέο!"
  },
  "profileTour": {
    "step1_title": "Καλώς ήρθες στο προφίλ σου!",
    "step1_text": "Εδώ ζουν τα στοιχεία σου. Ας δούμε γρήγορα τι έχει.",
    "step2_title": "Φωτογραφία & στοιχεία",
    "step2_text": "Πάτησε τη φωτογραφία για να την αλλάξεις. Συμπλήρωσε βιογραφικό για περισσότερη εμπιστοσύνη.",
    "step3_title": "Βαθμολογία & UserID",
    "step3_text": "Η βαθμολογία σου χτίζεται από τις αξιολογήσεις μετά από κάθε συμφωνία. Το UserID (HEI-…) το δίνεις σε άλλους για να σε βρίσκουν εύκολα.",
    "sig_text": "Ζωγράφισε την υπογραφή σου με το δάχτυλο. Θα εμφανίζεται στις συμφωνίες που υπογράφεις. (Υποχρεωτικό βήμα)",
    "save_continue": "Αποθήκευση & συνέχεια",
    "phone_text": "Προαιρετικό: επαλήθευσε τον αριθμό σου με SMS για το σήμα «✓ Επαληθευμένος» και περισσότερη εμπιστοσύνη.",
    "verify_now": "Επαλήθευση τώρα"
  },
  "wizard": {
    "agreement_step1_title": "Στοιχεία συμφωνίας",
    "agreement_step1_subtitle": "Ποιος είναι η άλλη πλευρά;",
    "agreement_step2_title": "Ποσό & Όροι",
    "agreement_step2_subtitle": "Ορίσε τους οικονομικούς όρους.",
    "agreement_step3_title": "Επισκόπηση",
    "agreement_step3_subtitle": "Έλεγξε τα πάντα πριν στείλεις.",
    "offer_step1_title": "Τίτλος & Αποδέκτης",
    "offer_step1_subtitle": "Για ποιον είναι αυτή η προσφορά;",
    "offer_step2_title": "Κόστος & Περιγραφή",
    "offer_step2_subtitle": "Ορίσε την υπηρεσία σου.",
    "offer_step3_title": "Επισκόπηση",
    "offer_step3_subtitle": "Έλεγξε πριν στείλεις."
  },
  "adminScreen": {
    "noAccess": "Δεν έχεις πρόσβαση σε αυτή τη σελίδα.",
    "noAccessScreen": "Δεν έχεις πρόσβαση σε αυτή την οθόνη.",
    "loadFailed": "Αποτυχία φόρτωσης.",
    "docOpenFailed": "Δεν άνοιξε το έγγραφο.",
    "photoOpenFailed": "Δεν άνοιξε η φωτογραφία.",
    "actionFailed": "Η ενέργεια απέτυχε.",
    "verificationsTitle": "Επαληθεύσεις",
    "manageAdminsLink": "🛡️ Διαχείριση Admins →",
    "feedbackLink": "💬 Bug reports →",
    "feedbackTitle": "Bug reports / Feedback",
    "feedbackFilter_new": "Νέα",
    "feedbackFilter_read": "Διαβασμένα",
    "feedbackFilter_all": "Όλα",
    "feedbackEmpty": "Δεν υπάρχουν μηνύματα.",
    "feedbackUnknownUser": "Άγνωστος χρήστης",
    "feedbackHasScreenshot": "Έχει screenshot",
    "feedbackMarkDone": "✓ Υλοποιήθηκε",
    "feedbackDeleteTitle": "Διαγραφή",
    "feedbackDeleteBody": "Οριστική διαγραφή αυτού του μηνύματος; Η ενέργεια δεν αναστρέφεται.",
    "feedbackActionFailed": "Η ενέργεια απέτυχε.",
    "chatReportsLink": "🚩 Αναφορές chat →",
    "chatReportsTitle": "Αναφορές Chat",
    "chatReportsFilter_pending": "Εκκρεμείς",
    "chatReportsFilter_reviewed": "Εξετασμένες",
    "chatReportsEmpty": "Δεν υπάρχουν αναφορές.",
    "chatReportsUsersLine": "{{reporter}} ανέφερε τον/την {{reported}}",
    "chatReportsReportedMessage": "Αναφερόμενο μήνυμα",
    "chatReportsMessageDeleted": "(το μήνυμα δεν υπάρχει πια)",
    "chatReportsViewAgreement": "Άνοιγμα συμφωνίας",
    "chatReportsMarkReviewed": "✓ Εξετάστηκε",
    "chatReportsActionFailed": "Η ενέργεια απέτυχε.",
    "tabIdentity": "🎖️ Ταυτότητας",
    "tabPhone": "📱 Κινητού",
    "tabHistory": "🕓 Ιστορικό",
    "emptyIdentity": "Δεν υπάρχουν εκκρεμή αιτήματα επαλήθευσης ταυτότητας. 🎉",
    "emptyPhone": "Δεν υπάρχουν εκκρεμή αιτήματα επαλήθευσης κινητού. 🎉",
    "emptyHistory": "Δεν υπάρχει ιστορικό επαληθεύσεων ακόμα.",
    "auditAction_approved": "✅ Εγκρίθηκε",
    "auditAction_rejected": "❌ Απορρίφθηκε",
    "auditAction_manual_grant": "🔧 Χειροκίνητη χορήγηση",
    "auditAction_manual_revoke": "🔧 Χειροκίνητη ανάκληση",
    "auditBy": "Από: {{name}}",
    "auditBySelf": "Ο ίδιος ο χρήστης (self-service)",
    "defaultUser": "Χρήστης",
    "nameFieldLabel": "Όνομα (όπως γράφει στην ταυτότητα)",
    "nameFieldPlaceholder": "Ονοματεπώνυμο",
    "nameFieldHint": "Διόρθωσε αν διαφέρει από τη φωτογραφία της ταυτότητας — θα κλειδώσει στο προφίλ του χρήστη κατά την έγκριση.",
    "photoFront": "Μπροστά",
    "photoBack": "Πίσω",
    "photoSelfie": "Selfie",
    "reviewed": "Ελέγχθηκε ✓",
    "reject": "Απόρριψη ✗",
    "approve": "Έγκριση",
    "rejectSimple": "Απόρριψη",
    "viewDocument": "Προβολή εγγράφου",
    "docTypePassport": "Διαβατήριο",
    "docTypeId": "Ταυτότητα",
    "rejectModalTitle": "Λόγος Απόρριψης",
    "rejectModalSubtitle": "Επίλεξε έναν ή περισσότερους λόγους (προαιρετικό):",
    "tagBlurry": "Θολή φωτογραφία",
    "tagDark": "Σκοτεινή φωτογραφία",
    "tagInvalidDoc": "Μη αποδεκτό έγγραφο",
    "manageAdminsTitle": "Διαχείριση Admins",
    "manageAdminsSubtitle": "Εισήγαγε το User ID ενός χρήστη για να του δώσεις ή να του αφαιρέσεις πρόσβαση στο admin panel.",
    "userIdLabel": "User ID",
    "userIdPlaceholder": "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
    "grantAdmin": "Δώσε Admin",
    "revokeAdmin": "Αφαίρεσε Admin",
    "confirmGrantTitle": "Να γίνει admin",
    "confirmRevokeTitle": "Να αφαιρεθεί το admin",
    "confirmUserIdBody": "User ID:\n{{id}}",
    "setAdminFailed": "Αποτυχία",
    "adminGranted": "✓ Admin δόθηκε",
    "adminRevoked": "✓ Admin αφαιρέθηκε",
    "tipTitle": "Πού βρίσκω το User ID;",
    "tipBody": "Στο Supabase Dashboard → Authentication → Users → κλικ στο χρήστη → το UUID στην κορυφή.\n\nΉ στην εφαρμογή, στις ρυθμίσεις του χρήστη αν έχεις πρόσβαση στο προφίλ του."
  },

  "checkin": {
    "action": "Δήλωσε παρουσία",
    "doneToday": "Δήλωσες παρουσία σήμερα",
    "rewarded": "🎉 Κέρδισες 1 μελάνι!",
    "hint": "Κάθε 7 συνεχόμενες μέρες κερδίζεις 1 μελάνι.",
    "progressDone_zero": "Το σερί συνεχίζεται — 7 μέρες ακόμα για το επόμενο μελάνι.",
    "progressDone_one": "Μία μέρα ακόμα για 1 μελάνι.",
    "progressDone_other": "{{count}} μέρες ακόμα για 1 μελάνι."
  }
}
